<template>
  <v-container
    ref="basewindow"
    fluid
    class="d-flex flex-column pa-0 ma-0"
    :class="{ resizing: isResizing }"
    :style="`height: 100vh; overflow: hidden;`"
  >
    <transition name="fade">
      <VoxdubAnimation v-if="videoLoading" />
    </transition>

    <div class="menu-container">
      <MenuBar
        @resetSubtitles="resetSubtitles"
        @saveProject="saveProject"
        @exportToJson="exportToJson"
        @exportToSrt="exportToSrt"
        @exportToAss="exportToAss"
        @exportAudiosForBwf="exportAudiosForBwf"
        @configureBwfMetadata="configureBwfMetadata"
        @exportProject="exportProject"
        @importProject="importProject"
        @importDETX="importDETX"
        @exportDETX="exportDETX"
        @exportCroisille="exportCroisille"
        @openExportWindow="openExportWindow"
        @detectSceneChange="detectSceneChange"
        @detectSubtitles="detectSubtitles"
        @audioDenoiser="audioDenoiser"
        @audioRemoveVoice="audioRemoveVoice"
        @generateSubtitles="generateSubtitles"
        @generateAudio="generateAudio"
        @playVideo="playVideo"
        @incrementSpeedRate="incrementSpeedRate"
        @getAudioData="getAudioData"
        @openFriendInvite="inviteFriendModal = true"
        @openTaskPopup="taskPopup = true"
        @importSubtitles="importSubtitles"
        @openPopupPlan="openPopupPlan = $event"
        @openSettings="openSettings = $event"
        :lastSave="lastSave"
        :cinemaMode="cinemaMode"
        @cinemaModeEvent="cinemaMode = $event"
        @toggleVideoSubtitles="
          settings.showVideoSubtitles = !settings.showVideoSubtitles
        "
        @openHelpWindow="openHelpWindow = $event"
        :subtitles="subtitles"
        :video="$refs.video"
        :hasProcessedAudio="hasProcessedAudio"
        @restoreOriginalAudio="restoreOriginalAudio"
        @replaceVideoNoVocal="replaceVideoNoVocal"
        :settings="settings"
      />

      <!-- Barre secondaire avec tabs et infos -->
      <div
        class="secondary-bar d-flex align-center justify-space-between px-2 py-1"
      >
        <!-- Label section -->
        <div class="d-flex align-center flex-grow-0 flex-shrink-0" style="width: auto; flex: 0 0 auto">
          <v-icon small color="primary" class="mr-1">mdi-music-box</v-icon>
          <span class="text-caption font-weight-bold" style="color: #ccc;">Rythmo</span>
        </div>

        <!-- Zone du titre du projet au centre -->
        <div class="project-title-zone mx-3" style="min-width: 0">
          <v-icon x-small color="white" class="mr-1">mdi-movie-edit</v-icon>
          <span class="project-title-text">{{
            title || "Projet sans titre"
          }}</span>
        </div>

        <!-- Statut de sauvegarde à droite -->
        <div
          class="save-status-zone d-flex align-center justify-end flex-grow-0 flex-shrink-0"
          style="min-width: 220px"
          v-if="!$vuetify.breakpoint.mobile"
        >
          <v-chip small outlined class="mr-2 px-3" :color="autoSaveStatusColor">
            <v-icon x-small left>mdi-content-save-auto</v-icon>
            {{ autoSaveStatus }}
          </v-chip>
          <small class="save-time-text mr-1">{{
            $moment(lastSave * 1000).fromNow()
          }}</small>
          <template v-if="!saveInProgress">
            <v-btn
              @click="saveProject()"
              icon
              small
              :color="
                $moment().diff(lastSave * 1000, 'minutes') > 5 ? 'red' : 'green'
              "
            >
              <v-icon small>mdi-cloud-sync</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-progress-circular
              v-if="saveInProgress"
              :value="uploadProgress"
              color="primary"
              size="20"
            />
          </template>
        </div>
      </div>
    </div>
    <v-dialog
      v-model="error"
      top
      transition="dialog-bottom-transition"
      max-width="600px"
      persistent
      width="100%"
      :retain-focus="false"
    >
      <v-card dark>
        <v-card-title> </v-card-title>
        <v-card-text class="text-center">
          <span class="headline primary--text">{{ $t("error.title") }}</span>
          <h3>{{ $t("error.error_message") }}</h3>
          <!-- discord button -->
          <v-btn
            color="primary"
            class="mt-12"
            @click="window.open('https://discord.gg/RrmKMBsYFy', '_blank')"
          >
            {{ $t("help.join_us_on_discord") }} </v-btn
          ><br />
          Details<br />
          <code>
            {{ errorMessage }}
          </code>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="error = false">{{
            $t("button.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="fullscreen">
      <div class="containerapp">
        <div
          style="overflow: hidden"
          xs12
          :md6="!cinemaMode"
          class="pa-0 ma-0"
          :class="cinemaMode ? 'center' : 'column1'"
          :style="
            cinemaMode
              ? ''
              : `width: ${videoSectionWidth}%; transition: width 0.2s ease;`
          "
        >
          <div class="videocontainer">
            <!-- Video Editor -->
            <div id="videoCanvas" class="pa-0 ma-0 videocanvas">
              <v-row v-show="false">
                <v-col>
                  <label>
                    Importer une video
                    <input
                      type="file"
                      ref="inputVideo"
                      @change="loadVideoBlob($event)"
                    />
                  </label>
                </v-col>
              </v-row>
              <div
                class="pa-0 text-center ma-0 art-video-player"
                style="width: 100%; position: relative"
              >
                <video
                  class="art-video"
                  :muted="isRecording"
                  style="
                    box-shadow: #e8497c24 1px 1px 32px;
                    width: 100%;
                    margin: auto;
                  "
                  crossorigin="anonymous"
                  ref="video"
                  webkit-playsinline
                  playsinline
                  controls
                >
                  <source :src="videoSource" type="video/mp4" />
                </video>

                <!-- Overlay des sous-titres sur la vidéo -->
                <div
                  class="video-subtitles-overlay"
                  v-if="
                    settings.showVideoSubtitles &&
                    displayCurrentSubtitle &&
                    displayCurrentSubtitle.length
                  "
                >
                  <div
                    v-for="subtitle in displayCurrentSubtitle"
                    :key="`video-subtitle-${subtitle.id}`"
                    class="video-subtitle-text"
                    :style="getVideoSubtitleStyle(subtitle)"
                  >
                    <span
                      class="subtitle-character"
                      v-if="subtitle.characterShow && subtitle.character"
                      :style="{
                        color:
                          settings.charactersColors[subtitle.character] ||
                          '#FCB6CD',
                      }"
                    >
                      {{ subtitle.character }}
                    </span>
                    <span
                      class="subtitle-content"
                      :class="{
                        'subtitle-underline': subtitle.underline,
                        'subtitle-dashed': subtitle.dashed,
                      }"
                      :style="{
                        fontFamily: settings.fontFamily,
                        color: settings.fontColor || '#ffffff',
                      }"
                    >
                      {{ subtitle.text }}
                    </span>
                  </div>
                </div>

                <!-- Display filigrane -->
              </div>
            </div>
          </div>
        </div>

        <!-- Splitter vertical entre vidéo et sous-titres -->
        <ResizableSplitter
          v-if="!cinemaMode"
          direction="vertical"
          :min-size="innerWidth * 0.2"
          :max-size="innerWidth * 0.8"
          @resize="handleVerticalResize"
          @resize-start="onResizeStart"
          @resize-end="onResizeEnd"
        />

        <div
          v-show="!cinemaMode"
          xs12
          md6
          style="overflow: scroll"
          class="column2"
          :style="`width: ${subtitleSectionWidth}%; transition: width 0.2s ease;`"
        >
          <!-- Subtitle Editor -->
          <v-col class="pa-0 ma-0">
            <v-col class="mx-0 my-0 px-0 py-0">
              <v-col cols="12" v-show="false">
                <label>
                  {{ $t("options.load_subtitles") }}
                  <input
                    type="file"
                    ref="inputSousTitre"
                    @change="importFromJson($event)"
                  />
                </label>
              </v-col>
              <!-- order subtitle by last id -->
              <v-col
                cols="12"
                class="pa-0 mx-0 mt-0"
                :style="{
                  position: 'relative',
                }"
              >
                <!-- Panneau moderne du titre et des langues -->
                <div class="project-header-panel">
                  <!-- Section principale avec titre et langue -->
                  <div class="header-main-section">
                    <!-- Titre du projet -->
                    <div class="title-section">
                      <v-icon color="primary" class="title-icon mr-3"
                        >mdi-movie-edit</v-icon
                      >
                      <v-text-field
                        v-model="title"
                        hide-details
                        class="project-title-field"
                        placeholder="Nom du projet..."
                        outlined
                        dense
                        dark
                      >
                        <template v-slot:prepend-inner>
                          <v-icon color="primary" size="18">mdi-pencil</v-icon>
                        </template>
                      </v-text-field>
                    </div>

                    <!-- Sélection de langue -->
                    <div class="language-section">
                      <v-icon color="info" class="language-icon mr-2"
                        >mdi-translate</v-icon
                      >
                      <v-select
                        class="language-select"
                        hide-details
                        :items="getAvailableLanguage"
                        v-model="settings.language"
                        label="Langue"
                        outlined
                        dense
                        @change="changeSubtitlesLanguage"
                        dark
                      >
                        <template v-slot:prepend-inner>
                          <v-icon color="info" size="16">mdi-web</v-icon>
                        </template>
                        <template v-slot:append>
                          <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                small
                                icon
                                color="info"
                                v-on="on"
                                @click.stop
                                class="add-language-btn"
                                :title="$t('button.add_language')"
                              >
                                <v-icon small>mdi-plus-circle</v-icon>
                              </v-btn>
                            </template>
                            <v-list class="language-menu">
                              <v-list-item-group>
                                <v-list-item
                                  v-for="lang in [
                                    'fr',
                                    'en',
                                    'de',
                                    'ja',
                                    'it',
                                    'es',
                                  ]"
                                  @click="
                                    $auth?.user?.role != 'pro' &&
                                    $auth?.user?.role != 'basic'
                                      ? (openPopupPlan = true)
                                      : createLanguage(lang)
                                  "
                                  :key="`lang${lang}`"
                                  class="language-item"
                                >
                                  <v-list-item-avatar size="32">
                                    <v-icon color="info">mdi-flag</v-icon>
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                    <v-list-item-title class="language-name">{{
                                      lang.toUpperCase()
                                    }}</v-list-item-title>
                                  </v-list-item-content>
                                  <v-list-item-action>
                                    <v-icon color="success" size="16"
                                      >mdi-plus</v-icon
                                    >
                                  </v-list-item-action>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-menu>
                        </template>
                      </v-select>
                    </div>
                  </div>

                  <!-- Section des actions -->
                  <div class="header-actions-section">
                    <!-- Groupe d'actions principales -->
                    <div class="action-group primary-actions">
                      <!-- Ajouter un sous-titre -->
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="action-btn primary-btn"
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            outlined
                            small
                          >
                            <v-icon left size="16">mdi-text-box-plus</v-icon>
                            <span class="btn-text">Ajouter</span>
                          </v-btn>
                        </template>
                        <v-list class="subtitle-menu">
                          <v-list-item-group>
                            <v-list-item
                              v-for="(line, index) in [1, 2, 3, 4]"
                              :key="`line-${line}`"
                              @click="
                                createSubtitle('Text Here', index);
                                selectedSubtitle =
                                  subtitles[subtitles.length - 1];
                                scrollTo(subtitles[subtitles.length - 1].id);
                              "
                              class="subtitle-line-item"
                            >
                              <v-list-item-avatar size="32">
                                <v-avatar color="primary" size="28">
                                  <span class="white--text font-weight-bold">{{
                                    line
                                  }}</span>
                                </v-avatar>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title
                                  >Ligne {{ line }}</v-list-item-title
                                >
                                <v-list-item-subtitle
                                  >Ajouter un sous-titre sur la ligne
                                  {{ line }}</v-list-item-subtitle
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-menu>

                      <!-- Édition en lot -->
                      <v-btn
                        class="action-btn secondary-btn"
                        :disabled="!selectedSubtitles.length"
                        @click="bulkEdit = !bulkEdit"
                        color="warning"
                        outlined
                        small
                      >
                        <v-icon left size="16">mdi-pencil-box-multiple</v-icon>
                        <span class="btn-text">Éditer</span>
                        <v-badge
                          v-if="selectedSubtitles.length"
                          :content="selectedSubtitles.length"
                          color="warning"
                          overlap
                          class="ml-1"
                        ></v-badge>
                      </v-btn>
                    </div>

                    <!-- Indicateur de statut -->
                    <div class="status-indicators">
                      <v-chip
                        small
                        color="success"
                        outlined
                        class="status-chip"
                      >
                        <v-icon left size="14">mdi-check-circle</v-icon>
                        {{ subtitles.length }} sous-titres
                      </v-chip>

                      <!-- Indicateur de complétion du doublage -->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            small
                            :color="
                              dubbingCompletionPercentage === 100
                                ? 'success'
                                : dubbingCompletionPercentage >= 50
                                ? 'warning'
                                : 'error'
                            "
                            outlined
                            class="status-chip"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon left size="14">mdi-microphone</v-icon>
                            {{ dubbingCompletionPercentage }}% doublé
                          </v-chip>
                        </template>
                        <span
                          >{{ getSubtitlesWithAudioCount() }}/{{
                            subtitles.length
                          }}
                          sous-titres ont un doublage audio</span
                        >
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col
                ref="scrollableSub"
                :style="`width:${subtitleWidth}px;`"
                class="subtitle mx-0 pb-16 my-0 px-0"
              >
                <draggable
                  v-model="subtitles"
                  group="people"
                  @start="drag = true"
                  @end="drag = false"
                  handle=".drag-handle-compact"
                >
                  <v-col
                    v-for="(subtitle, b) in subtitlesOrdered"
                    :key="`scrollsub${b}`"
                    no-action
                    class="pa-0 px-2 ma-0"
                  >
                    <SubtitleEditorComponent
                      @update:subtitle="subtitle = $event"
                      @seekToTime="handleSeekToTime($event)"
                      @update:selectedSubtitles="selectedSubtitles = $event"
                      :selectedSubtitles="selectedSubtitles"
                      @deleteSubtitle="deleteSubtitle($event)"
                      @update:speakingRateChange="speakingRateChange($event)"
                      @deleteAudioSource="deleteAudioSource($event)"
                      @update:selectedCharacter="selectedCharacter = $event"
                      @update:selectedSubtitle="selectedSubtitle = $event"
                      @openRecordingStudio="openRecordingStudioForSubtitle"
                      :subtitle="subtitle"
                      :characters="getArrayOfAvailableCharacter"
                      :index="b"
                      :selectedSubtitle="selectedSubtitle"
                      :settings="settings"
                      :sources="sources"
                      :isRecording="isRecording"
                      :selectedCharacter="selectedCharacter"
                    />
                  </v-col>
                </draggable>
                <v-col v-if="!subtitlesOrdered.length">
                  <v-card elevation="0">
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" class="text-center">
                          <v-btn
                            fab
                            elevation="0"
                            color="primary"
                            v-if="false"
                            @click="
                              createSubtitle('Text Here');
                              selectedSubtitle =
                                subtitles[subtitles.length - 1];
                              scrollTo(subtitles[subtitles.length - 1].id);
                            "
                          >
                            <v-icon x-large color="white">
                              mdi-text-box-plus
                            </v-icon>
                          </v-btn>
                          <!-- Ajouter un sous-titre avec dropdown menu -->
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                title="Ajouter un sous-titre"
                                fab
                                elevation="0"
                                v-bind="attrs"
                                class="ml-6"
                                v-on="on"
                                color="primary"
                              >
                                <v-icon x-large> mdi-text-box-plus </v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item
                                @click="
                                  createSubtitle('Text Here', 0);
                                  selectedSubtitle =
                                    subtitles[subtitles.length - 1];
                                  scrollTo(subtitles[subtitles.length - 1].id);
                                "
                              >
                                <v-list-item-title> Ligne 1 </v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                @click="
                                  createSubtitle('Text Here', 1);
                                  selectedSubtitle =
                                    subtitles[subtitles.length - 1];
                                  scrollTo(subtitles[subtitles.length - 1].id);
                                "
                              >
                                <v-list-item-title> Ligne 2 </v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                @click="
                                  createSubtitle('Text Here', 2);
                                  selectedSubtitle =
                                    subtitles[subtitles.length - 1];
                                  scrollTo(subtitles[subtitles.length - 1].id);
                                "
                              >
                                <v-list-item-title> Ligne 3 </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                          <h3 class="primary--text">
                            {{ $t("subtitle_editor.no_subtitle") }}
                          </h3>
                          <p>
                            {{ $t("subtitle_editor.no_subtitle_description") }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col class="mb-16"></v-col>
              </v-col>
              <v-col
                cols="12"
                style="max-height: 20vh; overflow: scroll"
                v-if="false"
              >
                <v-list dense>
                  <v-list-group
                    v-for="(character, b) in getArrayOfAvailableCharacter"
                    :key="`availabchara${b}`"
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ character }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-col cols="12">
                      <v-btn
                        fab
                        color="red"
                        small
                        @click="recordAudio(character)"
                      >
                        <v-icon small>
                          <!-- audio record -->
                          mdi-microphone
                        </v-icon>
                      </v-btn>
                      <br />
                      <template
                        v-if="
                          sources.find(
                            (map) => map.character == character && !map.subtitle
                          )?.src
                        "
                      >
                        <v-card class="secondary" elevation="0">
                          <v-card-text>
                            <v-subheader class="mt-0 pt-0">
                              {{ $t("title.audio") }}
                            </v-subheader>
                            <v-btn
                              color="red"
                              icon
                              style="
                                position: absolute;
                                right: 2em;
                                top: 2em;
                                cursor: pointer;
                                z-index: 100000;
                              "
                              @click="
                                deleteAudioSource(
                                  null,
                                  sources.find(
                                    (map) =>
                                      map.character == character &&
                                      !map.subtitle
                                  )?.src
                                )
                              "
                            >
                              <v-icon style="cursor: pointer" small
                                >mdi-delete</v-icon
                              >
                            </v-btn>
                            <!-- audio player -->
                            <wave-surfer
                              :height="50"
                              :interact="false"
                              :source="
                                sources.find(
                                  (map) =>
                                    map.character == character && !map.subtitle
                                )?.src
                              "
                            />
                            <audio
                              preload="auto"
                              :muted="isRecording"
                              class="mt-12"
                              :id="`audio${character}`"
                              :ref="`audio${character}`"
                              :src="
                                sources.find(
                                  (map) =>
                                    map.character == character && !map.subtitle
                                )?.src
                              "
                              crossorigin="anonymous"
                              controls
                            ></audio>
                          </v-card-text>
                        </v-card>
                      </template>
                    </v-col>
                  </v-list-group>
                </v-list>
              </v-col>
            </v-col>
          </v-col>
        </div>
      </div>

      <!-- Splitter horizontal pour la section rythmo -->
      <ResizableSplitter
        direction="horizontal"
        :min-size="200"
        :max-size="innerHeight - 200"
        @resize="handleHorizontalResize"
        @resize-start="onResizeStart"
        @resize-end="onResizeEnd"
      />

      <!-- Audio Toggle -->
      <div
        style="flex: 0 0 20px; height: 20px; background: #111; display: flex; align-items: center; justify-content: center; cursor: pointer; border-top: 1px solid #333;"
        @click="toggleAudioTracks"
      >
        <span style="font-size: 10px; color: #888; user-select: none;">
          Audio
          <span :style="{ display: 'inline-block', transform: showAudioTracks ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.2s' }">▼</span>
        </span>
      </div>
      <!-- Audio Tracks (inline) -->
      <div
        v-show="showAudioTracks"
        style="flex: 0 0 40px; height: 40px; background: #1a1a1a; border-top: 2px solid #e74970; overflow: hidden; white-space: nowrap;"
        ref="audioTracksScroll"
      >
        <div :style="`width: ${innerWidth / 2}px; display: inline-block; height: 100%;`"></div>
        <div :style="`width: ${videoDuration * 25 * settings.fontSize}px; display: inline-block; position: relative; height: 100%;`">
          <!-- Recording indicator bar -->
          <div
            v-if="isRecording"
            :style="{
              position: 'absolute',
              left: (startRecording * 25 * settings.fontSize) + 'px',
              width: (recordingTime * 25 * settings.fontSize) + 'px',
              height: '36px',
              top: '2px',
              backgroundColor: 'rgba(231, 73, 112, 0.4)',
              borderRadius: '3px',
              border: '1px solid #e74970',
              transition: 'width 0.1s linear',
            }"
          >
            <span style="font-size: 9px; color: #e74970; padding: 2px 4px; font-weight: bold;">REC</span>
          </div>
          <div
            v-for="source in audioSources"
            :key="'at-' + source.id"
            class="audio-track-segment"
            :style="{
              position: 'absolute',
              left: (source.start * 25 * settings.fontSize) + 'px',
              width: ((source.end - source.start) * 25 * settings.fontSize) + 'px',
              height: '36px',
              top: '2px',
              backgroundColor: hexToRgba(settings.charactersColors[source.character] || '#6449D1', 0.6),
              borderRadius: '3px',
              border: '1px solid ' + (settings.charactersColors[source.character] || '#6449D1'),
              fontSize: '9px',
              color: 'rgba(255,255,255,0.7)',
              padding: '2px 4px',
              overflow: 'hidden',
              cursor: 'grab',
            }"
            @mousedown="startAudioSegmentDrag($event, source)"
          >
            <audio
              :ref="`audioPlayer${source.character}${source.id}`"
              :src="source.src"
              preload="auto"
              style="display: none;"
            ></audio>
            <wave-surfer
              :ref="`audioTrackWs_${source.id}`"
              :source="source.src"
              :height="32"
              :interact="false"
              :muted="true"
              :waveColor="settings.charactersColors[source.character] || '#aaa'"
              :progressColor="'rgba(255,255,255,0.3)'"
              :cursorColor="'transparent'"
              :cursorWidth="0"
              :options="{ waveColor: settings.charactersColors[source.character] || '#aaa' }"
              :style="{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }"
            />
            <v-btn
              icon
              x-small
              class="audio-segment-delete"
              @click.stop="deleteAudioSource(source.id)"
              title="Supprimer"
              :style="{ position: 'absolute', top: '2px', right: '2px', zIndex: 10, opacity: 0, transition: 'opacity 0.15s' }"
            >
              <v-icon x-small color="white">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <div
        class="rowbottom"
        ref="rowbottom"
        :style="`height: ${rythmoSectionHeight}vh; transition: height 0.2s ease; --rythmo-height: ${rythmoSectionHeight}vh;`"
      >
        <div class="column3" lg12>
          <v-col class="pa-0 ma-0">
            <v-toolbar
              ref="rythmoToolbar"
              v-if="!cinemaMode"
              dense
              style="max-width: 100vw; overflow-x: scroll; overflow-y: hidden"
              class="rythmo-toolbar"
            >
              <!-- Section Enregistrement Audio Simple -->
              <DubbingRecorder
                :characters="getArrayOfAvailableCharacter"
                :charactersColors="settings.charactersColors"
                :video="$refs.video"
                :subtitles="subtitles"
                :initialCharacter="selectedCharacter"
                @recording-start="onDubbingRecordingStart"
                @recording-tick="recordingTime = $event"
                @recording-done="onDubbingRecordingDone"
                @error="onDubbingRecordingError"
                ref="dubbingRecorder"
              />
              <v-divider vertical class="mx-2"></v-divider>

              <!-- add subtitle -->
              <v-btn
                fab
                x-small
                elevation="0"
                color="primary"
                v-if="false"
                @click="
                  createSubtitle('Text Here');
                  selectedSubtitle = subtitles[subtitles.length - 1];
                  scrollTo(subtitles[subtitles.length - 1].id);
                "
              >
                <v-icon small>mdi-text-box-plus</v-icon>
              </v-btn>
              <!-- Ajouter un sous-titre avec dropdown menu -->
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    x-small
                    elevation="0"
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    title="Ajouter un sous-titre"
                  >
                    <v-icon> mdi-text-box-plus </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="line in [1, 2, 3, 4]"
                    :key="`line-${line}`"
                    @click="
                      createSubtitle('Text Here', line - 1);
                      selectedSubtitle = subtitles[subtitles.length - 1];
                      scrollTo(subtitles[subtitles.length - 1].id);
                    "
                  >
                    <v-list-item-title> Ligne {{ line }} </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- videoSpeedRate -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab x-small elevation="0" @click="incrementSpeedRate()" v-bind="attrs" v-on="on">
                    x{{ videoSpeedRate }}
                  </v-btn>
                </template>
                <span>Vitesse de lecture</span>
              </v-tooltip>
              <!-- Playback -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    x-small
                    elevation="0"
                    v-if="videoPaused"
                    @click="playVideo()"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-play</v-icon>
                  </v-btn>
                  <v-btn v-else fab x-small elevation="0" @click="playVideo()" v-bind="attrs" v-on="on">
                    <v-icon>mdi-pause</v-icon>
                  </v-btn>
                </template>
                <span>{{ videoPaused ? 'Lecture' : 'Pause' }}</span>
              </v-tooltip>
              <!-- go to start -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    x-small
                    elevation="0"
                    @click="$refs.video.currentTime = 0"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-skip-backward</v-icon>
                  </v-btn>
                </template>
                <span>Retour au debut</span>
              </v-tooltip>
              <!-- Forward -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    x-small
                    elevation="0"
                    @click="$refs.video.currentTime -= 1 / base_rate"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-skip-previous</v-icon>
                  </v-btn>
                </template>
                <span>Image precedente</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    x-small
                    elevation="0"
                    @click="$refs.video.currentTime += 1 / base_rate"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-skip-next</v-icon>
                  </v-btn>
                </template>
                <span>Image suivante</span>
              </v-tooltip>
              <!-- go to end -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    x-small
                    elevation="0"
                    @click="$refs.video.currentTime = $refs.video.duration"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-skip-forward</v-icon>
                  </v-btn>
                </template>
                <span>Aller a la fin</span>
              </v-tooltip>
              <!-- /Playback -->
              <!-- editing subtitles -->
              <v-btn
                v-if="false"
                fab
                x-small
                elevation="0"
                @click="cutMode = !cutMode"
                :color="cutMode ? 'primary' : ''"
              >
                <v-icon>mdi-content-cut</v-icon>
              </v-btn>
              <!-- editing subtitles -->
              <v-btn
                class="ml-3"
                fab
                x-small
                elevation="0"
                @click="addItem('↑')"
                v-if="false"
              >
                ↑
              </v-btn>
              <v-btn
                fab
                x-small
                elevation="0"
                @click="addItem('↓')"
                v-if="false"
              >
                ↓
              </v-btn>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab x-small elevation="0" @click="addLoop()" v-bind="attrs" v-on="on">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 74.263 89"
                    >
                      <path
                        id="Tracé_9"
                        data-name="Tracé 9"
                        d="M0,0,58,58"
                        transform="translate(8.132 13)"
                        fill="none"
                        stroke="red"
                        stroke-width="5"
                      />
                      <line
                        id="Ligne_30"
                        data-name="Ligne 30"
                        y1="58"
                        x2="58"
                        transform="translate(8.132 13)"
                        fill="none"
                        stroke="red"
                        stroke-width="5"
                      />
                      <line
                        id="Ligne_31"
                        data-name="Ligne 31"
                        y2="89"
                        transform="translate(37.132)"
                        fill="none"
                        stroke="red"
                        stroke-width="5"
                      />
                    </svg>
                  </v-btn>
                </template>
                <span>Ajouter une boucle</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab x-small elevation="0" @click="addEndDialog()" v-bind="attrs" v-on="on">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20.235"
                      height="20"
                      viewBox="0 0 65.235 109"
                    >
                      <rect
                        id="Rectangle_55"
                        data-name="Rectangle 55"
                        width="10"
                        height="104"
                        transform="translate(35.235 5)"
                        fill="#c43636"
                      />
                      <line
                        id="Ligne_19"
                        data-name="Ligne 19"
                        y1="66.494"
                        x2="66.948"
                        transform="translate(1.762 14)"
                        fill="none"
                        stroke="#c43636"
                        stroke-width="10"
                      />
                      <line
                        id="Ligne_73"
                        data-name="Ligne 73"
                        y1="67"
                        x2="66.774"
                        transform="translate(12.735 33.5)"
                        fill="none"
                        stroke="#c43636"
                        stroke-width="10"
                      />
                    </svg>
                  </v-btn>
                </template>
                <span>Fin de dialogue</span>
              </v-tooltip>
              <v-btn fab x-small elevation="0" @click="addSvg(1)" v-if="false">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 44.679 37.844"
                >
                  <g
                    id="Composant_12_1"
                    data-name="Composant 12 – 1"
                    transform="translate(1.36 2)"
                  >
                    <g
                      id="Groupe_20"
                      data-name="Groupe 20"
                      transform="translate(0 7.685)"
                    >
                      <line
                        id="Ligne_36"
                        data-name="Ligne 36"
                        x2="41.966"
                        y2="25.449"
                        transform="translate(0 1)"
                        fill="none"
                        stroke="#fff"
                        stroke-width="4"
                      />
                      <line
                        id="Ligne_37"
                        data-name="Ligne 37"
                        y1="26.449"
                        x2="41.966"
                        transform="translate(0 0)"
                        fill="none"
                        stroke="#fff"
                        stroke-width="4"
                      />
                    </g>
                    <path
                      id="Tracé_11"
                      data-name="Tracé 11"
                      d="M0-8.452s10.438-9.686,20.93-9.686S41.966-8.452,41.966-8.452"
                      transform="translate(0 18.138)"
                      fill="none"
                      stroke="#fff"
                      stroke-width="4"
                    />
                  </g>
                </svg>
              </v-btn>
              <v-btn fab x-small elevation="0" @click="addSvg(2)" v-if="false">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  viewBox="0 0 42.934 10.068"
                >
                  <path
                    id="Tracé_12"
                    data-name="Tracé 12"
                    d="M0-11.769s10.153-6.369,20.357-6.369,20.46,6.369,20.46,6.369"
                    transform="translate(1.063 20.138)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="4"
                  />
                </svg>
              </v-btn>
              <v-btn fab x-small elevation="0" @click="addSvg(3)" v-if="false">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  viewBox="0 0 44.729 13.386"
                >
                  <path
                    id="Tracé_13"
                    data-name="Tracé 13"
                    d="M0,0S10.473,9.932,20.968,9.932,41.979,0,41.979,0"
                    transform="translate(1.376 1.454)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="4"
                  />
                </svg>
              </v-btn>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab x-small elevation="0" @click="addSceneChange()" v-bind="attrs" v-on="on">
                    |
                  </v-btn>
                </template>
                <span>Changement de scene</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab x-small elevation="0" @click="addNote('«TEXT»')" v-bind="attrs" v-on="on">
                    «»
                  </v-btn>
                </template>
                <span>Ajouter une note</span>
              </v-tooltip>
              <!-- dropdown -->
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small elevation="0" v-bind="attrs" v-on="on" title="Symboles de respiration">
                    RESPIRATIONS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="addItem('↗')">
                    <v-list-item-title> ↗ </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addItem('↘')">
                    <v-list-item-title> ↘ </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="createSubtitle('(H)')">
                    <v-list-item-title> (H) </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="createSubtitle('(HH)')">
                    <v-list-item-title> (HH) </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="createSubtitle('(mH)')">
                    <v-list-item-title> (mH) </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="createSubtitle('(mHH)')">
                    <v-list-item-title> (mHH) </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small elevation="0" v-bind="attrs" v-on="on" title="Reactions sonores">
                    RÉACTIONS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="react in reactions"
                    :key="react"
                    @click="createSubtitle(react)"
                  >
                    <v-list-item-title>
                      {{ react }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab x-small elevation="0" @click="addItem('↦')" v-bind="attrs" v-on="on">
                    <span
                      :style="{
                        fontSize: '2em',
                      }"
                    >
                      ↦
                    </span>
                  </v-btn>
                </template>
                <span>Liaison a droite</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab x-small elevation="0" @click="addItem('↤')" v-bind="attrs" v-on="on">
                    <span
                      :style="{
                        fontSize: '2em',
                      }"
                    >
                      ↤
                    </span>
                  </v-btn>
                </template>
                <span>Liaison a gauche</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    x-small
                    class="mr-3"
                    elevation="0"
                    :color="deleteItems ? 'red' : ''"
                    @click="enableDeleteItems()"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Supprimer des elements</span>
              </v-tooltip>

              <!-- Bouton mode dessin -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    x-small
                    class="mr-3"
                    elevation="0"
                    :color="drawingMode ? 'primary' : ''"
                    @click="toggleDrawingMode()"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small v-if="$auth?.user?.role === 'pro'"
                      >mdi-brush</v-icon
                    >
                    <v-icon x-small v-else>mdi-lock</v-icon>
                  </v-btn>
                </template>
                <span>{{
                  $auth?.user?.role !== 'pro'
                    ? 'Fonctionnalite reservee aux abonnes Pro'
                    : drawingMode
                    ? 'Desactiver le mode dessin'
                    : 'Activer le mode dessin'
                }}</span>
              </v-tooltip>

              <!-- Bouton mode double bande rythmo -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    x-small
                    class="mr-1"
                    elevation="0"
                    :color="doubleBandMode ? 'primary' : ''"
                    @click="toggleDoubleBandMode()"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-view-split-horizontal</v-icon>
                  </v-btn>
                </template>
                <span>{{ doubleBandMode ? 'Desactiver le mode double bande' : 'Activer le mode double bande' }}</span>
              </v-tooltip>

              <!-- Sélecteurs de langues pour le mode double bande -->
              <v-menu
                v-if="doubleBandMode"
                offset-y
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip small v-bind="attrs" v-on="on" class="mr-1" title="Configurer les langues source et cible">
                    <v-icon left x-small>mdi-translate</v-icon>
                    {{ sourceLang }} → {{ targetLang }}
                    <v-icon right x-small>mdi-menu-down</v-icon>
                  </v-chip>
                </template>
                <v-card width="300">
                  <v-card-text>
                    <v-select
                      v-model="sourceLang"
                      :items="
                        getAvailableLanguage.filter(
                          (lang) => lang !== targetLang
                        )
                      "
                      label="Langue source (originale)"
                      dense
                      outlined
                      @change="loadDoubleBandSubtitles"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon small color="primary">mdi-lock-outline</v-icon>
                      </template>
                    </v-select>
                    <v-select
                      v-model="targetLang"
                      :items="
                        getAvailableLanguage.filter(
                          (lang) => lang !== sourceLang
                        )
                      "
                      label="Langue cible (traduction)"
                      dense
                      outlined
                      @change="loadDoubleBandSubtitles"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon small color="success"
                          >mdi-pencil-outline</v-icon
                        >
                      </template>
                    </v-select>

                    <v-divider class="my-3"></v-divider>

                    <div class="text-caption grey--text mb-2">
                      Ratio de division des bandes
                    </div>
                    <v-slider
                      v-model="rythmoSplitRatio"
                      :min="20"
                      :max="80"
                      :step="5"
                      thumb-label
                      prepend-icon="mdi-view-split-horizontal"
                      class="mt-1"
                    >
                      <template v-slot:append>
                        <span class="text-caption"
                          >{{ rythmoSplitRatio }}%</span
                        >
                      </template>
                    </v-slider>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      small
                      color="primary"
                      @click="
                        $event.target
                          .closest('.v-menu')
                          .querySelector('.v-menu__activator')
                          .click()
                      "
                    >
                      Fermer
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>

              <v-spacer />
              <v-btn
                x-small
                outlined
                color="error"
                class="mr-1"
                v-for="(loop, b) in ndd.loops"
                :key="`button${loop.x}`"
                @click="
                  $refs.video.currentTime =
                    loop.x / (base_rate * settings.fontSize)
                "
                :title="`Aller a la boucle ${b + 1}`"
              >
                {{ b + 1 }}
              </v-btn>
              <!-- vertical slider height -->
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small elevation="0" v-bind="attrs" v-on="on" title="Hauteur de la bande rythmo">
                    <v-icon small> mdi-arrow-expand-vertical </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="settings.height = 100">
                    <v-list-item-title> 100px </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="settings.height = 150">
                    <v-list-item-title> 150px </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="settings.height = 200">
                    <v-list-item-title> 200px </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="settings.height = 250">
                    <v-list-item-title> 250px </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="settings.height = 300">
                    <v-list-item-title> 300px </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
            <!-- cursor -->
            <div
              :style="`height:${
                rythmoElementHeight + 15
              }px;background-color:#e74970;border-radius:20px;box-shadow: 1px 1px 4px black;width:${
                5 / zoom
              }px;position:absolute;left:${innerWidth / 2}px;z-index:200;`"
            >
              <div style="position: absolute">
                <!-- timer -->
              </div>
            </div>
            <!-- Rythmo band (dialogues) -->
            <div class="rythmo-band-content">
                <div
                  style="width: 100%; overflow-x: hidden; overflow-y: hidden"
                  :style="`transform:scaleX(${zoom}); width:${
                    100 / zoom
                  }%; height:${
                    rythmoElementHeight + 15
                  }px; transform-origin:left;white-space: nowrap;`"
                  ref="offsetDiv"
                  id="offsetDiv"
                >
                  <!-- Subtitles -->
                  <div
                    :style="`width:${innerWidth / 2}px;display:inline-block;`"
                  >
                    <div
                      class="timeline-cell"
                      id="timeline"
                      @click="scrollToTimeline"
                      :style="`left:${
                        offsetDuration * 100
                      }px;position:relative;width:100%;height:${rythmoElementHeight}px;`"
                    ></div>
                  </div>
                  <div
                    ref="rythmo"
                    :style="{
                      width:
                        videoDuration * base_rate * settings.fontSize + 'px',
                      height: `${rythmoElementHeight}px`,
                      display: 'inline-block',
                    }"
                    v-touch="{
                      start: (e) => swipeMove(e),
                      end: (e) => swipeMove(e),
                      move: (e) => swipeMove(e),
                    }"
                  >
                    <div
                      v-if="videoSource"
                      class="base-audio-wave"
                      :style="`width:${
                        videoDuration * base_rate * settings.fontSize
                      }px;position:absolute;top:${
                        settings.height
                      }px;opacity:1;height:60px;pointer-events: none;`"
                    >
                      <wave-surfer
                        :source="videoSource"
                        :height="60"
                        :interact="false"
                        @click="scrollToTimeline"
                        :muted="true"
                        ref="baseaudio"
                        :options="{ waveColor: '#ffffff' }"
                        :style="{
                          touchAction: 'none',
                          // position: 'relative',
                          // pointerEvent: 'none',
                          backgroundColor: 'rgba(12,12,12,0)',
                          borderRadius: '10px',
                        }"
                        :waveColor="'rgba(100, 100, 100, .3)'"
                        :progressColor="'rgba(100, 100, 100, .3)'"
                        :cursorColor="'rgba(0,0,0,0)'"
                      />
                    </div>

                    <!-- Canvas de dessin -->
                    <DrawingCanvas
                      ref="drawingCanvas"
                      :canvasWidth="
                        videoDuration * base_rate * settings.fontSize
                      "
                      :canvasHeight="rythmoElementHeight"
                      :currentTime="videoTime"
                      :videoDuration="videoDuration"
                      :offsetDuration="offsetDuration"
                      :enabled="drawingMode"
                      :showToolbar="drawingMode"
                      :zIndex="200"
                      :style="{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 200,
                        opacity: 1,
                        visibility: 'visible',
                      }"
                      @drawingStart="onDrawingStart"
                      @drawing="onDrawing"
                      @drawingEnd="onDrawingEnd"
                      @canvasCleared="onCanvasCleared"
                      @canvasExported="onCanvasExported"
                      @canvasReady="onCanvasReady"
                    />

                    <div
                      style="
                        position: absolute;
                        top: -10px;
                        width: 100%;
                        z-index: 100;
                      "
                      v-if="$refs.video && $refs.video.duration"
                    >
                      <!-- each frame tick -->
                      <template v-if="false">
                        <div
                          :style="`width:${settings.fontSize}px; ${
                            i % base_rate == 0 ? 'color:red;' : 'color:grey;'
                          }${
                            i % 2 == 0 ? 'height:15px;' : 'height:20px;'
                          }overflow:hidden;position:absolute;left:${
                            i * settings.fontSize
                          }px;`"
                          style="z-index: 100000; color: white"
                          v-for="(time, i) in Math.round(
                            $refs.video.duration * base_rate
                          )"
                          :key="`timeline${i}`"
                        >
                          |
                        </div>
                      </template>
                    </div>
                    <div
                      style="position: absolute; width: 100%; z-index: 100"
                      v-if="$refs.video && $refs.video.duration"
                    >
                      <!-- timeline tick bar -->
                      <template v-if="false">
                        <div
                          v-for="(time, i) in Math.round(
                            videoDuration * base_rate
                          )"
                          :style="`width:${
                            base_rate * settings.fontSize
                          }px;position:absolute;left:${
                            i * base_rate * settings.fontSize -
                            settings.fontSize * 1.5
                          }px;top:-20px;`"
                          style="
                            display: inline-block;
                            z-index: 100000;
                            color: white;
                          "
                          :key="`timeline${i}`"
                        >
                          <!-- timeline 00:00:00 -->
                          {{ $moment(i * 1000).format("HH:mm:ss") }}
                        </div>
                      </template>
                    </div>
                    <div
                      id="replace-item"
                      class="replace-item"
                      :data-id="item.id"
                      data-type="items"
                      :data-x="item.x"
                      :data-y="item.y"
                      style="z-index: 1000; position: absolute"
                      :style="`transform:translate(${item.x}px, ${item.y}px);font-size:2em;filter:contrast(0);`"
                      v-for="(item, i) in ndd.items"
                      :key="`ndd${i}`"
                    >
                      <v-btn
                        v-if="deleteItems"
                        @click="
                          ndd.items = ndd.items.filter((e) => e.id != item.id)
                        "
                        fab
                        x-small
                        elevation="0"
                        color="error"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      {{ item.text }}
                    </div>
                    <div
                      id="replace-item"
                      class="replace-item"
                      :data-id="item.id"
                      data-type="notes"
                      :data-x="item.x"
                      :data-y="item.y"
                      style="z-index: 1000; position: absolute"
                      :style="`transform:translate(${item.x}px, ${item.y}px);`"
                      v-for="(item, z) in ndd.notes"
                      :key="`note${item.x}-${z}`"
                    >
                      <v-btn
                        v-if="deleteItems"
                        @click="
                          ndd.notes = ndd.notes.filter((e) => e.id != item.id)
                        "
                        fab
                        x-small
                        elevation="0"
                        color="error"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      <v-chip>
                        <v-text-field
                          v-if="item.active"
                          :style="{
                            width: 'auto',
                          }"
                          v-model="item.text"
                          dense
                          @blur="item.active = false"
                          hide-details
                        ></v-text-field>
                        <span
                          @click="
                            ($event) => {
                              item.active = true;
                              $nextTick(() => {
                                $event.target.focus();
                              });
                            }
                          "
                          v-else
                        >
                          {{ item.text }}
                        </span>
                      </v-chip>
                    </div>
                    <div
                      class="scenechange"
                      :style="`position:absolute;top:0;transform:translate(${sceneChange.x}px, 0px);height:${getDetectionMarkerHeight()}px;width:5px;background-color:grey; z-index:1000;`"
                      v-for="sceneChange in ndd.sceneChanges"
                      :key="`scene${sceneChange.x}`"
                    >
                      <v-btn
                        style="position: absolute; top: 0"
                        v-if="deleteItems"
                        @click="
                          ndd.sceneChanges = ndd.sceneChanges.filter(
                            (e) => e.id != sceneChange.id
                          )
                        "
                        fab
                        x-small
                        elevation="0"
                        color="error"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                    <div
                      class="loop"
                      :style="`position:absolute;top:0;transform:translate(${loop.x}px, 0px);height:${getDetectionMarkerHeight()}px;width:2px;background-color:red; z-index:1000;`"
                      v-for="(loop, c) in ndd.loops"
                      :key="`loop${loop.x}`"
                    >
                      <v-btn
                        v-if="deleteItems"
                        @click="
                          ndd.loops = ndd.loops.filter((e) => e.id != loop.id)
                        "
                        fab
                        x-small
                        elevation="0"
                        color="error"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      <div
                        :style="{
                          left: '-36px',
                          top: '50%',
                          position: 'absolute',
                          transform: 'translate(0, -50%)',
                        }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="74.263"
                          height="40"
                          viewBox="0 0 74.263 89"
                        >
                          <path
                            id="Tracé_9"
                            data-name="Tracé 9"
                            d="M0,0,58,58"
                            transform="translate(8.132 13)"
                            fill="none"
                            stroke="red"
                            stroke-width="5"
                          />
                          <line
                            id="Ligne_30"
                            data-name="Ligne 30"
                            y1="58"
                            x2="58"
                            transform="translate(8.132 13)"
                            fill="none"
                            stroke="red"
                            stroke-width="5"
                          />
                          <line
                            id="Ligne_31"
                            data-name="Ligne 31"
                            y2="89"
                            transform="translate(37.132)"
                            fill="none"
                            stroke="red"
                            stroke-width="5"
                          />
                          <text
                            id="OUT"
                            transform="translate(84.235 26)"
                            fill="#b5423c"
                            font-size="27"
                            font-family="HelveticaNeue, Helvetica Neue"
                          >
                            <tspan x="0" y="0">{{ c + 1 }}</tspan>
                          </text>
                        </svg>
                      </div>
                    </div>
                    <div
                      class="endDialog"
                      :style="`position:absolute;top:0;transform:translate(${endDialog.x}px, 0px);height:${getDetectionMarkerHeight()}px;width:2px;background-color:red; z-index:1000;`"
                      v-for="endDialog in ndd.endDialog"
                      :key="`endDialog${endDialog.x}`"
                    >
                      <v-btn
                        v-if="deleteItems"
                        @click="
                          ndd.endDialog = ndd.endDialog.filter(
                            (e) => e.id != endDialog.id
                          )
                        "
                        fab
                        x-small
                        elevation="0"
                        color="error"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      <div
                        :style="{
                          left: '-25px',
                          top: '50%',
                          position: 'absolute',
                          transform: 'translate(0, -50%)',
                        }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="74.263"
                          height="40"
                          viewBox="0 0 140.235 102.265"
                        >
                          <line
                            id="Ligne_19"
                            data-name="Ligne 19"
                            y1="66.494"
                            x2="66.948"
                            transform="translate(1.762 14)"
                            fill="none"
                            stroke="#c43636"
                            stroke-width="5"
                          />
                          <line
                            id="Ligne_73"
                            data-name="Ligne 73"
                            y1="67"
                            x2="66.774"
                            transform="translate(12.735 33.5)"
                            fill="none"
                            stroke="#c43636"
                            stroke-width="5"
                          />
                          <text
                            id="OUT"
                            transform="translate(84.235 26)"
                            fill="#b5423c"
                            font-size="27"
                            font-family="HelveticaNeue, Helvetica Neue"
                          >
                            <tspan x="0" y="0">OUT</tspan>
                          </text>
                        </svg>
                      </div>
                    </div>
                    <div
                      id="replace-item"
                      class="replace-item"
                      :data-id="item.id"
                      data-type="svg"
                      :data-x="item.x"
                      :data-y="item.y"
                      style="z-index: 1000; position: absolute"
                      :style="`transform:translate(${item.x}px, ${item.y}px);`"
                      v-for="(item, z) in ndd.svg"
                      :key="`note${z}`"
                    >
                      <v-btn
                        v-if="deleteItems"
                        @click="
                          ndd.svg = ndd.svg.filter((e) => e.id != item.id)
                        "
                        fab
                        x-small
                        elevation="0"
                        color="error"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      <template v-if="item.svg == 1">
                        <svg
                          :style="{
                            filter: 'contrast(0)',
                          }"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 44.679 37.844"
                        >
                          <g
                            id="Composant_12_1"
                            data-name="Composant 12 – 1"
                            transform="translate(1.36 2)"
                          >
                            <g
                              id="Groupe_20"
                              data-name="Groupe 20"
                              transform="translate(0 7.685)"
                            >
                              <line
                                id="Ligne_36"
                                data-name="Ligne 36"
                                x2="41.966"
                                y2="25.449"
                                transform="translate(0 1)"
                                fill="none"
                                stroke="#fff"
                                stroke-width="4"
                              />
                              <line
                                id="Ligne_37"
                                data-name="Ligne 37"
                                y1="26.449"
                                x2="41.966"
                                transform="translate(0 0)"
                                fill="none"
                                stroke="#fff"
                                stroke-width="4"
                              />
                            </g>
                            <path
                              id="Tracé_11"
                              data-name="Tracé 11"
                              d="M0-8.452s10.438-9.686,20.93-9.686S41.966-8.452,41.966-8.452"
                              transform="translate(0 18.138)"
                              fill="none"
                              stroke="#fff"
                              stroke-width="4"
                            />
                          </g>
                        </svg>
                      </template>
                      <template v-if="item.svg == 2">
                        <svg
                          :style="{
                            filter: 'contrast(0)',
                          }"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          viewBox="0 0 42.934 10.068"
                        >
                          <path
                            id="Tracé_12"
                            data-name="Tracé 12"
                            d="M0-11.769s10.153-6.369,20.357-6.369,20.46,6.369,20.46,6.369"
                            transform="translate(1.063 20.138)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="4"
                          />
                        </svg>
                      </template>
                      <template v-if="item.svg == 3">
                        <svg
                          :style="{
                            filter: 'contrast(0)',
                          }"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          viewBox="0 0 44.729 13.386"
                        >
                          <path
                            id="Tracé_13"
                            data-name="Tracé 13"
                            d="M0,0S10.473,9.932,20.968,9.932,41.979,0,41.979,0"
                            transform="translate(1.376 1.454)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="4"
                          />
                        </svg>
                      </template>
                    </div>

                    <div
                      :style="`width:${
                        videoDuration * base_rate * settings.fontSize
                      }px;position:relative;height:${rythmoElementHeight}px;`"
                    >
                      <!-- Mode simple bande (mode normal) -->
                      <div
                        v-if="!doubleBandMode"
                        class="timeline-cell"
                        id="timeline"
                        @click="scrollToTimeline"
                        :style="`left:${offsetDuration * 100}px;
                          position:relative;width:100%;background-image:url(${
                            settings.backgroundImage
                          });background-size:contain;background-repeat-x:repeat;background-repeat: repeat-x;height:${
                          settings.height
                        }px;z-index:100;`"
                      >
                        <div
                          style="position: absolute; width: 100%; height: 50px"
                          class="rythmo-ruban"
                        ></div>
                        <template v-for="(subtitle, b) in visibleSubtitles">
                          <!-- Indicateur d'enregistrement pour le sous-titre -->
                          <div
                            v-if="
                              isRecording && isRecordingForSubtitle(subtitle)
                            "
                            :style="getRecordingIndicatorStyle(subtitle)"
                            :key="`rec-indicator-${b}`"
                            class="recording-indicator-rythmo"
                          >
                            <div class="recording-pulse"></div>
                            <span class="recording-label">REC</span>
                          </div>

                          <!-- Indicateur de personnage en session -->
                          <div
                            v-if="
                              !isRecording &&
                              selectedCharacter &&
                              subtitle.character === selectedCharacter &&
                              recordingSettings.followSubtitles
                            "
                            :style="getSessionCharacterIndicatorStyle(subtitle)"
                            :key="`session-indicator-${b}`"
                            class="session-character-indicator"
                          >
                            <v-icon x-small color="white"
                              >mdi-account-voice</v-icon
                            >
                          </div>

                          <!-- Composant De Dialogue -->
                          <DialogueComponent
                            @click="
                              selectedSubtitle = subtitle;
                              subtitle.active = true;
                            "
                            @changeToLine="changeToLine"
                            :cursorTime="cursorTime"
                            :selectedSubtitle="selectedSubtitle"
                            :settings="settings"
                            :characterColor="
                              settings.charactersColors[subtitle.character]
                            "
                            :zoom="zoom"
                            :singleLine="singleLine"
                            :cutMode="cutMode"
                            :spaces="
                              fontFamily.find(
                                (map) => map.value == settings.fontFamily
                              ).spaces
                            "
                            :saveInProgress="saveInProgress"
                            @cutSubtitle="cutSubtitle"
                            :offsetDuration="offsetDuration"
                            :character="subtitle.character"
                            :darkMode="darkMode"
                            :fontFamily="fontFamily"
                            @updateSubtitle="updateSubtitle"
                            :subtitle="subtitle"
                            :id="subtitle.id"
                            :videoDuration="videoDuration"
                            :key="`dialg${b}`"
                          />
                        </template>
                      </div>

                      <!-- Mode double bande (nouveau) -->
                      <div
                        v-if="doubleBandMode"
                        :style="`width:100%;height:${rythmoElementHeight}px;position:relative;`"
                      >
                        <!-- Bande supérieure - Langue source -->
                        <div
                          :style="`position:absolute;top:0;left:0;right:0;height:${
                            (rythmoElementHeight * rythmoSplitRatio) / 100
                          }px;background: linear-gradient(180deg, #1e3c72 0%, #2a5298 100%);border-bottom:2px solid rgba(255,255,255,0.3);overflow:hidden;`"
                        >
                          <div class="rythmo-band-header source">
                            <v-icon x-small color="white" class="mr-1"
                              >mdi-lock-outline</v-icon
                            >
                            <span
                              >{{ sourceLang.toUpperCase() }} - Original</span
                            >
                          </div>
                          <div
                            class="timeline-cell source-band"
                            id="timeline-source"
                            @click="scrollToTimeline"
                            :style="`position:relative;left:${
                              offsetDuration * 100
                            }px;width:${
                              videoDuration * base_rate * settings.fontSize
                            }px;background-image:url(${
                              settings.backgroundImage
                            });background-size:auto ${
                              settings.height
                            }px;background-position: left center;background-repeat-x:repeat;height:100%;overflow:visible;`"
                          >
                            <template
                              v-for="(subtitle, b) in visibleSourceSubtitles"
                            >
                              <DialogueComponentReadOnly
                                :settings="getSettingsForBand('source')"
                                :zoom="zoom"
                                :singleLine="singleLine"
                                :offsetDuration="offsetDuration"
                                :character="subtitle.character"
                                :darkMode="darkMode"
                                :fontFamily="fontFamily"
                                :subtitle="subtitle"
                                :videoDuration="videoDuration"
                                :key="`dialg-source-${b}`"
                              />
                            </template>
                          </div>
                        </div>

                        <!-- Bande inférieure - Langue cible -->
                        <div
                          :style="`position:absolute;top:${
                            (rythmoElementHeight * rythmoSplitRatio) / 100
                          }px;left:0;right:0;height:${
                            (rythmoElementHeight * (100 - rythmoSplitRatio)) /
                            100
                          }px;background: linear-gradient(180deg, #27513a 0%, #3e7254 100%);overflow:hidden;`"
                        >
                          <div class="rythmo-band-header target">
                            <v-icon x-small color="white" class="mr-1"
                              >mdi-pencil-outline</v-icon
                            >
                            <span
                              >{{ targetLang.toUpperCase() }} - Traduction</span
                            >
                          </div>
                          <div
                            class="timeline-cell target-band"
                            id="timeline-target"
                            @click="scrollToTimeline"
                            :style="`position:relative;left:${
                              offsetDuration * 100
                            }px;width:${
                              videoDuration * base_rate * settings.fontSize
                            }px;background-image:url(${
                              settings.backgroundImage
                            });background-size:auto ${
                              settings.height
                            }px;background-position: left center;background-repeat-x:repeat;height:100%;overflow:visible;`"
                          >
                            <template
                              v-for="(subtitle, b) in visibleTargetSubtitles"
                            >
                              <DialogueComponent
                                @click="
                                  selectedSubtitle = subtitle;
                                  subtitle.active = true;
                                "
                                @changeToLine="changeToLine"
                                :cursorTime="cursorTime"
                                :selectedSubtitle="selectedSubtitle"
                                :settings="getSettingsForBand('target')"
                                :characterColor="
                                  settings.charactersColors[subtitle.character]
                                "
                                :zoom="zoom"
                                :singleLine="singleLine"
                                :cutMode="cutMode"
                                :spaces="
                                  fontFamily.find(
                                    (map) => map.value == settings.fontFamily
                                  ).spaces
                                "
                                :saveInProgress="saveInProgress"
                                @cutSubtitle="cutSubtitle"
                                :offsetDuration="offsetDuration"
                                :character="subtitle.character"
                                :darkMode="darkMode"
                                :fontFamily="fontFamily"
                                @updateSubtitle="updateSubtitle"
                                :subtitle="subtitle"
                                :id="subtitle.id"
                                :videoDuration="videoDuration"
                                :key="`dialg-target-${b}`"
                                :disableDrag="true"
                              />
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    :style="`width:${innerWidth / 2}px;display:inline-block;`"
                  >
                    <div style="height: 15px" class="timeline-cell"></div>
                    <div
                      class="timeline-cell"
                      id="timeline"
                      @click="scrollToTimeline"
                      :style="`left:${
                        offsetDuration * 100
                      }px;position:relative;width:100%;background-color:${choseColorBySeedString()};height:${
                        settings.height
                      }px;`"
                    ></div>
                  </div>
                </div>
              </div>
          </v-col>
        </div>
      </div>
      <!-- ToolBar -->
      <div
        cols="12"
        style="position: absolute; z-index: 100; width: 100%"
        class="py-0 mb-0"
        v-if="!rendering && selectedSubtitle.id && cinemaMode && !isRecording"
      >
        <v-card>
          <v-card-text>
            <v-row class="my-0">
              <v-col lg="2" cols="10" class="my-0">
                <!-- <v-text-field hide-details v-model="selectedSubtitle.character" outlined dense /> -->
                <v-text-field
                  label="character"
                  dense
                  outlined
                  hide-details
                  v-model="selectedSubtitle.character"
                >
                  <template v-slot:append>
                    <v-menu>
                      <template v-slot:activator="{ on }">
                        <v-btn small icon color="primary" v-on="on">
                          <v-icon small> mdi-chevron-down </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="i in getArrayOfAvailableCharacter"
                          @click="selectedCharacter = i"
                          :key="`charaarray${i}`"
                        >
                          {{ i }}
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" class="my-0">
                <v-text-field
                  hide-details
                  v-model="selectedSubtitle.text"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-btn
              small
              @click="
                deleteSubtitle(selectedSubtitle.id);
                selectedSubtitle = { id: null };
              "
              color="red"
              icon
              style="position: absolute; right: 2em; top: 0; cursor: pointer"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
            <!-- close button -->
            <v-btn
              small
              @click="selectedSubtitle = { id: null }"
              color="primary"
              icon
              style="position: absolute; right: 0em; top: 0; cursor: pointer"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <!-- Render Window -->
    <v-dialog
      v-model="renderDone"
      max-width="800px"
      max-height="70vh"
      persistent
    >
      <v-card class="render-dialog" dark>
        <!-- Header -->
        <v-app-bar flat color="success" dark class="render-header" dense>
          <v-icon left>mdi-check-circle</v-icon>
          <v-toolbar-title class="font-weight-bold">
            {{ $t("title.render_done") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click="renderDone = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>

        <v-card-text class="render-content pa-4">
          <v-row>
            <!-- Video Preview -->
            <v-col cols="12" md="7">
              <div class="video-preview-container">
                <video
                  crossorigin="anonymous"
                  ref="outputVideo"
                  v-if="outputURL"
                  class="preview-video"
                  :src="outputURL"
                  controls
                ></video>
                <div v-else class="video-placeholder">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="40"
                  ></v-progress-circular>
                  <p class="mt-2 mb-0">Chargement...</p>
                </div>
              </div>
            </v-col>

            <!-- Video Info & Actions -->
            <v-col cols="12" md="5">
              <div class="render-info-container">
                <!-- Success Message -->
                <div class="success-message text-center mb-4">
                  <v-icon color="success" size="48" class="mb-2"
                    >mdi-check-circle-outline</v-icon
                  >
                  <h3 class="success--text font-weight-bold mb-1">
                    Vidéo prête !
                  </h3>
                  <p class="text-caption grey--text text--lighten-1 mb-0">
                    {{ $t("title.render_done_subtitle") }}
                  </p>
                </div>

                <!-- Compact Video Stats -->
                <v-card class="video-stats mb-4" outlined flat>
                  <v-card-text class="pa-3">
                    <div class="stats-grid">
                      <div class="stat-item">
                        <v-icon small class="mr-1">mdi-clock-outline</v-icon>
                        <span class="text-caption">{{
                          formatDuration($refs.outputVideo?.duration)
                        }}</span>
                      </div>
                      <div class="stat-item">
                        <v-icon small class="mr-1">mdi-monitor</v-icon>
                        <span class="text-caption"
                          >{{ $refs.outputVideo?.videoWidth }}×{{
                            $refs.outputVideo?.videoHeight
                          }}</span
                        >
                      </div>
                      <div class="stat-item">
                        <v-icon small class="mr-1">mdi-file-video</v-icon>
                        <span class="text-caption">MP4</span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <!-- Actions -->
                <div class="actions-container">
                  <v-btn
                    large
                    block
                    color="success"
                    elevation="2"
                    @click="downloadRenderVideo()"
                    class="download-btn mb-3"
                  >
                    <v-icon left>mdi-download</v-icon>
                    {{ $t("button.download") }}
                  </v-btn>

                  <v-row dense>
                    <v-col cols="6">
                      <v-btn
                        outlined
                        block
                        color="primary"
                        @click="shareVideo()"
                        small
                      >
                        <v-icon left small>mdi-share-variant</v-icon>
                        Partager
                      </v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn outlined block @click="renderDone = false" small>
                        <v-icon left small>mdi-close</v-icon>
                        Fermer
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Overlay Rendering -->
    <v-overlay :value="rendering" class="text-center">
      <h2>
        {{ renderStatusMessage }}
      </h2>
      <template v-if="renderProgress"> {{ renderProgress }}% </template>
      <template v-else>
        {{ $t("title.export_in_prepare") }}
      </template>
      <h3>Don't close or resize this window</h3>
      <v-progress-linear indeterminate></v-progress-linear>
    </v-overlay>
    <!-- Overlay timer -->
    <v-overlay :value="timer > 0">
      <h1 class="display-1">
        {{ timer }}
      </h1>
    </v-overlay>
    <!-- Popup plan -->
    <v-dialog
      v-model="openPopupPlan"
      max-width="1200"
      width="95%"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card dark>
        <v-btn
          icon
          dark
          @click="openPopupPlan = false"
          class="dialog-close-btn"
          style="position: absolute; right: 16px; top: 16px; z-index: 10"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text class="pa-0">
          <plan-view :reason="reasonPlan" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Settings -->
    <v-dialog
      v-model="openSettings"
      max-width="900px"
      transition="dialog-transition"
    >
      <v-card class="settings-dialog">
        <!-- Header moderne avec gradient -->
        <v-app-bar flat color="transparent" class="settings-header">
          <v-icon left color="primary">mdi-cog</v-icon>
          <v-toolbar-title class="font-weight-bold">{{
            $t("title.settings")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="openSettings = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>

        <v-card-text class="pa-0">
          <!-- Tabs pour organiser les sections -->
          <v-tabs
            v-model="settingsTab"
            background-color="transparent"
            color="primary"
            grow
          >
            <v-tab>
              <v-icon left small>mdi-format-text</v-icon>
              Texte
            </v-tab>
            <v-tab>
              <v-icon left small>mdi-palette</v-icon>
              Apparence
            </v-tab>
            <v-tab>
              <v-icon left small>mdi-account-group</v-icon>
              Personnages
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="settingsTab" class="home-settings-content">
            <!-- Tab 1: Paramètres de texte -->
            <v-tab-item class="scrollable-tab-item">
              <v-container fluid class="pa-6">
                <v-row>
                  <!-- Preview en temps réel -->
                  <v-col cols="12" class="mb-4">
                    <v-card class="preview-card" elevation="0">
                      <v-card-title class="pb-2">
                        <v-icon small class="mr-2">mdi-eye</v-icon>
                        Aperçu en temps réel
                      </v-card-title>
                      <v-card-text>
                        <div class="preview-container">
                          <div
                            class="preview-text"
                            :style="{
                              fontFamily: settings.fontFamily,
                              fontSize: `${settings.fontSize}px`,
                              color: settings.fontColor || '#ffffff',
                            }"
                          >
                            Voici à quoi ressembleront vos sous-titres
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Sélection de police -->
                  <v-col cols="12" md="6">
                    <div class="setting-group">
                      <div class="setting-header">
                        <v-icon small color="primary">mdi-format-font</v-icon>
                        <span class="font-weight-medium ml-2"
                          >Police d'écriture</span
                        >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon small class="ml-1" v-on="on"
                              >mdi-help-circle-outline</v-icon
                            >
                          </template>
                          <span>Choisissez la police pour vos sous-titres</span>
                        </v-tooltip>
                      </div>
                      <v-select
                        :items="fontFamily"
                        v-model="settings.fontFamily"
                        item-text="text"
                        item-value="value"
                        outlined
                        dense
                        class="mt-2"
                      >
                        <template v-slot:selection="{ item }">
                          <span :style="{ fontFamily: item.value }">
                            {{ item.text }}
                          </span>
                        </template>
                        <template v-slot:item="{ item }">
                          <div
                            class="font-preview-item"
                            :style="{ fontFamily: item.value }"
                          >
                            <span class="font-name">{{ item.text }}</span>
                            <span class="font-sample">Aa Bb Cc 123</span>
                          </div>
                        </template>
                      </v-select>
                    </div>
                  </v-col>

                  <!-- Taille de police -->
                  <v-col cols="12" md="6">
                    <div class="setting-group">
                      <div class="setting-header">
                        <v-icon small color="primary">mdi-format-size</v-icon>
                        <span class="font-weight-medium ml-2"
                          >Taille du texte</span
                        >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon small class="ml-1" v-on="on"
                              >mdi-help-circle-outline</v-icon
                            >
                          </template>
                          <span
                            >Ajustez la taille des sous-titres (10-50px)</span
                          >
                        </v-tooltip>
                      </div>
                      <v-slider
                        v-model="settings.fontSize"
                        :min="10"
                        :max="50"
                        :step="1"
                        thumb-label="always"
                        color="primary"
                        track-color="grey"
                        class="mt-4"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="settings.fontSize"
                            type="number"
                            :min="10"
                            :max="50"
                            style="width: 60px"
                            dense
                            outlined
                            hide-details
                            suffix="px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </div>
                  </v-col>

                  <!-- Couleur du texte -->
                  <v-col cols="12" md="6">
                    <div class="setting-group">
                      <div class="setting-header">
                        <v-icon small color="primary">mdi-palette</v-icon>
                        <span class="font-weight-medium ml-2"
                          >Couleur du texte</span
                        >
                      </div>
                      <div class="color-picker-grid mt-3">
                        <div
                          v-for="color in fontColors"
                          :key="color.color"
                          class="color-option"
                          :class="{
                            active: settings.fontColor === color.color,
                          }"
                          :style="{ backgroundColor: color.color }"
                          @click="settings.fontColor = color.color"
                        >
                          <v-icon
                            v-if="settings.fontColor === color.color"
                            small
                            >mdi-check</v-icon
                          >
                        </div>
                      </div>
                    </div>
                  </v-col>

                  <!-- Langue -->
                  <v-col cols="12" md="6">
                    <div class="setting-group">
                      <div class="setting-header">
                        <v-icon small color="primary">mdi-translate</v-icon>
                        <span class="font-weight-medium ml-2"
                          >Langue des sous-titres</span
                        >
                      </div>
                      <v-select
                        :items="getAvailableLanguage"
                        v-model="settings.language"
                        outlined
                        dense
                        class="mt-2"
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <!-- Tab 2: Apparence et backgrounds -->
            <v-tab-item class="scrollable-tab-item">
              <v-container fluid class="pa-6">
                <v-row>
                  <!-- Affichage des sous-titres sur la vidéo -->
                  <v-col cols="12">
                    <div class="setting-group">
                      <div class="setting-header">
                        <v-icon small color="primary"
                          >mdi-subtitles-outline</v-icon
                        >
                        <span class="font-weight-medium ml-2"
                          >Affichage des sous-titres</span
                        >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon small class="ml-1" v-on="on"
                              >mdi-help-circle-outline</v-icon
                            >
                          </template>
                          <span
                            >Afficher ou masquer les sous-titres directement sur
                            la vidéo</span
                          >
                        </v-tooltip>
                      </div>
                      <v-switch
                        v-model="settings.showVideoSubtitles"
                        label="Afficher les sous-titres sur la vidéo"
                        hint="Désactivez pour masquer l'overlay des sous-titres sur le lecteur vidéo"
                        persistent-hint
                        color="primary"
                        class="mt-2"
                      ></v-switch>
                    </div>
                  </v-col>

                  <!-- Filtres de thèmes -->
                  <v-col cols="12">
                    <div class="setting-group">
                      <div class="setting-header mb-3">
                        <v-icon small color="primary">mdi-filter</v-icon>
                        <span class="font-weight-medium ml-2"
                          >Filtrer les styles</span
                        >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon small class="ml-1" v-on="on"
                              >mdi-help-circle-outline</v-icon
                            >
                          </template>
                          <span
                            >Sélectionnez les catégories de fonds à
                            afficher</span
                          >
                        </v-tooltip>
                      </div>
                      <v-chip-group
                        v-model="selectedThemes"
                        multiple
                        column
                        active-class="primary--text"
                      >
                        <v-chip
                          v-for="(count, theme) in backgrounds"
                          :key="theme"
                          :value="theme"
                          filter
                          outlined
                          class="ma-1"
                        >
                          <v-icon left small>mdi-palette-swatch</v-icon>
                          {{ theme }} ({{ count }})
                        </v-chip>
                      </v-chip-group>
                    </div>
                  </v-col>

                  <!-- Grille de backgrounds -->
                  <v-col cols="12">
                    <div class="setting-group">
                      <div class="setting-header mb-3">
                        <v-icon small color="primary">mdi-image</v-icon>
                        <span class="font-weight-medium ml-2"
                          >Choisir un fond</span
                        >
                      </div>
                      <v-row>
                        <v-col
                          v-for="(background, i) in filteredBackgrounds"
                          :key="i"
                          cols="12"
                          sm="6"
                          md="4"
                          lg="3"
                        >
                          <v-hover v-slot="{ hover }">
                            <v-card
                              @click="
                                settings.backgroundImage = background.path;
                                openSettings = false;
                              "
                              class="background-option"
                              :class="{
                                selected:
                                  settings.backgroundImage === background.path,
                              }"
                              :elevation="hover ? 8 : 2"
                            >
                              <div
                                class="background-preview"
                                :style="{
                                  backgroundImage: `url(${background.path})`,
                                  backgroundSize: 'contain',
                                  backgroundRepeat: 'repeat-x',
                                  backgroundPosition: 'center center',
                                  height: '120px',
                                  position: 'relative',
                                  overflow: 'hidden',
                                }"
                              >
                                <div
                                  class="preview-overlay"
                                  v-if="
                                    settings.backgroundImage === background.path
                                  "
                                >
                                  <v-icon color="success" large>
                                    mdi-check-circle
                                  </v-icon>
                                </div>
                                <div class="preview-text-example">
                                  <span
                                    :style="{
                                      fontFamily: settings.fontFamily,
                                      fontSize: '16px',
                                      color: settings.fontColor || '#ffffff',
                                    }"
                                  >
                                    Exemple de texte
                                  </span>
                                </div>
                              </div>
                              <v-card-text class="text-center py-2">
                                <small>{{ background.name }}</small>
                              </v-card-text>
                            </v-card>
                          </v-hover>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <!-- Tab 3: Personnages -->
            <v-tab-item class="scrollable-tab-item">
              <v-container fluid class="pa-6">
                <v-row>
                  <v-col cols="12">
                    <div class="setting-group">
                      <div class="setting-header mb-3">
                        <v-icon small color="primary">mdi-account-edit</v-icon>
                        <span class="font-weight-medium ml-2"
                          >Couleurs des personnages</span
                        >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon small class="ml-1" v-on="on"
                              >mdi-help-circle-outline</v-icon
                            >
                          </template>
                          <span
                            >Attribuez une couleur unique à chaque
                            personnage</span
                          >
                        </v-tooltip>
                      </div>

                      <!-- Liste des personnages -->
                      <v-list class="character-list">
                        <v-list-item
                          v-for="character in getArrayOfAvailableCharacter"
                          :key="character"
                          class="character-item"
                          @click="selectedCharacter = character"
                          :class="{ active: selectedCharacter === character }"
                        >
                          <v-list-item-avatar>
                            <v-avatar
                              :color="
                                settings.charactersColors[character] || '#666'
                              "
                              size="40"
                            >
                              <span class="white--text font-weight-bold">
                                {{ character.charAt(0).toUpperCase() }}
                              </span>
                            </v-avatar>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title class="font-weight-medium">
                              {{ character }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ countSubtitlesForCharacter(character) }}
                              sous-titres
                            </v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action class="d-flex flex-row">
                            <v-menu
                              v-model="colorMenus[character]"
                              :close-on-content-click="false"
                              offset-x
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" @click.stop title="Couleur du texte">
                                  <v-icon>mdi-format-color-text</v-icon>
                                </v-btn>
                              </template>
                              <v-card>
                                <v-card-title class="text-subtitle-2 pb-0">Couleur du texte</v-card-title>
                                <v-card-text>
                                  <v-color-picker
                                    :value="
                                      settings.charactersColors[character]
                                    "
                                    @update:color="
                                      updateColor(character, $event)
                                    "
                                    dot-size="25"
                                    mode="hexa"
                                    swatches-max-height="200"
                                  ></v-color-picker>
                                </v-card-text>
                              </v-card>
                            </v-menu>
                            <v-menu
                              v-model="badgeColorMenus[character]"
                              :close-on-content-click="false"
                              offset-x
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" @click.stop title="Couleur du badge">
                                  <v-icon>mdi-label</v-icon>
                                </v-btn>
                              </template>
                              <v-card>
                                <v-card-title class="text-subtitle-2 pb-0">Couleur du badge</v-card-title>
                                <v-card-text>
                                  <v-color-picker
                                    :value="
                                      settings.charactersBadgeColors[character]
                                    "
                                    @update:color="
                                      updateBadgeColor(character, $event)
                                    "
                                    dot-size="25"
                                    mode="hexa"
                                    swatches-max-height="200"
                                  ></v-color-picker>
                                </v-card-text>
                              </v-card>
                            </v-menu>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <!-- Footer avec actions -->
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-btn text @click="resetSettings">
            <v-icon left small>mdi-refresh</v-icon>
            Réinitialiser
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="openSettings = false"> Annuler </v-btn>
          <v-btn color="primary" @click="applySettings">
            <v-icon left small>mdi-check</v-icon>
            Appliquer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Loading -->
    <v-overlay :value="loading">
      <h2>
        {{ $t("title.loading") }}
      </h2>
      <v-progress-linear indeterminate></v-progress-linear>
    </v-overlay>
    <!-- Tasks -->
    <TaskManager
      v-model="taskPopup"
      :tasks="tasks"
      @delete-task="deleteTask"
      @update-tasks="updateTasksFromChild"
      @load-render-video="loadRenderVideo"
    />
    <!-- confirmLeave dialog -->
    <v-dialog v-model="confirmLeavePopup" persistent max-width="50vw">
      <v-card>
        <v-card-title class="headline">
          {{ $t("title.confirm_leave") }}
        </v-card-title>
        <v-card-text>
          {{ $t("text.confirm_leave") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="confirmLeavePopup = false">
            {{ $t("title.stay") }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="
              confirmLeave = true;
              confirmLeavePopup = false;
              $router.push(nextRoute);
            "
          >
            {{ $t("title.leave") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Help Window -->
    <v-dialog
      v-model="openHelpWindow"
      :max-height="innerHeight > 600 ? '80vh' : '100vh'"
    >
      <v-card>
        <help-section />
      </v-card>
    </v-dialog>
    <!-- export Window -->
    <v-dialog
      v-model="popupExport"
      :max-width="innerWidth > 600 ? '50vw' : '100vw'"
    >
      <v-card>
        <v-card-text>
          <v-row class="mx-3" v-if="$refs.video">
            <v-col v-if="$refs.video.duration > 10 * 60" cols="12">
              <v-alert type="warning" dismissible>
                {{ $t("error.export_warning") }}
              </v-alert>
            </v-col>
            <v-col cols="12">
              <!-- Choose export mode between Youtube and Tiktok with radio  -->
              Format
              <v-radio-group v-model="exportMode" row>
                <v-radio
                  label="Youtube (Paysage) - 1920x1080"
                  value="youtube"
                ></v-radio>
                <v-radio
                  label="Tiktok (Portrait) - 1080x1920"
                  value="tiktok"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="6">
              Filtre AI
              <v-checkbox
                v-model="settings.iafilter"
                :label="$t('options.denoise_audio')"
              ></v-checkbox>
            </v-col>
            <v-col cols="6">
              {{ $t("options.without_rythmo") }}
              <v-checkbox
                v-model="settings.without_rythmo"
                :label="$t('options.without_rythmo')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" v-if="hasProcessedAudio">
              <v-alert type="info" dense>
                <v-icon left>mdi-microphone-off</v-icon>
                Audio sans voix disponible
              </v-alert>
              <v-checkbox
                v-model="settings.useProcessedAudio"
                label="Utiliser l'audio sans voix pour l'export"
              ></v-checkbox>
            </v-col>
            <v-col cols="12">
              <!-- preroll -->
              Pre-roll<br />
              <v-btn
                v-for="i in [0, 1, 2, 3]"
                :key="i"
                :color="settings.preroll == i ? 'primary' : null"
                @click="settings.preroll = i"
              >
                {{ i }}s
              </v-btn>
            </v-col>
            <v-col cols="12">
              Frame Rate
              <v-select
                :items="framerates"
                v-model="settings.framerate"
                label="Framerate"
                value="value"
                hide-details
                @change="checkFrameratePlan()"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="
              createExportTask();
              popupExport = false;
            "
          >
            Exporter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Save in progress -->
    <v-overlay v-if="false" :value="saveInProgress" class="text-center">
      <h2>
        {{ $t("title.saving") }}
      </h2>
      <!-- scroled tips -->
      <transition-group name="fade">
        <div v-for="(tip, b) in tips" :key="tip">
          <div v-if="tip.show" :key="`tip${b}`" class="tip">
            <v-alert dense color="primary" class="white--text" type="info">
              {{ tip.text }}
            </v-alert>
          </div>
        </div>
      </transition-group>
      <v-progress-linear :value="uploadProgress"></v-progress-linear>
    </v-overlay>
    <v-snackbar v-model="snackbar" :timeout="5000" :color="snackbarColor || 'success'" top>
      {{ snackbarMessage }}
    </v-snackbar>

    <!-- Dialog Export Croisillé -->
    <v-dialog v-model="detxExportDialog" max-width="600px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-grid</v-icon>
          Export Croisillé
        </v-card-title>

        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12">
              <div class="text-body-1 mb-3">
                Sélectionnez le format d'export pour votre croisillé :
              </div>
            </v-col>

            <v-col cols="12">
              <v-radio-group v-model="detxExportFormat" column>
                <v-radio value="pdf" color="red">
                  <template v-slot:label>
                    <div class="d-flex align-center">
                      <v-icon left color="red">mdi-file-pdf-box</v-icon>
                      <div>
                        <div class="text-subtitle-1">PDF</div>
                        <div class="text-caption">
                          Document formaté avec grille, rôles et script
                        </div>
                      </div>
                    </div>
                  </template>
                </v-radio>

                <v-radio value="excel" color="green">
                  <template v-slot:label>
                    <div class="d-flex align-center">
                      <v-icon left color="green">mdi-microsoft-excel</v-icon>
                      <div>
                        <div class="text-subtitle-1">Excel</div>
                        <div class="text-caption">
                          Classeur avec 3 feuilles (Grille, Rôles, Script)
                        </div>
                      </div>
                    </div>
                  </template>
                </v-radio>

                <v-radio value="csv" color="blue">
                  <template v-slot:label>
                    <div class="d-flex align-center">
                      <v-icon left color="blue">mdi-file-delimited</v-icon>
                      <div>
                        <div class="text-subtitle-1">CSV</div>
                        <div class="text-caption">
                          Format tabulaire pour import dans d'autres outils
                        </div>
                      </div>
                    </div>
                  </template>
                </v-radio>

                <v-radio value="json" color="purple">
                  <template v-slot:label>
                    <div class="d-flex align-center">
                      <v-icon left color="purple">mdi-code-json</v-icon>
                      <div>
                        <div class="text-subtitle-1">JSON</div>
                        <div class="text-caption">
                          Données structurées (affichées dans la console)
                        </div>
                      </div>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12">
              <v-alert v-if="detxData" type="info" dense outlined>
                <v-icon left small>mdi-check-circle</v-icon>
                Données DETX disponibles :
                {{ detxData.statistics.totalRoles }} rôles,
                {{ detxData.statistics.totalLines }} lignes
              </v-alert>
              <v-alert
                v-else-if="subtitles.length"
                type="warning"
                dense
                outlined
              >
                <v-icon left small>mdi-alert</v-icon>
                Génération depuis {{ subtitles.length }} sous-titres existants
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="detxExportDialog = false"> Annuler </v-btn>
          <v-btn color="primary" @click="performCroisilleExport">
            <v-icon left>mdi-export</v-icon>
            Exporter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="inviteFriendModal">
      <InviteFriend :id_project="workspace" :settings="settings" />
    </v-dialog>
    <!-- bulk edit subtitles dialog with offset start/end -->
    <v-dialog v-model="bulkEdit" max-width="500px">
      <v-card>
        <v-card-title>
          <v-toolbar dense flat>
            <v-toolbar-title>{{ $t("title.bulk_edit") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="bulkEdit = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-row>
            <!-- change character (select character) -->
            <v-col cols="12">
              <v-select
                :items="getArrayOfAvailableCharacter"
                label="Character"
                outlined
                dense
                v-model="selectedCharacter"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <!-- change lines -->
              <v-select
                :items="[0, 1, 2, 3]"
                label="Lines"
                outlined
                dense
                v-model="selectedLineChange"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Offset Start (in s)"
                v-model="offsetStart"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="
              bulkEditSubtitles(offsetStart);
              bulkEdit = false;
            "
          >
            {{ $t("button.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogue de remplacement vidéo sans voix -->
    <v-dialog
      v-model="replaceVideoDialog"
      max-width="600px"
      persistent
      :retain-focus="false"
    >
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-microphone-variant-off</v-icon>
          Remplacer la vidéo par une version sans voix
        </v-card-title>

        <v-stepper v-model="replaceVideoStep" elevation="0">
          <v-stepper-header>
            <v-stepper-step
              :complete="replaceVideoStep > 1"
              step="1"
              color="primary"
            >
              Information
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :complete="replaceVideoStep > 2"
              step="2"
              color="warning"
            >
              Confirmation
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3" color="error"> Traitement </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Étape 1: Information -->
            <v-stepper-content step="1">
              <v-card-text class="pa-4">
                <v-alert
                  type="info"
                  outlined
                  prominent
                  icon="mdi-information"
                  class="mb-4"
                >
                  <div class="text-subtitle-1 font-weight-bold mb-2">
                    Cette fonction utilise l'IA pour supprimer les voix de votre
                    vidéo
                  </div>
                  <div class="text-body-2">
                    Le processus va :
                    <ul class="mt-2">
                      <li>Extraire l'audio de votre vidéo</li>
                      <li>Utiliser l'IA pour isoler et supprimer les voix</li>
                      <li>
                        Recompiler la vidéo avec uniquement la musique et les
                        effets sonores
                      </li>
                      <li>Remplacer définitivement votre vidéo actuelle</li>
                    </ul>
                  </div>
                </v-alert>

                <div class="d-flex align-center mb-3">
                  <v-icon left color="primary">mdi-timer-sand</v-icon>
                  <span class="text-body-1">
                    Temps estimé : 2-5 minutes selon la durée de votre vidéo
                  </span>
                </div>

                <div class="d-flex align-center">
                  <v-icon left color="primary">mdi-cloud-upload</v-icon>
                  <span class="text-body-1">
                    La vidéo sera traitée sur nos serveurs
                  </span>
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="
                    replaceVideoDialog = false;
                    replaceVideoStep = 1;
                  "
                >
                  Annuler
                </v-btn>
                <v-btn color="primary" @click="replaceVideoStep = 2">
                  Suivant
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-stepper-content>

            <!-- Étape 2: Confirmation -->
            <v-stepper-content step="2">
              <v-card-text class="pa-4">
                <v-alert
                  type="warning"
                  outlined
                  prominent
                  icon="mdi-alert"
                  class="mb-4"
                >
                  <div class="text-subtitle-1 font-weight-bold mb-2">
                    ⚠️ ACTION IRRÉVERSIBLE
                  </div>
                  <div class="text-body-2">
                    Une fois le traitement lancé, votre vidéo originale sera
                    <strong>définitivement remplacée</strong> par la version
                    sans voix. <br /><br />
                    Il n'y aura
                    <strong>aucun moyen de récupérer la vidéo originale</strong
                    >.
                  </div>
                </v-alert>

                <v-checkbox
                  v-model="confirmReplace"
                  color="warning"
                  class="mt-4"
                >
                  <template v-slot:label>
                    <span class="text-body-2">
                      Je comprends que cette action est
                      <strong>irréversible</strong>
                      et que ma vidéo originale sera perdue
                    </span>
                  </template>
                </v-checkbox>
              </v-card-text>

              <v-card-actions>
                <v-btn text @click="replaceVideoStep = 1">
                  <v-icon left>mdi-arrow-left</v-icon>
                  Retour
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="
                    replaceVideoDialog = false;
                    replaceVideoStep = 1;
                    confirmReplace = false;
                  "
                >
                  Annuler
                </v-btn>
                <v-btn
                  color="error"
                  @click="
                    replaceVideoStep = 3;
                    startReplaceVideo();
                  "
                  :disabled="!confirmReplace"
                >
                  Remplacer définitivement
                  <v-icon right>mdi-alert</v-icon>
                </v-btn>
              </v-card-actions>
            </v-stepper-content>

            <!-- Étape 3: Traitement -->
            <v-stepper-content step="3">
              <v-card-text class="pa-4 text-center">
                <div v-if="!replaceVideoTaskId">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    :size="80"
                    :width="7"
                    class="mb-4"
                  ></v-progress-circular>

                  <div class="text-h6 mb-2">Préparation du traitement...</div>
                  <div class="text-body-2 text--secondary">
                    Sauvegarde du projet et lancement de la tâche
                  </div>
                </div>

                <div v-else>
                  <v-icon color="success" size="80" class="mb-4">
                    mdi-check-circle
                  </v-icon>

                  <div class="text-h6 mb-2">Traitement en cours !</div>
                  <div class="text-body-2 text--secondary mb-4">
                    Votre vidéo est en cours de traitement sur nos serveurs.
                    <br />
                    Vous pouvez suivre la progression dans le panneau des
                    tâches.
                  </div>

                  <v-chip color="primary" outlined class="mb-4">
                    <v-icon left small>mdi-identifier</v-icon>
                    Tâche #{{ replaceVideoTaskId }}
                  </v-chip>

                  <div class="text-caption text--secondary">
                    La vidéo sera automatiquement rechargée une fois le
                    traitement terminé.
                  </div>
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="
                    replaceVideoDialog = false;
                    taskPopup = true;
                    replaceVideoStep = 1;
                    confirmReplace = false;
                  "
                  :disabled="!replaceVideoTaskId"
                >
                  Voir les tâches
                  <v-icon right>mdi-open-in-new</v-icon>
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>

    <!-- Add BWF Metadata Configuration Dialog -->
    <v-dialog v-model="bwfMetadataDialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="text-h5">Configuration des métadonnées BWF</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div class="text-subtitle-1 mb-2">
                  Associez un nom de micro à chaque personnage pour l'export BWF
                </div>
                <div class="text-caption text-grey mb-4">
                  Ces informations seront intégrées dans les métadonnées du
                  fichier BWF pour faciliter l'organisation dans les studios de
                  doublage
                </div>
              </v-col>
            </v-row>
            <v-row
              v-for="character in getArrayOfAvailableCharacter"
              :key="character"
            >
              <v-col cols="6">
                <v-text-field
                  :label="character"
                  disabled
                  :prepend-icon="'mdi-account'"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="bwfMicrophoneMapping[character]"
                  label="Nom du micro"
                  placeholder="Ex: MIC_01, BOOTH_A"
                  :prepend-icon="'mdi-microphone'"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  v-model="bwfIncludeSessionInfo"
                  label="Inclure les informations de session (date, durée, etc.)"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="bwfMetadataDialog = false"> Annuler </v-btn>
          <v-btn color="primary" @click="saveBwfMetadata"> Enregistrer </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
String.prototype.toHtmlEntities = function () {
  return this.replace(/./gm, function (s) {
    // return "&#" + s.charCodeAt(0) + ";";
    return s.match(/[a-z0-9\s]+/i) ? s : "&#" + s.charCodeAt(0) + ";";
  });
};
import interact from "interactjs";
import WaveSurfer from "wavesurfer.vue";
import AudioTracks from "@/components/Audio/AudioTracks.vue";
// import introjs from 'intro.js/intro.js';
import html2canvas from "html2canvas";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import * as toWav from "audiobuffer-to-wav";
import { mapState } from "vuex";
import { Capacitor } from "@capacitor/core";
import draggable from "vuedraggable";
import autoSaveMixin from "@/mixins/autoSave";
import userPreferencesService from "@/services/userPreferences";
import { AudioProcessor } from "@/components/Audio/AudioProcessor";
// MediaInfo
export default {
  mixins: [autoSaveMixin],
  name: "HomeView",
  data: () => ({
    selectedLineChange: null,
    selectedSubtitles: [],
    offsetStart: 0,
    bulkEdit: false,
    reasonPlan: false,
    inviteFriendModal: false,
    videoLoading: true,
    reactions: [
      "(X)",
      "(mts)",
      "(tsc)",
      "(ah)",
      "(oh)",
      "(ih)",
      "(mhm)",
      "(hm)",
      "(ptt)",
      "(pff)",
      "(unh)",
      "(hun)",
      "(psst)",
    ],
    openSettings: false,
    darkMode: true,
    taskPopup: false,
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    singleLine: false,
    maxSize: 20000,
    chunkSize: 20000,
    exportMode: "youtube",
    choiceTheme: {
      0: "classic",
      2: "dark",
      8: "voxdub",
    },
    openHelpWindow: false,
    onEditingDialog: false,
    offsetDuration: 0,
    tips: [
      {
        text: "Vous pouvez utiliser les flèches gauche et droite pour naviguer dans la timeline",
        show: true,
      },
      {
        text: "Vous pouvez utiliser la barre d'espace pour mettre en pause ou reprendre la lecture",
        show: false,
      },
      {
        text: "Vous pouvez utiliser la touche CTRL + K pour enregistrer votre voix",
        show: false,
      },
    ],
    popupExport: false,
    snackbar: false,
    snackbarMessage: "",
    snackbarColor: "success",
    settings: {
      preroll: 0,
      fontSize: 20,
      backgroundImage: "/img/templates/br-dark-2.png",
      fontFamily: "Arial",
      fontSpaces: 3.5,
      fontColor: "#ffffff",
      rythmoHeight: 50,
      height: 250,
      framerate: 60,
      iafilter: false,
      language: "fr",
      charactersColors: {},
      charactersBadgeColors: {},
      backCharactersColors: {},
      without_rythmo: false,
      useProcessedAudio: false,
      showVideoSubtitles: false,
    },
    framerates: [
      { text: "60", value: 60 },
      { text: "120", value: 120 },
    ],
    fontFamily: [
      { text: "League", value: "League", spaces: 1.5 },
      { text: "Arial", value: "Arial", spaces: 3.5 },
      { text: "Times New Roman", value: "Times New Roman", spaces: 4 },
      { text: "Courier New", value: "Courier New", spaces: 1.5 },
      { text: "Comic Sans MS", value: "Comic Sans MS", spaces: 3.5 },
      { text: "Impact", value: "Impact", spaces: 5 },
      { text: "Sacramento", value: "Sacramento", spaces: 4 },
      { text: "Oooh Baby", value: "Oooh Baby", spaces: 3 },
      {
        text: "The Girl Next Door",
        value: "The Girl Next Door",
        spaces: 3,
      },
    ],
    fontColors: [
      { text: "#ffffff", color: "#ffffff" },
      { text: "#000000", color: "#000000" },
      { text: "#3B3B3B", color: "#3B3B3B" },
      { text: "#FFF2D0", color: "#FFF2D0" },
      { text: "#FCB6CD", color: "#FCB6CD" },
      { text: "#DBBDF2", color: "#DBBDF2" },
      { text: "#BDF2CF", color: "#BDF2CF" },
      { text: "#B6F1FC", color: "#B6F1FC" },
      { text: "#FFE0D0", color: "#FFE0D0" },
      { text: "#6449D1", color: "#6449D1" },
    ],
    backgrounds: {
      classic: 10,
      bleu: 4,
      dark: 10,
      orange: 4,
      jaune: 3,
      vert: 4,
      violet: 4,
      voxdub: 10,
      rose: 4,
    },
    layoutoffset: 0,
    filigrane: true,
    renderFrame: 0,
    selectedCharacter: null,
    tiktokMode: false,
    argumentResolutionError: false,
    publicWorkspace: false,
    startRecording: 0,
    cutMode: false,
    selectedText: "Hello World",
    timer: 0,
    videoSource: null,
    isRecording: false,
    includeRythmo: true,
    videoTime: 0,
    _lastVideoTimeUpdate: 0,
    base_rate: 25,
    currentProgress: 0,
    subtitles: [],
    detxData: null,
    detxExportDialog: false,
    detxExportFormat: "pdf",
    deleteItems: false,
    cursorTime: 0,
    videoDuration: 0,
    videoSpeedRate: 1,
    selectedSubtitle: { id: null },
    selectedSubtitleType: null,
    videoImagesForRenderer: [],
    renderDone: false,
    ndd: {
      sceneChanges: [],
      notes: [],
      endDialog: [],
      loops: [],
      items: [],
      svg: [],
    },
    encoder: null,
    speechRecognition: false,
    uploadProgress: 0,
    timeRef: null,
    confirmLeave: false,
    tasksInterval: null,
    confirmLeavePopup: false,
    outputURL: null,
    cinemaMode: false,
    stripeBandeCounter: 0,
    title: "New Project",
    isDragging: false,
    baseDraggingX: null,
    bottomTab: 0,
    showAudioTracks: false,
    newTime: false,
    wavesurfer: null,
    renderProgress: 0,
    recordStart: 0,
    recordedChunks: [],
    rendering: false,
    error: false,
    isEditingSubtitle: false,
    errorMessage: null,
    renderStatusMessage: null,
    deleteBaseAudio: false,
    sources: [],
    denoiseAudio: false,
    saveInProgress: false,
    openPopupPlan: false,
    lastSave: false,
    loading: false,
    workspace: null,
    videoPaused: true,
    workspaceData: null,
    zoom: 1,
    operations: [],
    // Nouvelles variables pour le redimensionnement des fenêtres
    videoSectionWidth: 40, // pourcentage de largeur pour la section vidéo
    subtitleSectionWidth: 60, // pourcentage de largeur pour la section sous-titres
    rythmoSectionHeight: 30, // pourcentage de hauteur pour la section rythmo (en vh)
    isResizing: false,
    measuredRythmoContainerHeight: 0,
    measuredRythmoToolbarHeight: 0,
    measuredRythmoTabsHeight: 0,
    rythmoResizeObserver: null,
    drawingMode: false,
    drawingHistory: [], // Historique des dessins avec timing
    canvasData: null, // Données du canvas pour l'export
    // Nouveau système d'enregistrement intégré
    recordingSettings: {
      preRoll: 0,
      postRoll: 1,
      autoPlay: true,
      visualFeedback: true,
      followSubtitles: true,
      // Paramètres audio avancés
      audioGain: 0,
      noiseGate: -50,
      echoCancellation: true,
      noiseSuppression: true,
      autoGain: false,
    },
    recordingTime: 0,
    recordingTimer: null,
    countdown: 0,
    countdownTimer: null,
    lastRecordedSource: null,
    audioContext: null,
    mediaStream: null,
    audioAnalyser: null,
    recordingMonitorNode: null,
    recordingWaveData: [],
    recordedSamples: [],
    currentBufferLength: 0,
    scriptProcessor: null,
    audioSelectionStart: 0,
    audioSelectionEnd: 0,
    hasAudioSelection: false,
    isSelectingAudio: false,
    audioEditMode: "new", // 'new' or 'overwrite'
    // Variables d'optimisation pour la lecture
    _frameCount: 0,
    _lastAudioCheck: 0,
    _playDebounce: false,
    _cachedSources: null,
    _lastSourcesLength: 0,
    _audioPlaybackSuspended: false,
    _lastForcedViewportSync: 0,
    _lastSeekSyncAt: 0,
    _lastTimeUpdateSyncAt: 0,
    _scrollAnimationFrame: null,
    _updateScrollPositionBound: null,
    _videoHandlersAttached: false,
    _handleVideoLoadedMetadata: null,
    _handleVideoPlay: null,
    _handleVideoPause: null,
    _handleVideoSeeked: null,
    _handleVideoTimeUpdate: null,
    // Variables pour le dialogue de remplacement vidéo sans voix
    replaceVideoDialog: false,
    replaceVideoStep: 1,
    replaceVideoProcessing: false,
    replaceVideoTaskId: null,
    confirmReplace: false,
    // Variables pour le nouveau système de settings
    settingsTab: 0,
    selectedThemes: [],
    colorMenus: {},
    badgeColorMenus: {},
    bwfMetadataDialog: false,
    bwfMicrophoneMapping: {},
    bwfIncludeSessionInfo: true,
    // Variables pour le mode double bande rythmo
    doubleBandMode: false, // Active/désactive le mode double bande
    sourceLang: "en", // Langue source (originale)
    targetLang: "fr", // Langue cible (traduction)
    sourceSubtitles: [], // Sous-titres de la langue source
    targetSubtitles: [], // Sous-titres de la langue cible
    rythmoSplitRatio: 40, // Ratio de division entre les deux bandes (en pourcentage) - 40% source, 60% cible
  }),
  computed: {
    hasAudioRecordingAccess() {
      // Vérifier d'abord si on est sur une plateforme native (app payante)
      const isNativePlatform =
        window.Capacitor && window.Capacitor.isNativePlatform();
      if (isNativePlatform) {
        return true;
      }

      // Vérifier le rôle de l'utilisateur (priorité au rôle pour gérer les achats récents)
      const userRole = this.$auth?.user?.role || "free";
      if (userRole === "pro" || userRole === "basic") {
        return true;
      }

      // Fallback sur les limites du store
      const limits = this.$store?.getters?.GET_LIMITS || {};
      return limits.hasAudioRecordingAccess === true;
    },
    hasProcessedAudio() {
      return this.sources.some((source) => source.processed === true);
    },
    isTaskAlreadyExecuted() {
      return this.tasks.find(
        (task) =>
          task.attributes.state == "waiting" ||
          task.attributes.state == "queued"
      );
    },
    dubbingCompletionPercentage() {
      if (!this.subtitles.length) return 0;

      // Compter le nombre de sous-titres qui ont un doublage audio
      let subtitlesWithAudio = 0;

      this.subtitles.forEach((subtitle) => {
        // Vérifier s'il existe une source audio pour ce sous-titre
        const hasAudio = this.sources.some((source) => {
          // Vérifier que la source correspond au personnage du sous-titre
          // et que les timecodes correspondent (avec une tolérance)
          return (
            source.character === subtitle.character &&
            source.start <= subtitle.start + 0.5 &&
            source.end >= subtitle.end - 0.5
          );
        });

        if (hasAudio) {
          subtitlesWithAudio++;
        }
      });

      // Calculer le pourcentage
      const percentage = Math.round(
        (subtitlesWithAudio / this.subtitles.length) * 100
      );
      return percentage;
    },
    backgroundsFiltered() {
      let backgrounds = this.backgrounds;
      let choiceTheme = this.choiceTheme;
      let backgroundsFiltered = {};
      Object.entries(choiceTheme).map((map) => {
        if (map[1]) {
          backgroundsFiltered[map[1]] = backgrounds[map[1]];
        }
      });
      return backgroundsFiltered;
    },
    filteredBackgrounds() {
      // Créer un array plat de tous les backgrounds disponibles
      let allBackgrounds = [];
      const themes =
        this.selectedThemes.length > 0
          ? this.selectedThemes
          : Object.keys(this.backgrounds);

      themes.forEach((theme) => {
        if (this.backgrounds[theme]) {
          for (let i = 1; i <= this.backgrounds[theme]; i++) {
            allBackgrounds.push({
              path: `img/templates/br-${theme}-${i}-min.png`,
              name: `${theme} ${i}`,
              theme: theme,
            });
          }
        }
      });

      return allBackgrounds;
    },
    ...mapState(["user", "region", "tasks"]),
    isSafariOrIos() {
      let CapacitorPlatform = Capacitor.getPlatform();
      let Navigator = window.navigator;
      let isSafari = /^((?!chrome|android).)*safari/i.test(Navigator.userAgent);
      let isIos =
        /iPad|iPhone|iPod/.test(Navigator.userAgent) && !window.MSStream;
      return (
        isSafari ||
        isIos ||
        CapacitorPlatform == "ios" ||
        CapacitorPlatform == "electron"
      );
    },
    rythmoWidth() {
      return this.videoDuration * 25 * this.settings.fontSize;
    },
    isoLang() {
      switch (this.settings.language) {
        case "fr":
          return "fr-FR";
        case "en":
          return "en-US";
        case "es":
          return "es-ES";
        case "de":
          return "de-DE";
        case "it":
          return "it-IT";
        case "pt":
          return "pt-PT";
        case "ru":
          return "ru-RU";
        case "ja":
          return "ja-JP";
        default:
          return "fr-FR";
      }
    },
    getAvailableLanguage() {
      let array = ["fr"];
      if (!this.workspaceData?.attributes?.localizations?.data) return array;
      this.workspaceData?.attributes?.localizations?.data.map(
        (localization) => {
          array.push(localization.attributes.locale);
        }
      );
      return array;
    },
    subtitleHeight() {
      let value = null;
      let length = this.getArrayOfAvailableCharacter.length;
      if (this.singleLine) {
        return this.innerHeight - 340;
      }
      // if (length > 5) length = 5
      value = this.innerHeight - (340 + length * 50);
      return value;
    },
    subtitleWidth() {
      return this.innerWidth - 200;
    },
    getArrayOfAvailableCharacter() {
      let characters = this.subtitles.map((subtitle) => subtitle.character);
      return [...new Set(characters)];
    },
    audioSources() {
      const result = this.sources.filter((s) => s.character !== "all");
      if (this.sources.length > 0) {
        console.log("[AudioSources]", this.sources.length, "total,", result.length, "non-all, characters:", this.sources.map(s => s.character));
      }
      return result;
    },
    displayCurrentSubtitle() {
      if (!this.videoTime) {
        return null;
      }
      return this.subtitles.filter(
        (subtitle) =>
          subtitle.start <= this.videoTime && subtitle.end >= this.videoTime
      );
    },
    sourcesGroupedByCharacters() {
      let sources = {};
      Object.entries(this.subtitlesGroupedByCharacters).forEach(
        ([charName]) => {
          if (!sources[charName]) {
            sources[charName] = [];
          }
        }
      );

      this.sources.forEach((source) => {
        // Ignorer si le personnage n'existe plus dans le projet
        if (!this.getArrayOfAvailableCharacter.includes(source.character)) {
          return;
        }

        if (!sources[source.character]) {
          sources[source.character] = [];
        }
        source.muted = source.muted || false;
        sources[source.character].push(source);
      });

      // Exclure la waveform 'all' dans l'onglet audio
      delete sources["all"];
      return sources;
    },
    subtitlesGroupedByCharacters() {
      if (this.singleLine) {
        return { all: this.subtitlesOrdered };
      } else {
        return this.subtitlesOrdered.reduce((acc, subtitle) => {
          if (!acc[subtitle.character]) {
            acc[subtitle.character] = [];
          }
          acc[subtitle.character].push(subtitle);
          return acc;
        }, {});
      }
    },
    subtitlesOrdered() {
      let subtitles = this.subtitles;
      // subtitles.sort((a, b) => {
      //   return a.start - b.start
      // })
      return subtitles;
    },
    // Hauteur actuelle de la section rythmo en pixels
    currentRythmoHeight() {
      if (this.measuredRythmoContainerHeight > 0) {
        return this.measuredRythmoContainerHeight;
      }
      // Convertir le pourcentage en pixels
      const availableHeight = this.innerHeight;
      return (this.rythmoSectionHeight / 100) * availableHeight;
    },
    // Hauteur pour les éléments internes de la section rythmo
    rythmoElementHeight() {
      if (this.measuredRythmoTabsHeight > 0) {
        return Math.max(this.measuredRythmoTabsHeight - 15, 120);
      }

      // Calcul de la hauteur utile en soustrayant les marges et toolbars
      const totalHeight = this.currentRythmoHeight;
      const toolbarHeight = this.cinemaMode
        ? 0
        : this.measuredRythmoToolbarHeight || 48;
      const padding = 40; // Marges augmentées pour éviter le crop
      const usableHeight = Math.max(totalHeight - toolbarHeight - padding, 150);

      // Assurer une hauteur minimum raisonnable (settings.height + 60px pour le spectre)
      return Math.max(usableHeight, this.settings.height + 60);
    },
    // Virtualisation des sous-titres - buffer elargi pour reduire les recalculs
    visibleSubtitles() {
      if (!this.subtitles.length) return [];

      const buffer = 15;
      const pixelsPerSecond = 25 * this.settings.fontSize;
      const visibleDuration = (this.innerWidth || 1920) / pixelsPerSecond;
      const startTime = this.videoTime - buffer;
      const endTime = this.videoTime + visibleDuration + buffer;

      return this.subtitles.filter((s) => s.end >= startTime && s.start <= endTime);
    },
    visibleSourceSubtitles() {
      if (!this.sourceSubtitles.length) return [];

      const buffer = 15;
      const pixelsPerSecond = 25 * this.settings.fontSize;
      const visibleDuration = (this.innerWidth || 1920) / pixelsPerSecond;
      const startTime = this.videoTime - buffer;
      const endTime = this.videoTime + visibleDuration + buffer;

      return this.sourceSubtitles.filter((s) => s.end >= startTime && s.start <= endTime);
    },
    visibleTargetSubtitles() {
      if (!this.targetSubtitles.length) return [];

      const buffer = 15;
      const pixelsPerSecond = 25 * this.settings.fontSize;
      const visibleDuration = (this.innerWidth || 1920) / pixelsPerSecond;
      const startTime = this.videoTime - buffer;
      const endTime = this.videoTime + visibleDuration + buffer;

      return this.targetSubtitles.filter((s) => s.end >= startTime && s.start <= endTime);
    },
  },
  components: {
    VoxdubAnimation: () => import("@/components/VoxdubAnimation.vue"),
    InviteFriend: () => import("@/components/InviteFriend.vue"),
    WaveSurfer,
    HelpSection: () => import("@/components/ResourceSearch.vue"),
    PlanView: () => import("../views/PlanView.vue"),
    DialogueComponent: () =>
      import("@/components/Rythmo/DialogueComponent.vue"),
    DialogueComponentReadOnly: () =>
      import("@/components/Rythmo/DialogueComponentReadOnly.vue"),
    draggable,
    SubtitleEditorComponent: () =>
      import("@/components/Rythmo/SubtitleEditorComponent.vue"),
    MenuBar: () => import("@/components/MenuBar.vue"),
    ResizableSplitter: () => import("@/components/ResizableSplitter.vue"),
    DrawingCanvas: () => import("@/components/Rythmo/DrawingCanvas.vue"),
    TaskManager: () => import("@/components/TaskManager.vue"),
    DubbingRecorder: () => import("@/components/Audio/DubbingRecorder.vue"),
    AudioTracks,
  },
  watch: {
    snackbarMessage(msg) {
      const errorKeywords = ['erreur', 'error', 'échoué', 'impossible', 'indisponible', 'vide', 'aucun', 'trop volumineux', 'réservé'];
      const isError = errorKeywords.some(kw => msg.toLowerCase().includes(kw));
      this.snackbarColor = isError ? 'error' : 'success';
    },
    bottomTab() {
      this.$nextTick(() => {
        this.refreshRythmoMeasurements();
      });
    },
    subtitles: {
      deep: true,
      handler(newVal) {
        // Synchroniser les changements vers sourceSubtitles ou targetSubtitles en mode double bande
        if (this.doubleBandMode) {
          if (this.settings.language === this.sourceLang) {
            // Si on édite la langue source, copier les changements vers sourceSubtitles
            this.sourceSubtitles = [...newVal];
          } else if (this.settings.language === this.targetLang) {
            // Si on édite la langue cible, copier les changements vers targetSubtitles
            this.targetSubtitles = [...newVal];
          }
        }

        // Marquer comme modifié pour l'auto-save
        this.markAsModified();
      },
    },

    settings: {
      deep: true,
      handler(newVal) {
        // Marquer comme modifié pour l'auto-save
        this.markAsModified();

        // Sauvegarder les préférences
        this.saveUserPreferences();
      },
    },

    sources: {
      deep: true,
      handler(newVal) {
        // Marquer comme modifié pour l'auto-save
        this.markAsModified();
      },
    },

    videoSectionWidth(newVal) {
      userPreferencesService.savePreference("videoSectionWidth", newVal);
    },

    subtitleSectionWidth(newVal) {
      userPreferencesService.savePreference("subtitleSectionWidth", newVal);
    },

    rythmoSectionHeight(newVal) {
      userPreferencesService.savePreference("rythmoSectionHeight", newVal);
      this.$nextTick(() => {
        this.refreshRythmoMeasurements();
      });
    },
  },
  methods: {
    async checkAndRefreshUserProfile() {
      // Vérifier si l'utilisateur est connecté
      if (!this.$auth || !this.$auth.isAuthenticated) {
        return;
      }

      try {
        console.log("[HomeView] Checking user profile...");
        const currentRole = this.$auth?.user?.role || "free";
        const currentLimits = this.$store?.getters?.GET_LIMITS || {};

        // Détecter une incohérence : utilisateur Pro/Basic mais sans accès audio
        if (
          (currentRole === "pro" || currentRole === "basic") &&
          !currentLimits.hasAudioRecordingAccess
        ) {
          console.log(
            "[HomeView] Detected role/limits mismatch. Refreshing user profile..."
          );

          // Forcer un refresh du token Auth0
          if (this.$auth.getTokenSilently) {
            try {
              await this.$auth.getTokenSilently({ ignoreCache: true });

              // Récupérer les nouvelles données utilisateur
              if (this.$auth.auth0Client && this.$auth.auth0Client.getUser) {
                this.$auth.user = await this.$auth.auth0Client.getUser();
                console.log(
                  "[HomeView] User profile refreshed, new role:",
                  this.$auth.user?.role
                );
              }
            } catch (error) {
              console.warn("[HomeView] Could not refresh token:", error);
            }
          }

          // Mettre à jour les limites dans le store
          if (currentRole === "pro" || currentRole === "basic") {
            const newLimits = {
              projectLimit: Infinity,
              videoDurationLimit: Infinity,
              speechToTextLimit: Infinity,
              aiFilterLimit: Infinity,
              exportLimitPerProject: Infinity,
              hasWatermark: false,
              slowProcessing: false,
              hasAudioRecordingAccess: true,
            };
            this.$store.dispatch("updateLimits", newLimits);
            console.log("[HomeView] Limits updated for Pro/Basic user");
          }
        } else {
          console.log(
            "[HomeView] User profile is consistent. Role:",
            currentRole,
            "Audio access:",
            currentLimits.hasAudioRecordingAccess
          );
        }
      } catch (error) {
        console.error("[HomeView] Error checking user profile:", error);
      }
    },

    loadUserPreferences() {
      console.log("[Preferences] Loading user preferences...");
      const prefs = userPreferencesService.getAllPreferences();

      if (prefs.defaultFontSize) {
        this.settings.fontSize = prefs.defaultFontSize;
        console.log("[Preferences] Font size set to:", prefs.defaultFontSize);
      }

      if (prefs.defaultFontFamily) {
        this.settings.fontFamily = prefs.defaultFontFamily;
      }

      if (prefs.defaultFontColor) {
        this.settings.fontColor = prefs.defaultFontColor;
      }

      if (prefs.defaultBackgroundImage) {
        this.settings.backgroundImage = prefs.defaultBackgroundImage;
      }

      if (prefs.preserveWindowSizes) {
        if (prefs.videoSectionWidth) {
          this.videoSectionWidth = prefs.videoSectionWidth;
        }
        if (prefs.subtitleSectionWidth) {
          this.subtitleSectionWidth = prefs.subtitleSectionWidth;
        }
        if (prefs.rythmoSectionHeight) {
          this.rythmoSectionHeight = prefs.rythmoSectionHeight;
        }
      }

      console.log("[Preferences] User preferences loaded");
    },

    saveUserPreferences() {
      console.log("[Preferences] Saving user preferences...");

      userPreferencesService.savePreferences({
        defaultFontSize: this.settings.fontSize,
        defaultFontFamily: this.settings.fontFamily,
        defaultFontColor: this.settings.fontColor,
        defaultBackgroundImage: this.settings.backgroundImage,
        videoSectionWidth: this.videoSectionWidth,
        subtitleSectionWidth: this.subtitleSectionWidth,
        rythmoSectionHeight: this.rythmoSectionHeight,
      });

      console.log("[Preferences] User preferences saved");
    },

    onAudioTabClick() {
      if (!this.hasAudioRecordingAccess) {
        this.reasonPlan = "audio_recording_locked";
        this.openPopupPlan = true;
      }
    },
    handleSeekToTime(time) {
      console.log("seek to time", time);
      this.$refs.video.currentTime = time;
    },
    resolveDomElement(refTarget) {
      let element = refTarget;

      if (Array.isArray(element)) {
        element = element[0];
      }

      if (element && element.$el) {
        element = element.$el;
      }

      return element || null;
    },
    refreshRythmoMeasurements() {
      const rowbottom = this.resolveDomElement(this.$refs.rowbottom);
      const toolbar = this.resolveDomElement(this.$refs.rythmoToolbar);
      const tabsItems = this.resolveDomElement(this.$refs.rythmoTabsItems);

      this.measuredRythmoContainerHeight = rowbottom?.clientHeight || 0;
      this.measuredRythmoToolbarHeight =
        !this.cinemaMode && toolbar
          ? toolbar.offsetHeight || toolbar.clientHeight || 0
          : 0;
      this.measuredRythmoTabsHeight = tabsItems?.clientHeight || 0;
    },
    setupRythmoResizeObserver() {
      if (typeof ResizeObserver === "undefined" || this.rythmoResizeObserver) {
        return;
      }

      this.rythmoResizeObserver = new ResizeObserver(() => {
        this.refreshRythmoMeasurements();
      });

      this.$nextTick(() => {
        const elements = [
          this.resolveDomElement(this.$refs.rowbottom),
          this.resolveDomElement(this.$refs.rythmoToolbar),
          this.resolveDomElement(this.$refs.rythmoTabsItems),
        ].filter(Boolean);

        elements.forEach((element) => {
          this.rythmoResizeObserver.observe(element);
        });

        this.refreshRythmoMeasurements();
      });
    },
    cleanupRythmoResizeObserver() {
      if (!this.rythmoResizeObserver) {
        return;
      }

      this.rythmoResizeObserver.disconnect();
      this.rythmoResizeObserver = null;
    },
    getDetectionMarkerHeight() {
      return this.doubleBandMode ? this.rythmoElementHeight : this.settings.height;
    },
    guardAudioAccessAndMaybeOpenPlan(e) {
      if (!this.hasAudioRecordingAccess) {
        if (e && e.preventDefault) e.preventDefault();
        this.reasonPlan = "audio_recording_locked";
        this.openPopupPlan = true;
        return true;
      }
      return false;
    },
    // Méthodes pour le mode double bande rythmo
    toggleDoubleBandMode() {
      this.doubleBandMode = !this.doubleBandMode;
      if (this.doubleBandMode) {
        // S'assurer que les langues sont différentes
        if (this.sourceLang === this.targetLang) {
          // Si les deux langues sont identiques, définir des valeurs par défaut logiques
          const availableLangs = this.getAvailableLanguage;
          if (availableLangs.includes("en") && availableLangs.includes("fr")) {
            this.sourceLang = "en";
            this.targetLang = "fr";
          } else if (availableLangs.length >= 2) {
            // Prendre les deux premières langues disponibles
            this.sourceLang = availableLangs[0];
            this.targetLang = availableLangs[1];
          }
        }
        // Charger les sous-titres des deux langues
        this.loadDoubleBandSubtitles();
      } else {
        // Revenir au mode normal
        this.sourceSubtitles = [];
        this.targetSubtitles = [];
        this.changeSubtitlesLanguage();
      }

      // Forcer une mise à jour complète
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    async loadDoubleBandSubtitles() {
      if (!this.workspaceData) return;

      // Vérifier que les langues sont différentes
      if (this.sourceLang === this.targetLang) {
        this.snackbar = true;
        this.snackbarMessage =
          "Les langues source et cible doivent être différentes";
        return;
      }

      // Charger les sous-titres de la langue source
      if (this.sourceLang === "fr") {
        this.sourceSubtitles = this.workspaceData.attributes.subtitles || [];
      } else {
        const sourceLocalization =
          this.workspaceData.attributes.localizations.data.find(
            (map) => map?.attributes?.locale === this.sourceLang
          );
        if (sourceLocalization) {
          const sourceData = await this.$strapi.findOne(
            "workspaces",
            sourceLocalization.id,
            {
              populate: "*",
            }
          );
          this.sourceSubtitles = sourceData.data.attributes.subtitles || [];
        }
      }

      // Charger les sous-titres de la langue cible
      if (this.targetLang === "fr") {
        this.targetSubtitles = this.workspaceData.attributes.subtitles || [];
      } else {
        const targetLocalization =
          this.workspaceData.attributes.localizations.data.find(
            (map) => map?.attributes?.locale === this.targetLang
          );
        if (targetLocalization) {
          const targetData = await this.$strapi.findOne(
            "workspaces",
            targetLocalization.id,
            {
              populate: "*",
            }
          );
          this.targetSubtitles = targetData.data.attributes.subtitles || [];
        }
      }

      // S'assurer que les sous-titres ont toutes les propriétés nécessaires
      // Forcer la recalculation des positions Y pour le mode double bande
      this.sourceSubtitles = this.sourceSubtitles.map((sub) => ({
        ...sub,
        y: null,
      }));
      this.targetSubtitles = this.targetSubtitles.map((sub) => ({
        ...sub,
        y: null,
      }));

      this.sourceSubtitles = this.ensureSubtitleProperties(
        this.sourceSubtitles,
        "source"
      );
      this.targetSubtitles = this.ensureSubtitleProperties(
        this.targetSubtitles,
        "target"
      );

      // Log pour debug
      console.log(
        "Double band mode - Source band height:",
        (this.rythmoElementHeight * this.rythmoSplitRatio) / 100
      );
      console.log(
        "Double band mode - Target band height:",
        (this.rythmoElementHeight * (100 - this.rythmoSplitRatio)) / 100
      );
      console.log(
        "Source subtitles Y positions:",
        this.sourceSubtitles.map((s) => ({ text: s.text, y: s.y }))
      );
      console.log(
        "Target subtitles Y positions:",
        this.targetSubtitles.map((s) => ({ text: s.text, y: s.y }))
      );
    },

    ensureSubtitleProperties(subtitles, bandType = null) {
      return subtitles.map((subtitle, index) => {
        if (!subtitle.id) {
          subtitle.id = `temp_${Date.now()}_${index}`;
        }
        if (!subtitle.line) {
          subtitle.line = 0;
        }
        if (!subtitle.y) {
          // Ajuster la hauteur en fonction du type de bande
          let maxHeight = this.settings.height;
          if (this.doubleBandMode && bandType) {
            const availableHeight = this.rythmoElementHeight;
            if (bandType === "source") {
              maxHeight = (availableHeight * this.rythmoSplitRatio) / 100;
            } else {
              maxHeight =
                (availableHeight * (100 - this.rythmoSplitRatio)) / 100;
            }
          }

          // Générer une position Y dans les limites de la bande
          const seed = subtitle.character || "character";
          // Pour le mode double bande, utiliser une position fixe simple centrée dans chaque bande
          if (bandType === "source") {
            // Pour la bande source, position au centre de la bande
            const sourceBandHeight =
              (this.rythmoElementHeight * this.rythmoSplitRatio) / 100;
            subtitle.y = sourceBandHeight / 2 - 20; // Centré avec ajustement pour la hauteur du texte
          } else if (bandType === "target") {
            // Pour la bande cible, position au centre de la bande
            const targetBandHeight =
              (this.rythmoElementHeight * (100 - this.rythmoSplitRatio)) / 100;
            subtitle.y = targetBandHeight / 2 - 20; // Centré avec ajustement pour la hauteur du texte
          } else {
            // Mode normal
            const padding = 60;
            const effectiveHeight = Math.max(30, maxHeight - padding);
            const baseValue = parseInt(seed, 36) % effectiveHeight;
            subtitle.y = Math.max(
              30,
              Math.min(baseValue + 30, effectiveHeight)
            );
          }
        }
        if (subtitle.characterShow === undefined) {
          subtitle.characterShow = true;
        }
        if (!subtitle.letterWidths) {
          subtitle.letterWidths = {};
        }
        return subtitle;
      });
    },

    getSettingsForBand(band) {
      // Adapter les paramètres en fonction de la bande
      const baseSettings = { ...this.settings };

      if (this.doubleBandMode) {
        // Calculer la hauteur disponible pour chaque bande
        const availableHeight = this.rythmoElementHeight;

        if (band === "source") {
          baseSettings.height = (availableHeight * this.rythmoSplitRatio) / 100;
        } else {
          baseSettings.height =
            (availableHeight * (100 - this.rythmoSplitRatio)) / 100;
        }
      }

      return baseSettings;
    },
    getSubtitlesWithAudioCount() {
      if (!this.subtitles.length) return 0;

      let subtitlesWithAudio = 0;

      this.subtitles.forEach((subtitle) => {
        const hasAudio = this.sources.some((source) => {
          return (
            source.character === subtitle.character &&
            source.start <= subtitle.start + 0.5 &&
            source.end >= subtitle.end - 0.5
          );
        });

        if (hasAudio) {
          subtitlesWithAudio++;
        }
      });

      return subtitlesWithAudio;
    },
    // Méthodes de redimensionnement des fenêtres
    handleVerticalResize(resizeData) {
      // Redimensionnement vertical entre vidéo et sous-titres
      const mouseX = resizeData.size;
      const windowWidth = this.innerWidth;

      // La position de la souris détermine directement le pourcentage
      const newVideoWidth = (mouseX / windowWidth) * 100;

      // Contraintes de taille
      if (newVideoWidth >= 20 && newVideoWidth <= 80) {
        this.videoSectionWidth = Math.round(newVideoWidth);
        this.subtitleSectionWidth = Math.round(100 - newVideoWidth);
      }
    },

    handleHorizontalResize(resizeData) {
      // Redimensionnement horizontal pour la section rythmo
      const mouseY = resizeData.size;
      const windowHeight = this.innerHeight; // Hauteur disponible

      // Calculer la hauteur de la section rythmo en fonction de la position de la souris
      // La souris près du bas = section rythmo plus grande
      // La souris vers le haut = section rythmo plus petite
      const availableHeight = windowHeight - 100; // 100px pour les menus et marges
      const rythmoHeightPixels = windowHeight - mouseY;
      const newRythmoHeight = (rythmoHeightPixels / windowHeight) * 100;

      // Contraintes de taille (minimum 15%, maximum 50%)
      if (newRythmoHeight >= 15 && newRythmoHeight <= 50) {
        this.rythmoSectionHeight = Math.round(newRythmoHeight);
        this.$nextTick(() => {
          this.refreshRythmoMeasurements();
        });
      }
    },

    onResizeStart() {
      this.isResizing = true;
    },

    onResizeEnd() {
      this.isResizing = false;
      // Sauvegarder les préférences de taille dans les settings
      this.settings.videoSectionWidth = this.videoSectionWidth;
      this.settings.subtitleSectionWidth = this.subtitleSectionWidth;
      this.settings.rythmoSectionHeight = this.rythmoSectionHeight;
      this.$nextTick(() => {
        this.refreshRythmoMeasurements();
      });
    },
    bulkEditSubtitles(offsetStart) {
      // selected subtitles is just id's
      let selectedSubtitles = this.selectedSubtitles;
      selectedSubtitles.forEach((subtitle) => {
        let subtitleToEdit = this.subtitles.find((sub) => sub.id == subtitle);
        let newStart = subtitleToEdit.start + parseInt(offsetStart);
        let newEnd = subtitleToEdit.end + parseInt(offsetStart);
        let character = this.selectedCharacter;
        subtitleToEdit.start = newStart;
        subtitleToEdit.end = newEnd;
        if (character) {
          subtitleToEdit.character = character;
        }
        if (this.selectedLineChange != null) {
          subtitleToEdit.y =
            this.selectedLineChange * (this.settings.height / 4) || 0;
        }
      });
      this.selectedSubtitles = [];
      this.selectedLineChange = null;
      this.offsetStart = 0;
    },
    checkIfSubtitleIsEmpty() {
      let emptySubtitle = this.subtitles.find(
        (subtitle) => subtitle.text == ""
      );
      if (emptySubtitle) {
        this.snackbar = true;
        this.snackbarMessage = "Un sous-titre est vide";
        return true;
      }
      return false;
    },
    importSubtitles() {
      this.$refs.inputSousTitre.click();
    },
    updateSubtitle(subtitle, innerText) {
      subtitle.text = innerText;

      // Toujours mettre à jour dans la liste principale
      const mainIndex = this.subtitles.findIndex((s) => s.id === subtitle.id);
      if (mainIndex !== -1) {
        this.subtitles[mainIndex].text = innerText;
      }

      // Si on est en mode double bande, synchroniser aussi dans les listes spécifiques
      if (this.doubleBandMode) {
        // Déterminer quelle liste mettre à jour en fonction de la langue active
        if (this.settings.language === this.sourceLang) {
          // On édite la langue source - mettre à jour sourceSubtitles
          const sourceIndex = this.sourceSubtitles.findIndex(
            (s) => s.id === subtitle.id
          );
          if (sourceIndex !== -1) {
            this.$set(this.sourceSubtitles[sourceIndex], "text", innerText);
          }
        } else if (this.settings.language === this.targetLang) {
          // On édite la langue cible - mettre à jour targetSubtitles
          const targetIndex = this.targetSubtitles.findIndex(
            (s) => s.id === subtitle.id
          );
          if (targetIndex !== -1) {
            this.$set(this.targetSubtitles[targetIndex], "text", innerText);
          }
        }

        // Forcer la mise à jour de l'affichage
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    async detectSceneChange() {
      this.loading = true;
      try {
        await this.saveProject();
        await axios.get(
          `${import.meta.env.VITE_APP_TASK_URI}/detect-cut/${
            this.workspace
          }?region=${this.region}`
        );
        this.loadWorkspace();
      } catch (err) {
        this.error = true;
        this.errorMessage = err.message;
        console.error(err);
      }
      this.loading = false;
    },
    updateColor(character, color) {
      try {
        if (!character) return;
        this.$set(this.settings.charactersColors, character, color.hex);
      } catch (err) {
        console.error(err);
      }
    },
    updateBadgeColor(character, color) {
      try {
        if (!character) return;
        this.$set(this.settings.charactersBadgeColors, character, color.hex);
      } catch (err) {
        console.error(err);
      }
    },
    // Nouvelles méthodes pour le système de settings amélioré
    countSubtitlesForCharacter(character) {
      return this.subtitles.filter((sub) => sub.character === character).length;
    },
    resetSettings() {
      // Réinitialiser les paramètres par défaut
      this.settings = {
        ...this.settings,
        fontSize: 20,
        backgroundImage: "/img/templates/br-dark-2.png",
        fontFamily: "Arial",
        fontColor: "#ffffff",
        charactersColors: {},
        charactersBadgeColors: {},
      };
      this.selectedThemes = [];
      this.snackbar = true;
      this.snackbarMessage = "Paramètres réinitialisés";
    },
    applySettings() {
      // Fermer le dialogue et sauvegarder
      this.openSettings = false;
      this.snackbar = true;
      this.snackbarMessage = "Paramètres appliqués avec succès";
    },
    changeBackgroundColor(color) {
      let url = `/img/templates/br-${color}-min.png`;
      this.settings.backgroundImage = url;
    },
    incrementSpeedRate() {
      let speedRatesAvailables = [0.2, 0.5, 0.75, 1, 1.25, 1.5, 2];
      let index = speedRatesAvailables.findIndex(
        (rate) => rate == this.videoSpeedRate
      );
      if (index == speedRatesAvailables.length - 1) {
        this.videoSpeedRate = speedRatesAvailables[0];
      } else {
        this.videoSpeedRate = speedRatesAvailables[index + 1];
      }
    },
    async audioDenoiser() {
      this.loading = true;
      try {
        await this.saveProject();
        await axios.get(
          `${import.meta.env.VITE_APP_TASK_URI}/denoise/${
            this.workspace
          }?region=${this.region}`
        );
        this.loadWorkspace();
      } catch (err) {
        console.error(err);
        this.error = true;
        this.errorMessage = err.message;
      }
      this.loading = false;
    },
    async audioRemoveVoice() {
      this.loading = true;
      this.snackbarMessage = "Traitement de l'audio en cours avec IA...";
      this.snackbar = true;

      try {
        // Créer un contexte audio pour extraire l'audio de la vidéo
        const audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();

        // Obtenir l'URL de la vidéo actuelle
        const videoUrl = this.$refs.video.src;

        // Charger l'audio depuis la vidéo
        const response = await fetch(videoUrl);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        // Convertir l'AudioBuffer en WAV pour l'envoyer au serveur
        const wavBlob = await this.audioBufferToWav(audioBuffer);

        // Vérifier la taille du fichier
        const sizeMB = wavBlob.size / (1024 * 1024);
        console.log(`Taille de l'audio: ${sizeMB.toFixed(2)} MB`);

        let finalBlob = wavBlob;
        if (sizeMB > 90) {
          // Si le fichier est trop gros, proposer des alternatives
          const compress = confirm(
            `L'audio fait ${sizeMB.toFixed(
              2
            )} MB. Voulez-vous réduire la qualité pour accélérer le traitement ?`
          );
          if (compress) {
            // Réduire le sample rate pour diminuer la taille
            const reducedBuffer = await this.downsampleAudioBuffer(
              audioBuffer,
              22050
            ); // 22kHz au lieu de 44.1kHz
            finalBlob = await this.audioBufferToWav(reducedBuffer);
            console.log(
              `Taille réduite: ${(finalBlob.size / (1024 * 1024)).toFixed(
                2
              )} MB`
            );
          }
        }

        // Créer FormData pour l'upload
        const formData = new FormData();
        formData.append("audio", finalBlob, "audio.wav");

        // Envoyer au serveur pour traitement avec vocal-remover
        this.snackbarMessage = "Envoi au serveur pour traitement IA avancé...";
        this.snackbar = true;

        let processedBlob;

        const processResponse = await fetch(
          `${import.meta.env.VITE_APP_TASK_URI}/remove-voice`,
          {
            method: "POST",
            body: formData,
          }
        );

        if (!processResponse.ok) {
          let errorData;
          try {
            errorData = await processResponse.json();
          } catch (e) {
            // Si la réponse n'est pas du JSON valide
            throw new Error(
              `Erreur serveur (${processResponse.status}): ${processResponse.statusText}`
            );
          }

          // Gérer spécifiquement l'erreur de taille de fichier
          if (
            errorData.code === "FILE_TOO_LARGE" ||
            processResponse.status === 413
          ) {
            this.snackbarMessage =
              "Fichier trop volumineux ! Réduction automatique de la qualité...";
            this.snackbar = true;

            // Réduire automatiquement la qualité
            const reducedBuffer = await this.downsampleAudioBuffer(
              audioBuffer,
              16000
            ); // 16kHz
            const reducedWavBlob = await this.audioBufferToWav(reducedBuffer);
            console.log(
              `Taille auto-réduite: ${(
                reducedWavBlob.size /
                (1024 * 1024)
              ).toFixed(2)} MB`
            );

            // Réessayer avec l'audio réduit
            const retryFormData = new FormData();
            retryFormData.append("audio", reducedWavBlob, "audio.wav");

            const retryResponse = await fetch(
              `${import.meta.env.VITE_APP_TASK_URI}/remove-voice`,
              {
                method: "POST",
                body: retryFormData,
              }
            );

            if (!retryResponse.ok) {
              throw new Error(
                "Impossible de traiter l'audio même après réduction"
              );
            }

            const processedArrayBuffer = await retryResponse.arrayBuffer();
            processedBlob = new Blob([processedArrayBuffer], {
              type: "audio/wav",
            });
          } else {
            throw new Error(errorData.message || "Erreur lors du traitement");
          }
        } else {
          // Récupérer l'audio traité si pas d'erreur
          const processedArrayBuffer = await processResponse.arrayBuffer();
          processedBlob = new Blob([processedArrayBuffer], {
            type: "audio/wav",
          });
        }

        // Créer un nouveau fichier audio pour chaque personnage
        const timestamp = this.$moment().unix();
        const newSources = [];

        // Traiter chaque source audio existante
        for (const source of this.sources) {
          if (source.character === "all") {
            // Remplacer la source principale par l'audio sans voix
            const newSource = {
              ...source,
              name: `${timestamp}_novocal_ai`,
              src: URL.createObjectURL(processedBlob),
              processed: true,
              processedWithAI: true,
              originalSrc: source.src, // Garder l'original
            };
            newSources.push(newSource);
          } else {
            // Conserver les autres sources
            newSources.push(source);
          }
        }

        // Si aucune source 'all' n'existe, créer une nouvelle
        if (!this.sources.find((s) => s.character === "all")) {
          newSources.push({
            id: this.sources.length + 1,
            name: `${timestamp}_novocal_ai`,
            character: "all",
            duration: this.videoDuration * this.timelineSize,
            start: 0,
            end: this.videoDuration,
            src: URL.createObjectURL(processedBlob),
            processed: true,
            processedWithAI: true,
          });
        }

        // Mettre à jour les sources
        this.sources = newSources;

        // Activer automatiquement l'option pour utiliser l'audio traité
        this.settings.useProcessedAudio = true;

        // Proposer de télécharger l'audio traité
        this.downloadProcessedAudio(processedBlob);

        this.snackbarMessage =
          "Audio traité avec succès par IA ! Les voix ont été supprimées de manière avancée.";
        this.snackbar = true;
      } catch (err) {
        console.error("Erreur lors de la suppression des voix:", err);
        this.error = true;
        this.errorMessage = `Erreur lors du traitement audio: ${err.message}`;

        // Fallback sur la méthode locale si le serveur échoue
        if (err.message.includes("fetch") || err.message.includes("network")) {
          this.snackbarMessage =
            "Serveur indisponible, utilisation de la méthode locale...";
          this.snackbar = true;
          await this.audioRemoveVoiceLocal();
        }
      }

      this.loading = false;
    },
    // Méthode de fallback locale (phase cancellation)
    async audioRemoveVoiceLocal() {
      try {
        const audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();
        const videoUrl = this.$refs.video.src;
        const response = await fetch(videoUrl);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        if (audioBuffer.numberOfChannels < 2) {
          throw new Error(
            "Audio mono détecté. La méthode locale nécessite du stéréo."
          );
        }

        const outputBuffer = audioContext.createBuffer(
          2,
          audioBuffer.length,
          audioBuffer.sampleRate
        );
        const leftChannel = audioBuffer.getChannelData(0);
        const rightChannel = audioBuffer.getChannelData(1);
        const outputLeft = outputBuffer.getChannelData(0);
        const outputRight = outputBuffer.getChannelData(1);

        for (let i = 0; i < audioBuffer.length; i++) {
          const difference = (leftChannel[i] - rightChannel[i]) / 2;
          const bassBoost = (leftChannel[i] + rightChannel[i]) * 0.1;
          outputLeft[i] = difference + bassBoost;
          outputRight[i] = -difference + bassBoost;
        }

        const wavBlob = await this.audioBufferToWav(outputBuffer);
        const timestamp = this.$moment().unix();

        // Mettre à jour les sources avec l'audio traité localement
        this.sources = this.sources.map((source) => {
          if (source.character === "all") {
            return {
              ...source,
              name: `${timestamp}_novocal_local`,
              src: URL.createObjectURL(wavBlob),
              processed: true,
              processedLocally: true,
              originalSrc: source.src,
            };
          }
          return source;
        });

        this.settings.useProcessedAudio = true;
        this.snackbarMessage = "Audio traité localement (méthode basique)";
        this.snackbar = true;
      } catch (err) {
        console.error("Erreur méthode locale:", err);
        throw err;
      }
    },
    // Fonction pour télécharger l'audio traité
    downloadProcessedAudio(blob) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `audio_sans_voix_${this.$moment().format(
        "YYYY-MM-DD_HH-mm-ss"
      )}.wav`;

      // Créer un dialogue pour demander à l'utilisateur s'il veut télécharger
      if (confirm("Voulez-vous télécharger l'audio sans voix ?")) {
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      // Libérer l'URL après un délai
      setTimeout(() => URL.revokeObjectURL(url), 100);
    },
    // Fonction pour restaurer l'audio original
    restoreOriginalAudio() {
      const processedSources = this.sources.filter(
        (source) => source.processed && source.originalSrc
      );

      if (processedSources.length === 0) {
        this.snackbarMessage = "Aucun audio traité à restaurer";
        this.snackbar = true;
        return;
      }

      // Restaurer les sources originales
      this.sources = this.sources.map((source) => {
        if (source.processed && source.originalSrc) {
          return {
            ...source,
            src: source.originalSrc,
            processed: false,
            originalSrc: undefined,
          };
        }
        return source;
      });

      // Désactiver l'option d'utiliser l'audio traité
      this.settings.useProcessedAudio = false;

      this.snackbarMessage = "Audio original restauré";
      this.snackbar = true;
    },
    // Fonction pour ouvrir le dialogue de remplacement vidéo sans voix
    replaceVideoNoVocal() {
      // Réinitialiser les variables
      this.replaceVideoStep = 1;
      this.replaceVideoTaskId = null;
      this.confirmReplace = false;

      // Ouvrir le dialogue
      this.replaceVideoDialog = true;
    },

    // Fonction pour démarrer le remplacement de la vidéo
    async startReplaceVideo() {
      this.replaceVideoProcessing = true;

      try {
        // Sauvegarder le projet d'abord
        await this.saveProject();

        // Lancer la task de remplacement
        const response = await fetch(
          `${import.meta.env.VITE_APP_TASK_URI}/replace-video-novocal/${
            this.workspace
          }`,
          {
            method: "POST",
          }
        );

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message || "Erreur lors du remplacement");
        }

        const result = await response.json();
        this.replaceVideoTaskId = result.taskId;

        // Notification de succès
        this.snackbarMessage = "✅ Tâche de remplacement créée avec succès !";
        this.snackbar = true;

        // Vérifier régulièrement le statut de la tâche
        const checkTaskStatus = async () => {
          await this.getTasks();
          const task = this.tasks.find((t) => t.id === result.taskId);

          if (task && task.attributes.state === "done") {
            // Tâche terminée, recharger le workspace
            this.snackbarMessage =
              "🎉 Vidéo remplacée avec succès ! Rechargement...";
            this.snackbar = true;

            // Fermer le dialogue
            this.replaceVideoDialog = false;

            // Attendre un peu avant de recharger
            setTimeout(async () => {
              await this.loadWorkspace();

              // Réinitialiser les sources audio car la vidéo a changé
              this.sources = [];
              this.settings.useProcessedAudio = false;

              this.snackbarMessage =
                "✨ Projet rechargé avec la nouvelle vidéo sans voix !";
              this.snackbar = true;
            }, 2000);
          } else if (task && task.attributes.state === "failed") {
            this.replaceVideoDialog = false;
            throw new Error("La tâche a échoué");
          } else {
            // Continuer à vérifier
            setTimeout(checkTaskStatus, 2000);
          }
        };

        // Commencer à vérifier après 2 secondes
        setTimeout(checkTaskStatus, 2000);
      } catch (err) {
        console.error("Erreur lors du remplacement de la vidéo:", err);
        this.error = true;
        this.errorMessage = `Erreur : ${err.message}`;
        this.replaceVideoDialog = false;
      } finally {
        this.replaceVideoProcessing = false;
      }
    },
    // Fonction utilitaire pour convertir AudioBuffer en WAV
    audioBufferToWav(buffer) {
      const length = buffer.length * buffer.numberOfChannels * 2 + 44;
      const arrayBuffer = new ArrayBuffer(length);
      const view = new DataView(arrayBuffer);
      const channels = [];
      let offset = 0;
      let pos = 0;

      // Écrire l'en-tête WAV
      const setUint16 = (data) => {
        view.setUint16(pos, data, true);
        pos += 2;
      };

      const setUint32 = (data) => {
        view.setUint32(pos, data, true);
        pos += 4;
      };

      // RIFF identifier
      setUint32(0x46464952);
      // file length - 8
      setUint32(length - 8);
      // WAVE identifier
      setUint32(0x45564157);
      // fmt sub-chunk identifier
      setUint32(0x20746d66);
      // fmt chunk length
      setUint32(16);
      // sample format (raw)
      setUint16(1);
      // channel count
      setUint16(buffer.numberOfChannels);
      // sample rate
      setUint32(buffer.sampleRate);
      // byte rate (sample rate * block align)
      setUint32(buffer.sampleRate * buffer.numberOfChannels * 2);
      // block align (channel count * bytes per sample)
      setUint16(buffer.numberOfChannels * 2);
      // bits per sample
      setUint16(16);
      // data sub-chunk identifier
      setUint32(0x61746164);
      // data chunk length
      setUint32(length - pos - 4);

      // Écrire les données audio entrelacées
      for (let i = 0; i < buffer.numberOfChannels; i++) {
        channels.push(buffer.getChannelData(i));
      }

      while (pos < length) {
        for (let i = 0; i < buffer.numberOfChannels; i++) {
          let sample = Math.max(-1, Math.min(1, channels[i][offset]));
          sample = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
          view.setInt16(pos, sample, true);
          pos += 2;
        }
        offset++;
      }

      return new Blob([arrayBuffer], { type: "audio/wav" });
    },
    // Fonction pour réduire le sample rate d'un AudioBuffer
    async downsampleAudioBuffer(buffer, targetSampleRate) {
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      const offlineContext = new OfflineAudioContext(
        buffer.numberOfChannels,
        buffer.duration * targetSampleRate,
        targetSampleRate
      );

      const source = offlineContext.createBufferSource();
      source.buffer = buffer;
      source.connect(offlineContext.destination);
      source.start(0);

      return await offlineContext.startRendering();
    },

    cutSubtitle(subtitle, firstPart, secondPart) {
      this.subtitles = this.subtitles.filter((sub) => sub.id != subtitle.id);
      this.subtitles.push(firstPart);
      this.subtitles.push(secondPart);
    },
    checkFrameratePlan() {
      if (this.$auth?.user?.role != "pro" && this.settings.framerate > 60) {
        this.openPopupPlan = true;
        this.$nextTick(() => {
          this.settings.framerate = 60;
          // this.$forceUpdate()
        });
      }
    },
    checkAIAudioPlan() {
      let hasAISources = this.sources.find((map) => map.subtitle_id);
      return hasAISources;
    },
    async createLanguage(lang) {
      // save project
      await this.saveProject();
      // create language
      await axios.post(
        `${import.meta.env.VITE_APP_API_URI}/api/workspaces/${
          this.workspace
        }/localizations`,
        {
          locale: lang,
        }
      );
      // reload workspace
      this.loadWorkspace();
    },
    deleteTask(id) {
      this.$strapi.delete("tasks", id);
      this.getTasks();
    },
    async loadEvent() {
      console.log("loaded");
    },
    getLevelHeightOfSelectedCharacter() {
      let charactersIndex = this.getArrayOfAvailableCharacter.findIndex(
        (character) => character == this.selectedCharacter
      );
      let height = 0;
      if (charactersIndex == 0) {
        height = 0;
      } else {
        height = charactersIndex * 60;
      }
      return height;
    },
    async detectSubtitles() {
      this.loading = true;
      try {
        await this.saveProject();
        await axios.get(
          `${import.meta.env.VITE_APP_TASK_URI}/speechtotext/${
            this.workspace
          }?region=${this.region}`
        );
        this.loadWorkspace();
      } catch (err) {
        console.error(err);
        this.error = true;
        this.errorMessage = err.message;
      }
      this.loading = false;
    },
    async changeSubtitlesLanguage() {
      let lang = this.settings.language;
      if (lang == "fr") {
        this.subtitles = this.workspaceData.attributes.subtitles;
        this.sources = this.workspaceData.attributes.audiojson;
      } else {
        this.subtitles =
          this.workspaceData.attributes.localizations.data.find(
            (map) => map?.attributes?.locale == lang
          )?.attributes?.subtitles || [];
        let localizedData =
          this.workspaceData.attributes.localizations.data.find(
            (map) => map?.attributes?.locale == lang
          );
        localizedData = await this.$strapi.findOne(
          "workspaces",
          localizedData.id,
          {
            populate: "*",
          }
        );
        localizedData = localizedData.data;
        let audiojson = localizedData.attributes.audiojson;
        console.log("audiojson for lang", audiojson);
        let sources = audiojson;
        if (audiojson) {
          for (let i = 0; i < sources.length; i++) {
            if (!sources[0].id) {
              sources[i].id = i;
            }
            if (!sources[i].muted) {
              sources[i].muted = false;
            }
            // data.attributes.audios.data[0].attributes.name
            if (
              localizedData.attributes.audios.data.find(
                (audio) => audio.attributes.name == sources[i].name
              )
            ) {
              sources[i].src = localizedData.attributes.audios.data.find(
                (audio) => audio.attributes.name == sources[i].name
              ).attributes.url;
            }
          }
          this.sources = sources;
        }
      }

      // Si on est en mode double bande, recharger aussi les sous-titres pour les deux langues
      if (this.doubleBandMode) {
        await this.loadDoubleBandSubtitles();
      }
    },
    async generateSubtitles() {
      this.loading = true;
      try {
        await this.saveProject();
        await axios.get(
          `${import.meta.env.VITE_APP_TASK_URI}/translate/${
            this.workspace
          }?region=${this.region}&lang=${this.isoLang}`
        );
        this.loadWorkspace();
      } catch (err) {
        console.error(err);
        this.error = err;
        this.errorMessage = err.message;
      }
      this.loading = false;
    },
    swipeMove(dir) {
      console.log("editing subtitle", this.isEditingSubtitle);
      if (this.isEditingSubtitle) return;
      let offsetX = dir.touchmoveX - dir.touchstartX;
      if (offsetX < -100) {
        this.$refs.video.currentTime += 1 / this.base_rate;
      } else if (offsetX > 100) {
        this.$refs.video.currentTime -= 1 / this.base_rate;
      }
    },
    speakingRateChange($event) {
      this.generateAudio($event.id);
    },
    async generateAudio(id = null) {
      this.loading = true;
      try {
        await this.saveProject();
        await axios.get(
          `${import.meta.env.VITE_APP_TASK_URI}/vocalize/${
            this.workspace
          }?subtitle_id=${id}&lang=${this.isoLang}&region=${this.region}`
        );
        this.loadWorkspace();
      } catch (err) {
        console.error(err);
        this.error = err;
        this.errorMessage = err.message;
      }
      this.loading = false;
    },
    muteAudio(sourcesMerged) {
      sourcesMerged.forEach((source) => {
        source.muted = !source.muted;
        // Mute visual waveform (optional, for visual feedback)
        if (
          this.$refs[`audio${source.character}${source.id}`] &&
          this.$refs[`audio${source.character}${source.id}`][0]
        ) {
          // this.$refs[`audio${source.character}${source.id}`][0].toggleMute();
        }
        // Mute actual audio player
        const playerRef =
          this.$refs[`audioPlayer${source.character}${source.id}`];
        if (playerRef && playerRef[0]) {
          playerRef[0].muted = source.muted;
        }
      });
    },
    async createExportTask() {
      if (this.checkIfSubtitleIsEmpty()) return;
      // if is not pro or basic and isTaskAlreadyExecuted return
      if (this.isTaskAlreadyExecuted) {
        if (
          this.$auth?.user?.role != "basic" &&
          this.$auth?.user?.role != "pro"
        ) {
          this.openPopupPlan = true;
          this.reasonPlan = "too_many_tasks";
          return;
        }
      }
      this.zoom = 1;
      this.videoTime = 0;
      this.loading = true;
      this.$nextTick(async () => {
        try {
          this.tasks.push({
            attributes: {
              state: "queued",
              progress: 0,
              createdAt: new Date(),
            },
          });
          this.taskPopup = true;
          await this.saveProject();
          if (this.checkAIAudioPlan()) {
            if (
              this.$auth?.user?.role != "basic" &&
              this.$auth?.user?.role != "pro"
            ) {
              this.openPopupPlan = true;
              return;
            }
          }
          this.saveInProgress = true;
          let options = {
            fps: this.settings.framerate < 60 ? 60 : this.settings.framerate,
            iafilter: this.settings.iafilter,
            tiktokMode: this.exportMode == "tiktok",
            without_rythmo: this.settings.without_rythmo,
          };

          // Ajouter les données du canvas si il y en a
          if (
            this.settings.drawingData &&
            this.settings.drawingData.history &&
            this.settings.drawingData.history.length > 0
          ) {
            // Vérifier si l'utilisateur est Pro pour utiliser les dessins
            if (this.$auth?.user?.role !== "pro") {
              this.openPopupPlan = true;
              this.reasonPlan = "drawing_export_pro_only";
              this.loading = false;
              this.saveInProgress = false;
              this.snackbar = true;
              this.snackbarMessage =
                "L'export avec dessins est réservé aux abonnés Pro";
              return;
            }
            options.hasDrawing = true;
            console.log("Canvas de dessin détecté dans les settings du projet");
          }

          let query = `?fps=${options.fps}&iafilter=${
            options.iafilter
          }&tiktokMode=${options.tiktokMode}&without_rythmo=${
            options.without_rythmo
          }&hasDrawing=${options.hasDrawing || false}&region=${this.region}`;
          await axios.get(
            `${import.meta.env.VITE_APP_TASK_URI}/launch-task/${
              this.workspace
            }${query}`
          );

          // Track video export creation
          this.$amplitude.track("Video_Export_Started", {
            fps: options.fps,
            mode: options.tiktokMode ? "tiktok" : "youtube",
            without_rythmo: options.without_rythmo,
            has_drawing: options.hasDrawing || false,
            ia_filter: options.iafilter,
            subtitle_count: this.subtitles.length,
            user_role: this.$auth?.user?.role || "free",
          });
        } catch (err) {
          console.error(err);
          this.error = err;
          this.errorMessage = err.message;
        }
        this.loading = false;
        this.saveInProgress = false;
      });
    },
    heightBySeed(seed) {
      let height = this.settings.height;
      let maxValue = Math.max(50, height - 50);
      let value = (parseInt(seed, 36) % maxValue) + 10;
      if (value < 10) value = 10;
      if (value > maxValue) value = maxValue;
      return value;
    },
    // function to change height of subtitle
    changeToLine(line, subtitle) {
      line = line - 1;
      let baseHeight =
        this.subtitles.find(
          (subtitle) => subtitle.character == this.selectedCharacter
        )?.y || this.heightBySeed(this.selectedCharacter || "character");
      if (line !== null) baseHeight = line * (this.settings.height / 4);
      if (line == 0) {
        baseHeight = 10; // Offset de 10px pour éviter le rognage du badge en ligne 1
      }
      for (let i = 0; i < this.subtitles.length; i++) {
        if (this.subtitles[i].id == subtitle.id) {
          this.$nextTick(() => {
            this.$set(this.subtitles[i], "y", baseHeight || 0);
          });
        }
      }
    },
    createSubtitle(text, line = null) {
      let baseHeight =
        this.subtitles.find(
          (subtitle) => subtitle.character == this.selectedCharacter
        )?.y || this.heightBySeed(this.selectedCharacter || "character");
      if (line !== null) baseHeight = line * (this.settings.height / 4);
      if (line == 0) {
        baseHeight = 10; // Offset de 10px pour éviter le rognage du badge en ligne 1
      }
      this.subtitles.push({
        start: this.$refs.video.currentTime,
        end: this.$refs.video.currentTime + 1,
        line: 0,
        y: baseHeight || 0,
        id: this.subtitles.length + 1,
        text: text || "",
        underline: false,
        dashed: false,
        exclude: false,
        speedrate: 1,
        male: false,
        female: false,
        character: this.selectedCharacter || "character",
        active: true,
        characterShow: true,
      });
      this.operations.push({
        type: "subtitle",
        item: {
          id: this.subtitles.length,
        },
      });
    },
    undo() {
      let lastOperation = this.operations.pop();
      console.log("lastOperation", lastOperation);
      if (!lastOperation) return;
      switch (lastOperation.type) {
        case "subtitle":
          this.subtitles = this.subtitles.filter(
            (subtitle) => subtitle.id != lastOperation.item.id
          );
          break;
        case "item":
          this.ndd.items = this.ndd.items.filter(
            (item) => item.id != lastOperation.item.id
          );
          break;
        case "loop":
          this.ndd.loops = this.ndd.loops.filter(
            (item) => item.id != lastOperation.item.id
          );
          break;
        case "endDialog":
          this.ndd.endDialog = this.ndd.endDialog.filter(
            (item) => item.id != lastOperation.item.id
          );
          break;
        case "svg":
          this.ndd.svg = this.ndd.svg.filter(
            (item) => item.id != lastOperation.item.id
          );
          break;
        case "sceneChange":
          this.ndd.sceneChanges = this.ndd.sceneChanges.filter(
            (item) => item.id != lastOperation.item.id
          );
          break;
        case "note":
          this.ndd.notes = this.ndd.notes.filter(
            (item) => item.id != lastOperation.item.id
          );
          break;
      }
    },
    loadRenderVideo(src) {
      this.outputURL = null;
      this.$nextTick(() => {
        this.renderDone = true;
        this.outputURL = src;
      });
    },
    newProject() {
      if (this.$route.query.workspace) {
        this.$router.push("/");
      }
      this.workspace = null;
      this.subtitles = [];
      this.sources = [];
      this.ndd = {
        sceneChanges: [],
        notes: [],
        endDialog: [],
        loops: [],
        items: [],
        svg: [],
      };
      this.operations = [];
      this.$refs.video.src = "";
    },
    // Audio Handling
    deleteAudioSource(sourceId) {
      this.sources = this.sources.filter((source) => source.id !== sourceId);
    },
    handleInput(e, subtitle) {
      // e.preventDefault();
      subtitle.text = e.target.innerText;
    },
    addItem(item) {
      this.ndd.items.push({
        id: this.ndd.items.length + 1,
        text: item,
        x: this.$refs.video.currentTime * 25 * this.settings.fontSize,
        y: 0,
      });
      this.operations.push({
        type: "item",
        item: {
          id: this.ndd.items.length,
        },
      });
    },
    addLoop() {
      this.ndd.loops.push({
        id: this.ndd.loops.length + 1,
        x: this.$refs.video.currentTime * 25 * this.settings.fontSize,
      });
      this.operations.push({
        type: "loop",
        item: {
          id: this.ndd.loops.length,
        },
      });
    },
    addEndDialog() {
      this.ndd.endDialog.push({
        id: this.ndd.endDialog.length + 1,
        x: this.$refs.video.currentTime * 25 * this.settings.fontSize,
      });
      this.operations.push({
        type: "endDialog",
        item: {
          id: this.ndd.endDialog.length,
        },
      });
    },
    addSvg(id) {
      this.ndd.svg.push({
        id: this.ndd.svg.length + 1,
        x: this.$refs.video.currentTime * 25 * this.settings.fontSize,
        y: 0,
        svg: id,
      });
      this.operations.push({
        type: "svg",
        item: {
          id: this.ndd.svg.length,
        },
      });
    },
    addSceneChange() {
      this.ndd.sceneChanges.push({
        id: this.ndd.sceneChanges.length + 1,
        x: this.$refs.video.currentTime * 25 * this.settings.fontSize,
      });
      this.operations.push({
        type: "sceneChange",
        item: {
          id: this.ndd.sceneChanges.length,
        },
      });
    },
    addNote(text) {
      this.ndd.notes.push({
        id: this.ndd.notes.length + 1,
        x: this.$refs.video.currentTime * 25 * this.settings.fontSize,
        y: 0,
        text: text,
      });
      this.operations.push({
        type: "note",
        item: {
          id: this.ndd.notes.length,
        },
      });
    },
    scrollToTimeline(event) {
      if (
        event.target.id == "timeline" ||
        event.target.id == "offsetDivAudio"
      ) {
        let scroll =
          (event.offsetX / event.target.offsetWidth) * this.videoDuration;
        this.$refs.video.currentTime = scroll - this.offsetDuration;
      }
    },
    scrollTo() {
      // return; originaly scrollTo(subtitle)
      // this.$nextTick(() => {
      //   const overflow = this.$refs.scrollableSub
      //   const anchor = document.getElementById(`su${subtitle}`)
      //   console.log(`su${gitsubtitle}`, anchor)
      //   overflow.scrollTop = anchor.offsetTop - overflow.offsetTop
      // })
    },
    applyStyle(style, subtitle) {
      if (style == "underline") {
        subtitle.underline = !subtitle.underline;
      }
      if (style == "dashed") {
        subtitle.dashed = !subtitle.dashed;
      }
    },
    bufferToWave(abuffer, offset, len) {
      var numOfChan = abuffer.numberOfChannels,
        length = len * numOfChan * 2 + 44,
        buffer = new ArrayBuffer(length),
        view = new DataView(buffer),
        channels = [],
        i,
        sample,
        pos = 0;
      // write WAVE header
      setUint32(0x46464952); // "RIFF"
      setUint32(length - 8); // file length - 8
      setUint32(0x45564157); // "WAVE"
      setUint32(0x20746d66); // "fmt " chunk
      setUint32(16); // length = 16
      setUint16(1); // PCM (uncompressed)
      setUint16(numOfChan);
      setUint32(abuffer.sampleRate);
      setUint32(abuffer.sampleRate * 2 * numOfChan); // avg. bytes/sec
      setUint16(numOfChan * 2); // block-align
      setUint16(16); // 16-bit (hardcoded in this demo)
      setUint32(0x61746164); // "data" - chunk
      setUint32(length - pos - 4); // chunk length
      // write interleaved data
      for (i = 0; i < abuffer.numberOfChannels; i++)
        channels.push(abuffer.getChannelData(i));
      while (pos < length) {
        for (i = 0; i < numOfChan; i++) {
          // interleave channels
          sample = Math.max(-1, Math.min(1, channels[i][offset])); // clamp
          sample = (0.5 + sample < 0 ? sample * 32768 : sample * 32767) | 0; // scale to 16-bit signed int
          view.setInt16(pos, sample, true); // update data chunk
          pos += 2;
        }
        offset++; // next source sample
      }
      // create Blob
      return new Blob([buffer], { type: "audio/mpeg" });
      function setUint16(data) {
        view.setUint16(pos, data, true);
        pos += 2;
      }
      function setUint32(data) {
        view.setUint32(pos, data, true);
        pos += 4;
      }
    },
    async recordAudio(i = false) {
      if (i) {
        this.selectedCharacter = i;
      }

      // Utiliser le nouveau système d'enregistrement intégré
      this.startRecordingWithPreRoll();
    },
    selectCharacterAudio(i) {
      this.resetselectedSubtitle();
      this.$nextTick(() => {
        this.selectedCharacter = i;
      });
    },
    async getAudioBuffer(src) {
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();
      }
      try {
        const response = await fetch(src);
        const arrayBuffer = await response.arrayBuffer();
        return await this.audioContext.decodeAudioData(arrayBuffer);
      } catch (error) {
        console.error("Error loading audio buffer:", error);
        throw error;
      }
    },
    async copyAudioBuffer(buffer, start, end) {
      var segmentDuration = end - start;
      var originalBuffer = buffer;
      // originalBuffer.numberOfChannels,
      // segmentDuration * originalBuffer.sampleRate,
      // originalBuffer.sampleRate
      var emptySegment = new AudioBuffer({
        length: segmentDuration * originalBuffer.sampleRate,
        numberOfChannels: originalBuffer.numberOfChannels,
        sampleRate: originalBuffer.sampleRate,
      });
      for (var i = 0; i < originalBuffer.numberOfChannels; i++) {
        var chanData = originalBuffer.getChannelData(i);
        var emptySegmentData = emptySegment.getChannelData(i);
        var mid_data = chanData.subarray(
          start * originalBuffer.sampleRate,
          end * originalBuffer.sampleRate
        );
        emptySegmentData.set(mid_data);
      }
      var arraybuffer = await toWav(emptySegment);
      return new Blob([arraybuffer], { type: "audio/wav" });
    },
    async decouperSourcesChevauchantes(
      nouvelleSource,
      sources,
      selectedCharacter
    ) {
      let sourcesDecoupees = [];
      for (let i = 0; i < sources.length; i++) {
        let source = sources[i];
        try {
          // Si la source chevauche la nouvelle source
          if (
            source.start < nouvelleSource.end &&
            source.end > nouvelleSource.start &&
            source.character == selectedCharacter
          ) {
            // Découper la source chevauchante en deux parties distinctes
            if (source.start < nouvelleSource.start) {
              let partieAvant = {
                ...source,
                end: nouvelleSource.start,
              };
              let buffer = await this.getAudioBuffer(source.src);
              let cutAudioBuffer = await this.copyAudioBuffer(
                buffer,
                0,
                nouvelleSource.start - source.start
              );
              partieAvant.src = URL.createObjectURL(cutAudioBuffer);
              sourcesDecoupees.push(partieAvant);
            }
            if (
              source.end > nouvelleSource.end &&
              selectedCharacter == nouvelleSource.character
            ) {
              let partieApres = {
                ...source,
                start: nouvelleSource.end,
              };
              let buffer = await this.getAudioBuffer(source.src);
              let cutAudioBuffer = await this.copyAudioBuffer(
                buffer,
                nouvelleSource.end - source.start,
                source.end - source.start
              );
              partieApres.src = URL.createObjectURL(cutAudioBuffer);
              sourcesDecoupees.push(partieApres);
            }
          } else {
            sourcesDecoupees.push(source);
          }
        } catch (err) {
          console.log("err", err);
          sourcesDecoupees.push(source);
        }
      }
      return sourcesDecoupees;
    },
    async stopRecording() {
      this.$refs.video.pause();
      this.isRecording = false;
      this.mediaRecorder.stop();
      let blob = new Blob(this.recordedChunks, {
        type: "video/webm",
      });
      if (!this.selectedCharacter) {
        this.selectedCharacter = this.getArrayOfAvailableCharacter[0];
      }
      var mediaElt = document.createElement("video");
      mediaElt.src = URL.createObjectURL(blob);
      this.recordedChunks = [];
      let newSource = {
        id: this.sources.length + 1,
        name: this.$moment().unix(),
        character: this.selectedCharacter,
        duration: this.$refs.video.currentTime - this.recordStart,
        start: this.recordStart - 0.1 < 0 ? 0 : this.recordStart - 0.1,
        end: this.$refs.video.currentTime,
        src: mediaElt.src,
      };
      // trouver les sources qui chevauche la nouvelle source et les découper en 2
      this.sources = await this.decouperSourcesChevauchantes(
        newSource,
        this.sources,
        this.selectedCharacter
      );
      this.sources.push(newSource);
      // reset source index
      this.sources = this.sources.map((source, index) => {
        source.id = index + 1;
        return source;
      });
      this.isRecording = false;
    },
    async speechReconitionInit() {
      // Récupérer la balise vidéo
      let video = this.$refs.video;
      let startVideo = this.videoTime - 0.5;
      if (startVideo < 0) {
        startVideo = 0;
      }
      this.$refs.video.currentTime = startVideo;
      // timer countdown before recording
      this.timer = 3;
      let timerInterval = setInterval(() => {
        this.timer--;
        if (this.timer === 0) {
          clearInterval(timerInterval);
        }
      }, 1000);
      window.gtag("event", "speech_recognition");
      let start = 0;
      let end = 0;
      // Vérifie si l'API SpeechRecognition est prise en charge par le navigateur
      if (
        "SpeechRecognition" in window ||
        "webkitSpeechRecognition" in window
      ) {
        this.speechRecognition = true;
        // Créer un nouvel objet SpeechRecognition
        let recognition = new (window.SpeechRecognition ||
          window.webkitSpeechRecognition)();
        // Définir la langue de reconnaissance
        recognition.lang = "fr-FR";
        // Écouter les événements de résultat de reconnaissance vocale
        recognition.onresult = (event) => {
          // Obtenir le résultat de la reconnaissance vocale sous forme de texte
          const transcription = event.results[0][0].transcript;
          end = video.currentTime;
          this.subtitles.push({
            id: this.subtitles.length + 1,
            active: true,
            underline: false,
            dashed: false,
            y: this.heightBySeed(this.selectedCharacter || "character") || 0,
            line: 0,
            exclude: false,
            male: false,
            female: false,
            speedrate: 1,
            start: start,
            end: end,
            character: this.selectedCharacter || "character",
            text: transcription,
          });
          this.speechRecognition = false;
        };
        // Écouter les événements d'erreur de reconnaissance vocale
        recognition.onerror = (err) => {
          console.log("err", err);
          this.$refs.video.pause();
        };
        // Écouter l'événement "play" de la vidéo
        this.$refs.video.addEventListener("play", () => {
          if (!video) {
            video = this.$refs.video;
          }
          if (!video) return;
          start = video.currentTime;
          // Démarrer la reconnaissance vocale lorsque la vidéo commence à jouer
          if (this.speechRecognition == true) {
            recognition.start();
          }
        });
        // Écouter l'événement "pause" de la vidéo
        this.$refs.video.addEventListener("pause", () => {
          // Arrêter la reconnaissance vocale lorsque la vidéo est en pause
          recognition.stop();
          this.speechRecognition = false;
          this.$refs.baseaudio.pause();
        });
        // await 3 sec
        await new Promise((resolve) => setTimeout(resolve, 3000));
        this.$refs.video.play();
        await new Promise((resolve) => setTimeout(resolve, 0.5 * 1000));
      }
    },
    enableDeleteItems() {
      this.deleteItems = !this.deleteItems;
    },
    openExportWindow() {
      this.popupExport = true;
    },
    async denoiseAudioData() {
      var adjust = 2;
      const videoElt = this.$refs.video;
      // wait 5 sec
      await new Promise((resolve) => setTimeout(resolve, 5000));
      this.$refs.video.play();
      const audioContext = new AudioContext();
      const sourceNode = audioContext.createMediaElementSource(videoElt);
      const processorNode = audioContext.createScriptProcessor(4096);
      processorNode.onaudioprocess = (e) => {
        var inp0 = e.inputBuffer.getChannelData(0);
        var inp1 = e.inputBuffer.getChannelData(1);
        var out0 = e.outputBuffer.getChannelData(0);
        var out1 = e.outputBuffer.getChannelData(1);
        var i;
        if (this.denoiseAudio) {
          for (i = 0; i < inp0.length; i++) {
            out0[i] = ((inp0[i] - inp1[i]) / 2) * adjust;
            out1[i] = ((inp1[i] - inp0[i]) / 2) * adjust;
          }
        } else {
          for (i = 0; i < inp0.length; i++) {
            out0[i] = inp0[i];
            out1[i] = inp1[i];
          }
        }
      };
      sourceNode.connect(processorNode);
      processorNode.connect(audioContext.destination);
    },
    async getAudioData() {
      // axios arraybuffer
      let audioSource = await fetch(this.$refs.video.src, {
        responseType: "arraybuffer",
      }).then((r) => r.blob());
      if (!this.sources.find((s) => s.character == "all")) {
        this.sources.push({
          id: this.sources.length + 1,
          name: this.$moment().unix(),
          character: "all",
          duration: this.videoDuration * this.timelineSize,
          start: 0,
          end: this.videoDuration,
          src: URL.createObjectURL(audioSource),
        });
      }
    },
    handleDataAvailable(event) {
      if (event.data.size > 0) {
        this.recordedChunks.push(event.data);
      }
    },
    async getLocalMediaStream() {
      let mediaStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
      return mediaStream;
    },
    // Subtitle Handling
    startDragSubtitle(subtitle, type) {
      this.resetselectedSubtitle();
      this.selectedSubtitle = subtitle;
      var end = subtitle[type];
      this.baseDraggingX = end;
      this.selectedSubtitleType = type;
      this.isDragging = this.selectedSubtitle.id;
    },
    dragEnd(event) {
      this.newTime = this.baseDraggingX + event.offsetX / 100;
      this.isDragging = false;
      this.selectedSubtitle[this.selectedSubtitleType] = this.newTime;
      this.newTime = false;
      this.resetselectedSubtitle();
    },
    resetSubtitles() {
      this.subtitles = [];
    },
    resetselectedSubtitle() {
      this.selectedSubtitle = { id: null };
    },
    // seconds = 0.00
    transformSecondsToTime(time, format) {
      // output format 00:00:00,000 without $moment
      if (format == "00:00:00,000") {
        let hours = Math.floor(time / 3600);
        let minutes = Math.floor((time - hours * 3600) / 60);
        let seconds = Math.floor(time - hours * 3600 - minutes * 60);
        let milliseconds = Math.floor((time - Math.floor(time)) * 1000);
        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        if (milliseconds < 10) {
          milliseconds = "00" + milliseconds;
        } else if (milliseconds < 100) {
          milliseconds = "0" + milliseconds;
        }
        return hours + ":" + minutes + ":" + seconds + "," + milliseconds;
      } else if (format == "0:00:00.00") {
        let hours = Math.floor(time / 3600);
        let minutes = Math.floor((time - hours * 3600) / 60);
        let seconds = Math.floor(time - hours * 3600 - minutes * 60);
        let milliseconds = Math.floor((time - Math.floor(time)) * 100);
        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        if (milliseconds < 10) {
          milliseconds = "00" + milliseconds;
        } else if (milliseconds < 100) {
          milliseconds = "0" + milliseconds;
        }
        return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
      }
    },
    exportToSrt() {
      // Gate: only PRO can export projects longer than 10 minutes
      if (!this.gateLongDuration("export")) return;

      // Track export event
      this.$amplitude.track("Export", {
        format: "srt",
        subtitle_count: this.subtitles.length,
        duration: this.getDurationSecondsFromSubtitles(),
        user_role: this.$auth?.user?.role || "free",
      });

      let srttext = "";
      this.subtitles.forEach((subtitle, index) => {
        srttext += `${index + 1}\n`;
        // format is 01:MM:ss,SSS
        let start = this.transformSecondsToTime(subtitle.start, "00:00:00,000");
        let end = this.transformSecondsToTime(subtitle.end, "00:00:00,000");
        // want 00:MM:ss,SSS
        srttext += `${start} --> ${end}\n`;
        srttext += `${subtitle.text}\n\n`;
      });
      let dataStr =
        "data:text/srt;charset=utf-8," + encodeURIComponent(srttext);
      let downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", "subtitles.srt");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
    },
    exportToAss() {
      // Gate: only PRO can export projects longer than 10 minutes
      if (!this.gateLongDuration("export")) return;

      // Track export event
      this.$amplitude.track("Export", {
        format: "ass",
        subtitle_count: this.subtitles.length,
        duration: this.getDurationSecondsFromSubtitles(),
        user_role: this.$auth?.user?.role || "free",
      });

      let asstext = "";
      asstext += "[Script Info]\n";
      asstext += "; Script generated by Voxdub\n";
      asstext += "; https://voxdub.com/\n";
      asstext += "PlayResY: 600\n";
      asstext += "WrapStyle: 2\n";
      asstext += "\n";
      asstext += "[V4+ Styles]\n";
      asstext +=
        "Format: Name, Fontname, Fontsize, PrimaryColour, SecondaryColour, OutlineColour, BackColour, Bold, Italic, Underline, StrikeOut, ScaleX, ScaleY, Spacing, Angle, BorderStyle, Outline, Shadow, Alignment, MarginL, MarginR, MarginV, Encoding\n";
      asstext +=
        "Style: Code,monospace,20,&H00B0B0B0,&H00B0B0B0,&H00303030,&H80000008,-1,0,0,0,100,100,0,0,1,1,2,7,30,10,30,0\n";
      asstext +=
        "Style: Expl,Arial,28,&H00FFB0B0,&H00B0B0B0,&H00303030,&H80000008,-1,0,0,0,100,100,0,0,1,1,2,7,30,10,30,0\n";
      asstext += "\n";
      // [Events]
      // Format: Layer, Start, End, Style, Name, MarginL, MarginR, MarginV, Effect, Text
      asstext += "[Events]\n";
      asstext +=
        "Format: Layer, Start, End, Style, Name, MarginL, MarginR, MarginV, Effect, Text\n";
      this.subtitles.forEach((subtitle) => {
        // format is 01:MM:ss,SSS
        let start = this.transformSecondsToTime(subtitle.start, "0:00:00.00");
        let end = this.transformSecondsToTime(subtitle.end, "0:00:00.00");
        // want 00:MM:ss,SSS
        asstext += `Dialogue: 1,${start},${end},Default,${subtitle.character},0,0,0,,${subtitle.text}\n`;
      });
      let dataStr =
        "data:text/ass;charset=utf-8," + encodeURIComponent(asstext);
      let downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", "subtitles.ass");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
    },
    importDETX() {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = ".detx";

      fileInput.onchange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        this.loading = true;

        try {
          const formData = new FormData();
          formData.append("file", file);

          const response = await fetch(
            `${import.meta.env.VITE_APP_TASK_URI}/parse-detx`,
            {
              method: "POST",
              body: formData,
            }
          );

          if (!response.ok) {
            throw new Error("Erreur lors du parsing du fichier DETX");
          }

          const result = await response.json();

          if (result.data && result.data.dialogues) {
            const subtitles = [];
            result.data.dialogues.forEach((dialogue, index) => {
              subtitles.push({
                id: index,
                start: this.timecodeToSeconds(dialogue.timecodeIn),
                end: this.timecodeToSeconds(dialogue.timecodeOut),
                text: dialogue.text,
                character: dialogue.roleName,
                voice: dialogue.voice || "on",
              });
            });

            this.subtitles = subtitles;
            this.detxData = result.data;

            // Afficher un message de succès
            this.snackbarMessage = `Fichier DETX importé avec succès : ${result.data.statistics.totalLines} lignes de dialogue`;
            this.snackbar = true;
          }
        } catch (error) {
          console.error("Erreur import DETX:", error);
          this.snackbarMessage =
            "Erreur lors de l'import du fichier DETX. Vérifiez que le serveur API est démarré.";
          this.snackbar = true;
        } finally {
          this.loading = false;
        }
      };

      fileInput.click();
    },
    exportDETX() {
      // Gate: only PRO can export projects longer than 10 minutes
      if (!this.gateLongDuration("export")) return;

      // Track export event
      this.$amplitude.track("Export", {
        format: "detx",
        subtitle_count: this.subtitles.length,
        duration: this.getDurationSecondsFromSubtitles(),
        user_role: this.$auth?.user?.role || "free",
      });

      // Vérifier qu'on a des sous-titres
      if (!this.subtitles || this.subtitles.length === 0) {
        this.snackbarMessage = "Aucun sous-titre à exporter";
        this.snackbar = true;
        return;
      }

      this.loading = true;

      // Préparer les données pour l'export DETX
      const exportData = {
        title: this.workspace?.title || this.video?.name || "Projet Voxdub",
        framerate: this.settings?.framerate || 25,
        language: this.settings?.language || "fr-FR",
        duration: this.videoDuration || 0,
        videoPath: this.video?.src || "",
        audioPath: "",
        episode: {
          number: 1,
          season: 1,
          title: this.workspace?.title || "",
        },
        subtitles: this.subtitles.map((subtitle) => ({
          start: subtitle.start || 0,
          end: subtitle.end || subtitle.start + 1,
          text: subtitle.text || "",
          character: subtitle.character || "Narrateur",
          voice: subtitle.voice || "on",
          track: subtitle.track || "1",
          color: subtitle.color || "#000000",
          backgroundColor: subtitle.backgroundColor || "#000000",
          description: subtitle.description || "",
        })),
      };

      // Appeler l'API pour générer le DETX
      fetch(`${import.meta.env.VITE_APP_TASK_URI}/export-detx`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(exportData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Erreur lors de l'export DETX");
          }
          return response.blob();
        })
        .then((blob) => {
          // Télécharger le fichier
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${
            this.workspace?.title || "export"
          }_${Date.now()}.detx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);

          this.snackbarMessage = "Export DETX réussi";
          this.snackbar = true;
        })
        .catch((error) => {
          console.error("Erreur export DETX:", error);
          this.snackbarMessage = "Erreur lors de l'export DETX";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportCroisille() {
      // Gate: only PRO can export projects longer than 10 minutes
      if (!this.gateLongDuration("export")) return;

      // Track export event
      this.$amplitude.track("Export", {
        format: "croisille",
        subtitle_count: this.subtitles.length,
        duration: this.getDurationSecondsFromSubtitles(),
        user_role: this.$auth?.user?.role || "free",
      });

      // Vérifier qu'on a des données DETX ou des sous-titres
      if (!this.detxData && !this.subtitles.length) {
        this.snackbarMessage =
          "Veuillez d'abord importer un fichier DETX ou avoir des sous-titres";
        this.snackbar = true;
        return;
      }

      // Ouvrir le dialog d'export
      this.detxExportDialog = true;
    },
    async performCroisilleExport() {
      this.detxExportDialog = false;
      this.loading = true;

      try {
        // Sauvegarder le projet avant l'export
        try {
          await this.saveProject();
        } catch (e) {
          console.warn(
            "Sauvegarde avant export échouée, tentative d'export quand même:",
            e
          );
        }

        // Préparer les données pour l'export
        let dataToExport = this.detxData;

        // Si pas de données DETX, créer un format minimal depuis les sous-titres
        if (!dataToExport) {
          dataToExport = this.convertSubtitlesToDETXFormat(this.subtitles);
        }

        // Inject workspace NDD and settings so the server can regroup by loops
        if (dataToExport && typeof dataToExport === "object") {
          dataToExport = {
            ...dataToExport,
            ndd: this.ndd,
            settings: this.settings,
          };
        }

        const response = await fetch(
          `${import.meta.env.VITE_APP_TASK_URI}/export-croisille/${
            this.detxExportFormat
          }`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              detxData: dataToExport,
              ndd: this.ndd,
              settings: this.settings,
            }),
          }
        );

        if (!response.ok) {
          throw new Error(
            `Erreur lors de l'export en ${this.detxExportFormat}`
          );
        }

        if (this.detxExportFormat === "json") {
          const data = await response.json();
          console.log("Croisillé JSON:", data);
          this.snackbarMessage =
            "Les données du croisillé ont été affichées dans la console";
          this.snackbar = true;
        } else {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `croisille_${Date.now()}.${
            this.detxExportFormat === "excel" ? "xlsx" : this.detxExportFormat
          }`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);

          this.snackbarMessage = `Croisillé exporté en ${this.detxExportFormat.toUpperCase()} avec succès`;
          this.snackbar = true;
        }
      } catch (error) {
        console.error("Erreur export croisillé:", error);
        this.snackbarMessage =
          "Erreur lors de l'export du croisillé. Vérifiez que le serveur API est démarré.";
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },
    convertSubtitlesToDETXFormat(subtitles) {
      // Convertir les sous-titres au format DETX minimal pour l'export
      const roles = new Map();
      const loops = [];
      let currentLoop = null;
      let loopNumber = 1;

      // S'assurer que subtitles est un tableau
      if (!Array.isArray(subtitles)) {
        subtitles = [];
      }

      subtitles.forEach((subtitle, index) => {
        // Extraire ou créer le rôle
        const roleName = subtitle.character || "Narrateur";
        if (!roles.has(roleName)) {
          roles.set(roleName, {
            id: `role-${roles.size}`,
            name: roleName,
            lineCount: 0,
            loops: new Set(),
          });
        }

        const role = roles.get(roleName);
        role.lineCount++;

        // Créer des boucles basées sur les gaps temporels (>30 secondes = nouvelle boucle)
        const startTime = subtitle.start || 0;
        const endTime = subtitle.end || startTime + 1;

        if (!currentLoop || startTime - (currentLoop.lastEnd || 0) > 30) {
          if (currentLoop) {
            loops.push(currentLoop);
          }
          currentLoop = {
            number: loopNumber++,
            timecodeIn: this.secondsToTimecode(startTime),
            timecodeOut: this.secondsToTimecode(endTime),
            lines: [],
            roles: new Set(),
            lastEnd: endTime,
          };
        }

        currentLoop.lines.push({
          id: `line-${index}`,
          roleId: role.id,
          roleName: roleName,
          text: subtitle.text || "",
          timecodeIn: this.secondsToTimecode(startTime),
          timecodeOut: this.secondsToTimecode(endTime),
        });

        currentLoop.roles.add(role.id);
        currentLoop.timecodeOut = this.secondsToTimecode(endTime);
        currentLoop.lastEnd = endTime;
        role.loops.add(loopNumber - 1);
      });

      if (currentLoop) {
        loops.push(currentLoop);
      }

      // Convertir en format attendu
      const rolesArray = Array.from(roles.values()).map((r) => ({
        ...r,
        loops: Array.from(r.loops),
      }));

      // Si aucun sous-titre, créer une structure minimale
      if (rolesArray.length === 0) {
        rolesArray.push({
          id: "role-0",
          name: "Narrateur",
          lineCount: 0,
          loops: [],
        });
      }

      if (loops.length === 0) {
        loops.push({
          number: 1,
          timecodeIn: "00:00:00:00",
          timecodeOut: "00:00:01:00",
          lines: [],
          roles: [],
        });
      }

      return {
        header: {
          title: this.workspace?.title || this.video?.name || "Projet Voxdub",
          framerate: this.settings?.framerate || 25,
        },
        roles: rolesArray,
        loops: loops.map((l) => ({
          ...l,
          roles: Array.from(l.roles),
        })),
        dialogues: subtitles.map((s, i) => {
          const roleName = s.character || "Narrateur";
          const role = roles.get(roleName);
          const roleId = role ? role.id : "role-0";
          return {
            loopNumber: Math.floor(i / 20) + 1, // Approximation (sera re-grouppé côté serveur via NDD)
            roleId: roleId,
            roleName: roleName,
            text: s.text || "",
            timecodeIn: this.secondsToTimecode(s.start || 0),
            timecodeOut: this.secondsToTimecode(s.end || s.start + 1 || 1),
          };
        }),
        statistics: {
          totalRoles: rolesArray.length,
          totalLoops: loops.length,
          totalLines: subtitles.length,
          totalLignage: subtitles.length,
        },
      };
    },
    timecodeToSeconds(timecode) {
      // Convertir timecode format "HH:MM:SS:FF" en secondes
      if (!timecode) return 0;
      const parts = timecode.split(":");
      if (parts.length !== 4) return 0;

      const hours = parseInt(parts[0]) || 0;
      const minutes = parseInt(parts[1]) || 0;
      const seconds = parseInt(parts[2]) || 0;
      const frames = parseInt(parts[3]) || 0;

      return hours * 3600 + minutes * 60 + seconds + frames / 25;
    },
    secondsToTimecode(seconds) {
      // Convertir secondes en timecode format "HH:MM:SS:FF"
      if (!seconds && seconds !== 0) return "00:00:00:00";

      const hours = Math.floor(seconds / 3600);
      const remaining = seconds % 3600;
      const minutes = Math.floor(remaining / 60);
      const secs = Math.floor(remaining % 60);
      const frames = Math.floor(((remaining % 60) - secs) * 25);

      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:${String(secs).padStart(2, "0")}:${String(frames).padStart(2, "0")}`;
    },
    exportProject() {
      // Gate: only PRO can export projects longer than 10 minutes
      if (!this.gateLongDuration("export")) return;

      // Track export event
      this.$amplitude.track("Export", {
        format: "project_json",
        subtitle_count: this.subtitles.length,
        duration: this.getDurationSecondsFromSubtitles(),
        user_role: this.$auth?.user?.role || "free",
      });

      let json = {
        subtitles: this.subtitles,
        ndd: this.ndd,
      };
      let dataStr =
        "data:text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(json));
      let downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", "project.json");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
    },
    importProject() {
      // create file input
      let fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = ".json";
      document.body.appendChild(fileInput);
      fileInput.onchange = (e) => {
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.onload = (e) => {
          let json = JSON.parse(e.target.result);
          const pendingSubtitles = json.subtitles || [];
          // Gate: only PRO can import projects longer than 10 minutes
          if (!this.gateLongDuration("import", pendingSubtitles)) return;
          this.subtitles = pendingSubtitles;
          this.ndd = json.ndd;

          // Track import event
          this.$amplitude.track("Import", {
            format: "project_json",
            subtitle_count: pendingSubtitles.length || 0,
            user_role: this.$auth?.user?.role || "free",
          });
        };
        reader.readAsText(file);
      };
      fileInput.click();
    },
    exportToJson() {
      // Gate: only PRO can export projects longer than 10 minutes
      if (!this.gateLongDuration("export")) return;

      // Track export event
      this.$amplitude.track("Export", {
        format: "json",
        subtitle_count: this.subtitles.length,
        duration: this.getDurationSecondsFromSubtitles(),
        user_role: this.$auth?.user?.role || "free",
      });

      window.gtag("event", "export_subtitles");
      let dataStr =
        "data:text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(this.subtitles));
      let downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", "subtitles.json");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },
    parseAss(text) {
      let subtitles = [];
      let lines = text.split("\n");
      for (const line of lines) {
        if (line.startsWith("Dialogue:")) {
          let parts = line.split(",");
          let start = this.transformTimeToSeconds(parts[1], "0:00:00.00");
          let end = this.transformTimeToSeconds(parts[2], "0:00:00.00");
          let character = parts[4];
          let text = parts[9];
          subtitles.push({ start, end, character, text });
        }
      }
      return subtitles;
    },
    transformTimeToSeconds(time, format) {
      let parts = time.split(":");
      let hours = 0;
      let minutes = 0;
      let seconds = 0;
      let milliseconds = 0;
      if (format == "00:00:00,000") {
        hours = parseInt(parts[0]);
        minutes = parseInt(parts[1]);
        seconds = parseInt(parts[2].split(",")[0]);
        milliseconds = parseInt(parts[2].split(",")[1]);
      } else if (format == "0:00:00.00") {
        hours = parseInt(parts[0]);
        minutes = parseInt(parts[1]);
        seconds = parseInt(parts[2].split(".")[0]);
        milliseconds = parseInt(parts[2].split(".")[1]) * 10;
      }
      return hours * 3600 + minutes * 60 + seconds + milliseconds / 1000;
    },
    parseSrt(text) {
      let subtitles = [];
      let lines = text.split("\n");
      for (const line of lines) {
        if (line.match(/\d\d:\d\d:\d\d,\d\d\d --> \d\d:\d\d:\d\d,\d\d\d/)) {
          let parts = line.split(" --> ");
          let start = this.transformTimeToSeconds(parts[0], "00:00:00,000");
          let end = this.transformTimeToSeconds(parts[1], "00:00:00,000");
          let text = "";
          let character = "";
          let nextLine = lines[lines.indexOf(line) + 1];
          if (nextLine.startsWith("[")) {
            let characterLine = nextLine.split("]");
            character = characterLine[0].replace("[", "");
            text = characterLine[1];
          } else {
            text = nextLine;
          }
          subtitles.push({ start, end, character, text });
        }
      }
      return subtitles;
    },
    importFromJson(event) {
      window.gtag("event", "import_subtitles");
      let file = event.target.files[0];
      //get file extensions
      let fileName = file.name;
      let fileExtension = fileName.split(".").pop();
      let reader = new FileReader();
      reader.onload = (e) => {
        if (fileExtension.toLowerCase() == "json") {
          const parsed = JSON.parse(e.target.result);
          if (!this.gateLongDuration("import", parsed)) return;
          this.subtitles = parsed;

          // Track import event
          this.$amplitude.track("Import", {
            format: "json",
            subtitle_count: parsed.length || 0,
            user_role: this.$auth?.user?.role || "free",
          });
        } else if (fileExtension.toLowerCase() == "srt") {
          const parsed = this.parseSrt(e.target.result);
          if (!this.gateLongDuration("import", parsed)) return;
          this.subtitles = parsed;

          // Track import event
          this.$amplitude.track("Import", {
            format: "srt",
            subtitle_count: parsed.length || 0,
            user_role: this.$auth?.user?.role || "free",
          });
        } else if (fileExtension.toLowerCase() == "ass") {
          const parsed = this.parseAss(e.target.result);
          if (!this.gateLongDuration("import", parsed)) return;
          this.subtitles = parsed;

          // Track import event
          this.$amplitude.track("Import", {
            format: "ass",
            subtitle_count: parsed.length || 0,
            user_role: this.$auth?.user?.role || "free",
          });
        }
      };
      reader.readAsText(file);
    },
    // ===== Limite PRO pour import/export > 10 minutes =====
    isProUser() {
      return this.$auth?.user?.role === "pro";
    },
    getDurationSecondsFromSubtitles(subs) {
      const list = Array.isArray(subs) ? subs : this.subtitles || [];
      if (!list.length) return 0;
      let maxEnd = 0;
      for (const s of list) {
        const end = typeof s.end === "number" ? s.end : s.endTime || 0;
        if (end > maxEnd) maxEnd = end;
      }
      return maxEnd;
    },
    gateLongDuration(type, pendingSubtitles) {
      const duration = this.getDurationSecondsFromSubtitles(pendingSubtitles);
      const limitSec = 10 * 60; // 10 minutes
      if (!this.isProUser() && duration > limitSec) {
        this.snackbarMessage =
          "Les " +
          (type === "import" ? "imports" : "exports") +
          " de plus de 10 minutes sont réservés au plan PRO.";
        this.snackbar = true;
        this.reasonPlan = "duration_limit_pro_only";

        // Track limit hit
        this.$trackConversion?.featureBlocked(type + "_long_duration", "pro");
        this.$trackConversion?.limitHit("duration_" + type, duration, limitSec);
        this.$trackConversion?.upgradeAttempt("duration_limit_" + type, "pro");

        // Option: ouvrir la page plan après un court délai
        setTimeout(() => {
          try {
            this.$router.push("/plan");
          } catch (e) {}
        }, 1200);
        return false;
      }
      return true;
    },
    selectSubtitle(id, type) {
      this.resetselectedSubtitle();
      this.selectedSubtitle = this.subtitles.find(
        (subtitle) => subtitle.id == id
      );
      this.selectedSubtitle.type = type;
    },
    deleteSubtitle(id) {
      this.subtitles = this.subtitles.filter((subtitle) => subtitle.id != id);
      this.$nextTick(() => {
        this.resetselectedSubtitle();
      });
    },
    // Méthode pour sauvegarder les sous-titres en mode double bande
    async saveDoubleBandSubtitles() {
      if (!this.workspaceData) return;

      try {
        const url = this.$strapi.options.url;

        // Sauvegarder les sous-titres de la langue source
        if (this.sourceLang === "fr") {
          // Mettre à jour les sous-titres principaux (français)
          await this.$strapi.update("workspaces", this.workspace, {
            subtitles: this.sourceSubtitles,
          });
        } else {
          // Mettre à jour les sous-titres localisés
          const sourceLocalization =
            this.workspaceData.attributes.localizations.data.find(
              (map) => map?.attributes?.locale === this.sourceLang
            );
          if (sourceLocalization) {
            await this.$strapi.update("workspaces", sourceLocalization.id, {
              subtitles: this.sourceSubtitles,
            });
          }
        }

        // Sauvegarder les sous-titres de la langue cible
        if (this.targetLang === "fr") {
          // Mettre à jour les sous-titres principaux (français)
          await this.$strapi.update("workspaces", this.workspace, {
            subtitles: this.targetSubtitles,
          });
        } else {
          // Mettre à jour les sous-titres localisés
          const targetLocalization =
            this.workspaceData.attributes.localizations.data.find(
              (map) => map?.attributes?.locale === this.targetLang
            );
          if (targetLocalization) {
            await this.$strapi.update("workspaces", targetLocalization.id, {
              subtitles: this.targetSubtitles,
            });
          }
        }

        // Recharger le workspace pour synchroniser les données
        await this.loadWorkspace();
      } catch (err) {
        console.error(
          "Erreur lors de la sauvegarde des sous-titres double bande:",
          err
        );
        this.error = true;
        this.errorMessage = "Erreur lors de la sauvegarde des sous-titres";
      }
    },

    // Project Handling
    async saveProject() {
      window.gtag("event", "save_project");
      window.gtag("event", "conversion", {
        send_to: "AW-11106758945/KXgQCPSZ8q0YEKHijrAp",
      });
      this.title = this.title.replace(/[()]/g, "");
      let config = {
        onUploadProgress: (progressEvent) => {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.uploadProgress = percentCompleted;
        },
      };
      this.saveInProgress = true;
      if (!this.sources.find((map) => map.character == "all")) {
        // if video source = base64 then convert to blob
        let videoSource = this.$refs.video.src;
        if (videoSource.includes("base64")) {
          let blob = await fetch(videoSource).then((r) => r.blob());
          videoSource = URL.createObjectURL(blob);
        }
        this.sources.push({
          id: this.sources.length + 1,
          name: this.$moment().unix(),
          character: "all",
          duration: this.videoDuration * this.timelineSize,
          start: 0,
          end: this.videoDuration,
          src: videoSource,
        });
      }
      // remove if we have twice character all
      let alreadyHaveCharacterAll = false;
      this.sources = this.sources.filter((map) => {
        if (
          !this.getArrayOfAvailableCharacter.includes(map.character) &&
          map.character != "all"
        ) {
          return false;
        }
        if (!alreadyHaveCharacterAll && map.character == "all") {
          alreadyHaveCharacterAll = true;
          return true;
        } else if (map.character != "all") {
          return true;
        }
      });
      console.log("this.sources", this.sources);
      try {
        if (
          this.workspace &&
          !this.publicWorkspace &&
          this.workspaceData.attributes.user == this.$auth.user.sub
        ) {
          let data = new FormData();
          // create file object from src
          // let blob = await fetch(this.$refs.video.src).then(r => r.blob());
          // clean audios from workspace
          let id = this.workspace;
          await this.$strapi.update("workspaces", id, {
            settings: this.settings,
          });
          if (
            this.settings.language != "fr" &&
            this.settings.language != null
          ) {
            id = this.workspaceData.attributes?.localizations?.data.find(
              (l) => l.attributes.locale == this.settings.language
            ).id;
          }
          // data.append('files.video', blob);
          data.append(
            "data",
            JSON.stringify({
              subtitles: this.subtitles,
              audiojson: this.sources,
              user: this.$auth.user.sub,
              settings: this.settings,
              ndd: this.ndd,
              title: this.title,
            })
          );
          let audios = this.sources;
          for (let i = 0; i < audios.length; i++) {
            // Upload tous les audios, y compris l'audio traité (all)
            // Sauf si c'est l'audio de base et qu'il n'a pas été traité
            if (audios[i].character === "all" && !audios[i].processed) {
              // Skip l'audio de base non traité (sera récupéré de la vidéo)
              continue;
            }
            try {
              let blob = await fetch(audios[i].src).then((r) => r.blob());
              // Ajouter un suffixe au nom pour les audios traités
              // S'assurer que le nom a une extension .wav pour Strapi
              let filename = audios[i].processed
                ? `${audios[i].name}_processed.wav`
                : `${audios[i].name}.wav`;
              data.append(`files.audios`, blob, filename);
            } catch (err) {
              console.log(err);
            }
          }
          let url = this.$strapi.options.url;
          // get upload progress
          await axios.put(`${url}/api/workspaces/${id}`, data, config);
        } else {
          if (
            this.$auth?.user?.role != "basic" &&
            this.$auth?.user?.role != "pro"
          ) {
            if (this.user.projects.length >= 5) {
              this.error = true;
              this.errorMessage =
                "You have reached the maximum number of projects";
              this.openPopupPlan = true;
              // return;
            }
          } else if (this.$auth?.user?.role == "basic") {
            if (this.user.projects.length >= 10) {
              this.error = true;
              this.errorMessage =
                "You have reached the maximum number of projects";
              this.openPopupPlan = true;
              // return;
            }
          }
          let data = new FormData();
          let blob = await fetch(this.$refs.video.src).then((r) => r.blob());
          data.append("files.video", blob);
          data.append(
            "data",
            JSON.stringify({
              subtitles: this.subtitles,
              audiojson: this.sources,
              user: this.$auth.user.sub,
              settings: this.settings,
              locale: this.settings.language,
              ndd: this.ndd,
              title: this.title,
            })
          );
          let audios = this.sources;
          for (let i = 0; i < audios.length; i++) {
            // Upload tous les audios, y compris l'audio traité (all)
            // Sauf si c'est l'audio de base et qu'il n'a pas été traité
            if (audios[i].character === "all" && !audios[i].processed) {
              // Skip l'audio de base non traité (sera récupéré de la vidéo)
              continue;
            }
            try {
              let blob = await fetch(audios[i].src).then((r) => r.blob());
              // Ajouter un suffixe au nom pour les audios traités
              // S'assurer que le nom a une extension .wav pour Strapi
              let filename = audios[i].processed
                ? `${audios[i].name}_processed.wav`
                : `${audios[i].name}.wav`;
              data.append(`files.audios`, blob, filename);
            } catch (err) {
              console.log(err);
            }
          }
          let url = this.$strapi.options.url;
          let createWokspace = await axios.post(
            `${url}/api/workspaces`,
            data,
            config
          );
          this.workspace = createWokspace.data.data.id;
          this.$router.push(
            `/project?workspace=${createWokspace.data.data.id}`
          );
          this.publicWorkspace = false;
        }
      } catch (err) {
        this.saveInProgress = false;
        this.error = err;
        console.error("err", err);
        this.$sentry.captureException(err.message);
        this.errorMessage = this.$t("error.internet_or_space_left", {
          err: err.message,
        });
      }
      this.saveInProgress = false;
      // this.$refs.renderRythmo.scrollLeft = 0;
      this.chunkSize = this.maxSize;
      this.lastSave = this.$moment().unix();

      // Marquer comme sauvegardé pour l'auto-save
      this.markAsSaved();

      // event bus emit
      this.$bus.$emit("updateProjects");
    },
    buildWorkspaceLoadErrorMessage(err) {
      const status =
        err?.response?.status || err?.status || err?.error?.status || null;

      if (status === 404) {
        return "Ce projet est introuvable. Il a peut-être été supprimé ou le lien est invalide.";
      }

      if (status === 403) {
        return "Vous n'avez pas accès à ce projet.";
      }

      return `Erreur lors du chargement du projet${err?.message ? `: ${err.message}` : "."}`;
    },
    async loadWorkspace() {
      this.videoLoading = true;
      this.error = false;
      this.errorMessage = null;

      try {
        window.gtag("event", "load_workspace");
        let entry = await this.$strapi.findOne("workspaces", this.workspace, {
          populate: "*",
        });
        this.workspaceData = entry.data;
        if (
          entry.data.attributes.user != this.$auth?.user?.sub &&
          !entry.data.attributes.public
        ) {
          console.log("current user", this.$auth?.user?.sub);
          // check in settings if user can access to workspace
          if (
            entry.data.attributes.settings?.access?.find(
              (user) => user == this.$auth?.user?.sub
            )
          ) {
            console.log("can access");
          } else {
            console.log("can't access");
            this.confirmLeave = true;
            // this.$router.push('/workspaces')
          }
        }
        this.lastSave = this.$moment(entry.data.attributes.updatedAt).unix();
        this.publicWorkspace = entry.data.attributes.public;
        if (this.$refs.video) {
          this.$refs.video.src = entry.data.attributes.video.data.attributes.url;
        }
        let audiojson = entry.data.attributes.audiojson;
        this.settings = {
          ...this.settings,
          ...entry.data.attributes.settings,
        };
        if (this.settings.framerate < 60) {
          this.settings.framerate = 60;
        }
        this.title = entry.data.attributes.title || this.title;
        this.ndd = entry.data.attributes.ndd || this.ndd;
        // if ndd is type of array then convert to object
        if (Array.isArray(this.ndd)) {
          this.ndd = {
            svg: [],
            items: [],
            loops: [],
            endDialog: [],
            notes: [],
            sceneChanges: [],
          };
        }
        if (!this.ndd.sceneChanges) {
          this.ndd.sceneChanges = [];
        }
        if (!this.ndd.notes) {
          this.ndd.notes = [];
        }
        if (!this.ndd.endDialog) {
          this.ndd.endDialog = [];
        }
        // audiojson reverse
        let sources = audiojson;
        if (audiojson) {
          for (let i = 0; i < sources.length; i++) {
            if (!sources[0].id) {
              sources[i].id = i;
            }
            if (!sources[i].muted) {
              sources[i].muted = false;
            }
            // data.attributes.audios.data[0].attributes.name
            // Chercher l'audio avec le nom exact (en ignorant l'extension et les suffixes Strapi)
            let audioFile = entry.data.attributes.audios?.data?.find((audio) => {
              const strapiName = audio.attributes.name;
              const sourceName = sources[i].name.toString();
              return (
                strapiName === sourceName ||
                strapiName === `${sourceName}_processed` ||
                strapiName.startsWith(sourceName)
              );
            });
            if (audioFile) {
              sources[i].src = audioFile.attributes.url;
              console.log(
                `[AudioPersistence] Matched source ${sources[i].name} with Strapi URL: ${sources[i].src}`
              );
            } else {
              console.warn(
                `[AudioPersistence] Could not find Strapi file for source: ${sources[i].name}`
              );
            }
          }
          this.sources = [...sources]; // Force reactivity
        }
        // Optimisation : Traitement par lot des sous-titres pour éviter les appels multiples à $set
        const processedSubtitles = entry.data.attributes.subtitles.map(
          (subtitle) => {
            // Créer un nouvel objet avec les valeurs par défaut
            return {
              ...subtitle,
              underline:
                subtitle.underline !== undefined ? subtitle.underline : false,
              dashed: subtitle.dashed !== undefined ? subtitle.dashed : false,
              male: subtitle.male !== undefined ? subtitle.male : false,
              female: subtitle.female !== undefined ? subtitle.female : false,
              speedrate: subtitle.speedrate || 1,
              exclude: subtitle.exclude !== undefined ? subtitle.exclude : false,
              line: subtitle.line || 0,
              y:
                subtitle.y !== undefined && subtitle.y !== null
                  ? subtitle.y
                  : this.heightBySeed(subtitle.character || "character"),
              characterShow:
                subtitle.characterShow !== undefined
                  ? subtitle.characterShow
                  : true,
              letterWidths: subtitle.letterWidths || {},
            };
          }
        );

        // Assignation en une seule fois pour réduire les déclenchements de réactivité
        this.subtitles = processedSubtitles;
        this.videoSource = entry.data.attributes.video.data.attributes.url;
        this.$nextTick(() => {
          this.getVideoData();
          this.changeSubtitlesLanguage();

          // Si le mode double bande était actif, recharger les sous-titres
          if (this.doubleBandMode) {
            this.loadDoubleBandSubtitles();
          }

          // Charger les données de dessin avec un délai pour s'assurer que tout est monté
          setTimeout(() => {
            this.loadDrawingData();
          }, 500);
        });
      } catch (err) {
        console.error("Erreur lors du chargement du projet:", err);
        this.videoLoading = false;
        this.workspaceData = null;
        this.error = true;
        this.errorMessage = this.buildWorkspaceLoadErrorMessage(err);
        this.$sentry.captureException(err);
        return;
      }
    },
    async getTasks() {
      if (this.loading) return;
      await this.$strapi
        .find("tasks", {
          populate: "*",
          filters: {
            workspace: this.workspace,
          },
          sort: "createdAt:desc",
        })
        .then((res) => {
          this.$store.dispatch("setTasks", res.data);
        });
    },
    async exportAudiosForBwf() {
      // Vérifier si l'utilisateur est Pro
      if (this.$auth?.user?.role !== "pro") {
        this.openPopupPlan = true;
        this.reasonPlan = "bwf_export_pro_only";
        this.snackbar = true;
        this.snackbarMessage = "L'export audio BWF est réservé aux abonnés Pro";
        return;
      }
      // Afficher d'abord le dialog de configuration
      this.bwfMetadataDialog = true;
    },

    async performBwfExport() {
      this.loading = true;
      try {
        let ffmpeg = createFFmpeg({
          log: true,
        });
        await ffmpeg.load();

        let audios = this.sources;
        let output = [];

        for (const audio of audios) {
          let { start, character, src } = audio;
          let frequency = 48000;
          let echantillon = start * frequency;

          // Déterminer l'extension d'entrée
          const isWav = src.includes("audio/wav") || src.endsWith(".wav");
          const inputExt = isWav ? "wav" : "webm";
          const inputName = `${audio.name}.${inputExt}`;

          // Préparer les métadonnées BWF
          const micName =
            this.bwfMicrophoneMapping[character] || `MIC_${character}`;
          const description = `Character:${character},Mic:${micName}`;
          const originator = "VOXDUB";
          const originatorRef = `CHAR_${character
            .toUpperCase()
            .replace(/\s+/g, "_")}`;
          const codingHistory = `T=Character:${character};Mic:${micName};Session:${
            this.title || "Untitled"
          }`;

          await ffmpeg.FS("writeFile", inputName, await fetchFile(audio.src));

          let cmd = [
            "-i",
            inputName,
            "-write_bext",
            "1",
            "-metadata",
            `time_reference=${echantillon}`,
            "-metadata",
            `description=${description}`,
            "-metadata",
            `originator=${originator}`,
            "-metadata",
            `originator_reference=${originatorRef}`,
            "-metadata",
            `coding_history=${codingHistory}`,
            "-c:a",
            "pcm_f32le",
            `${audio.name}_bwf.wav`,
          ];

          if (this.bwfIncludeSessionInfo) {
            const date = new Date().toISOString().split("T")[0];
            const time = new Date().toISOString().split("T")[1].split(".")[0];
            cmd.push("-metadata", `origination_date=${date}`);
            cmd.push("-metadata", `origination_time=${time}`);
          }

          await ffmpeg.run(...cmd);
          const data = ffmpeg.FS("readFile", `${audio.name}_bwf.wav`);

          // Nom de fichier descriptif
          const fileName = `${character}_${micName}_${audio.name}`;

          output.push({
            name: fileName,
            data,
          });
        }

        // Créer un fichier README avec les informations de mapping
        const readmeContent = this.generateBwfReadme();

        // create zip file
        const zip = new JSZip();

        // Ajouter le README
        zip.file("BWF_METADATA_INFO.txt", readmeContent);

        // Ajouter les fichiers audio
        for (const file of output) {
          zip.file(`${file.name}.wav`, file.data);
        }

        const projectName = this.title || "export";
        const timestamp = new Date()
          .toISOString()
          .replace(/[:.]/g, "-")
          .slice(0, -5);
        const zipFile = await zip.generateAsync({ type: "blob" });
        saveAs(zipFile, `${projectName}_BWF_${timestamp}.zip`);
      } catch (err) {
        console.error(err);
        this.error = err;
        this.errorMessage = err.message;
      }
      this.loading = false;
    },

    generateBwfReadme() {
      let content = `BROADCAST WAVE FORMAT (BWF) EXPORT METADATA\n`;
      content += `============================================\n\n`;
      content += `Project: ${this.title || "Untitled"}\n`;
      content += `Export Date: ${new Date().toISOString()}\n`;
      content += `Generated by: Voxdub\n\n`;

      content += `CHARACTER/MICROPHONE MAPPING:\n`;
      content += `----------------------------\n`;

      for (const character of this.getArrayOfAvailableCharacter) {
        const micName =
          this.bwfMicrophoneMapping[character] || `MIC_${character}`;
        content += `${character.padEnd(20)} => ${micName}\n`;
      }

      content += `\nMETADATA FIELDS USED:\n`;
      content += `---------------------\n`;
      content += `- Description: Contains character name and microphone assignment\n`;
      content += `- OriginatorReference: Character identifier (CHAR_[CHARACTER_NAME])\n`;
      content += `- CodingHistory: Session information and character/mic details\n`;
      content += `- TimeReference: Sample-accurate position in the original timeline\n`;

      if (this.bwfIncludeSessionInfo) {
        content += `- OriginationDate: Date of export\n`;
        content += `- OriginationTime: Time of export\n`;
      }

      content += `\nNOTES:\n`;
      content += `------\n`;
      content += `These BWF files contain embedded metadata following EBU Tech 3285 specifications.\n`;
      content += `The metadata can be read by professional audio applications supporting BWF.\n`;

      return content;
    },

    saveBwfMetadata() {
      // Sauvegarder les préférences dans localStorage
      localStorage.setItem(
        "bwfMicrophoneMapping",
        JSON.stringify(this.bwfMicrophoneMapping)
      );
      localStorage.setItem("bwfIncludeSessionInfo", this.bwfIncludeSessionInfo);

      // Fermer le dialog et lancer l'export
      this.bwfMetadataDialog = false;
      this.performBwfExport();
    },

    configureBwfMetadata() {
      // Ouvrir le dialog de configuration sans lancer l'export
      this.bwfMetadataDialog = true;
    },
    loadVideoBlob(event) {
      try {
        this.title = "New project";
        this.loading = true;
        // this.$router.push('/')
        this.workspace = null;
        this.subtitles = [];
        this.sources = [];
        this.$refs.video.src = "";
        let file = event.target.files[0];
        let reader = new FileReader();
        // Store video in localstorage
        reader.onload = (e) => {
          this.videoSource = e.target.result;
          this.createSubtitle("Text here");
          this.loading = false;
        };
        reader.readAsDataURL(file);
      } catch (err) {
        console.log(err);
      }
    },
    downloadRenderVideo() {
      let videoUrl = this.outputURL;
      let fileName = this.title + ".mp4";
      saveAs(videoUrl, fileName);
    },
    clearSelectedSubtitle() {
      if (!this.selectedSubtitle || this.selectedSubtitle.id == null) {
        if (this.selectedCharacter !== null) {
          this.selectedCharacter = null;
        }
        return;
      }

      this.selectedSubtitle = { id: null };
      this.selectedCharacter = null;
    },
    startScrollLoop() {
      const video = this.$refs.video;
      if (!video || video.paused || video.ended || this._scrollAnimationFrame) {
        return;
      }

      if (!this._updateScrollPositionBound) {
        this._updateScrollPositionBound = this.updateScrollPosition.bind(this);
      }

      this._scrollAnimationFrame = requestAnimationFrame(
        this._updateScrollPositionBound
      );
    },
    stopScrollLoop() {
      if (this._scrollAnimationFrame) {
        cancelAnimationFrame(this._scrollAnimationFrame);
        this._scrollAnimationFrame = null;
      }
    },
    syncRythmoViewport({
      forceReactive = false,
      syncAudio = false,
      currentTime = null,
    } = {}) {
      const video = this.$refs.video;
      if (!video) return;

      const effectiveCurrentTime = currentTime ?? video.currentTime;
      const scrollTime = effectiveCurrentTime + this.offsetDuration;
      const pixelsPerSecond = 25 * this.settings.fontSize;
      const baseScroll = scrollTime * pixelsPerSecond;
      const offsetDiv = this.$refs.offsetDiv;

      // Sync rythmo band scroll position
      if (offsetDiv) {
        if (Math.abs(offsetDiv.scrollLeft - baseScroll) > 1) {
          offsetDiv.scrollLeft = baseScroll;
        }
      }

      // Sync audio tracks scroll
      const ats = this.$refs.audioTracksScroll;
      if (ats && offsetDiv) {
        ats.scrollLeft = offsetDiv.scrollLeft;
      }

      const now = performance.now();
      if (
        forceReactive ||
        now - this._lastVideoTimeUpdate > 120 ||
        Math.abs(scrollTime - this.videoTime) > 0.25
      ) {
        this._lastVideoTimeUpdate = now;
        this.videoTime = scrollTime;
      }
      if (syncAudio && !video.paused && !this.isRecording) {
        if (
          !this._lastAudioCheck ||
          Math.abs(effectiveCurrentTime - this._lastAudioCheck) > 0.3
        ) {
          this._lastAudioCheck = effectiveCurrentTime;

          if (
            !this._cachedSources ||
            this._lastSourcesLength !== this.sources.length
          ) {
            this._cachedSources = this.sources.filter(
              (s) => s.character !== "all"
            );
            this._lastSourcesLength = this.sources.length;
          }

          const relevantSources = this._cachedSources.filter(
            (s) =>
              s.end >= effectiveCurrentTime - 3 &&
              s.start <= effectiveCurrentTime + 3
          );
          this.syncAudio(relevantSources);
        }
      }
    },
    updateScrollPosition() {
      this._scrollAnimationFrame = null;

      const video = this.$refs.video;
      if (!video) return;

      if (video.paused || video.ended) {
        this.syncRythmoViewport({ forceReactive: true });
        return;
      }

      this.syncRythmoViewport({ syncAudio: true });
      this.startScrollLoop();
    },
    scheduleForcedViewportSync(minInterval = 120, options = {}) {
      const now = performance.now();
      if (now - this._lastForcedViewportSync < minInterval) {
        return;
      }

      this._lastForcedViewportSync = now;
      this.syncRythmoViewport({ forceReactive: true, ...options });
    },
    pauseSyncedAudioPlayers({ includeBaseAudio = true } = {}) {
      if (includeBaseAudio && this.$refs.baseaudio) {
        try {
          this.$refs.baseaudio.pause();
        } catch (e) {
          // noop
        }
      }

      if (this._audioPlayersCache) {
        for (const player of this._audioPlayersCache.values()) {
          if (player && !player.paused) {
            try {
              player.pause();
            } catch (e) {
              // noop
            }
          }
        }
      }

      for (const source of this.sources) {
        const playerRef = this.$refs[`audioPlayer${source.character}${source.id}`];
        const player = Array.isArray(playerRef) ? playerRef[0] : playerRef;
        if (player && !player.paused) {
          try {
            player.pause();
          } catch (e) {
            // noop
          }
        }
      }
    },
    syncAudio(relevantSources = null) {
      const video = this.$refs.video;
      if (!video) return;
      if (this.isRecording) return;

      const currentTime = video.currentTime;
      const isVideoPaused = video.paused;
      const sourcesToSync = relevantSources || this.sources;

      // Utiliser un cache pour les éléments audio pour éviter les lookups de refs coûteux
      if (!this._audioPlayersCache) this._audioPlayersCache = new Map();

      for (const source of sourcesToSync) {
        const cacheKey = `${source.character}${source.id}`;
        let player = this._audioPlayersCache.get(cacheKey);

        if (!player) {
          const playerRef =
            this.$refs[`audioPlayer${source.character}${source.id}`];
          if (playerRef && playerRef[0]) {
            player = playerRef[0];
            this._audioPlayersCache.set(cacheKey, player);
          } else {
            continue;
          }
        }
        const shouldBePlaying =
          !isVideoPaused &&
          currentTime >= source.start &&
          currentTime <= source.end;

        if (shouldBePlaying) {
          // Sync time: video time - source start time
          let seekTime = currentTime - source.start;
          if (seekTime < 0) seekTime = 0;

          // Si le player est en pause ou si le temps est désynchronisé (> 0.2s)
          if (player.paused || Math.abs(player.currentTime - seekTime) > 0.2) {
            player.currentTime = seekTime;

            if (!this.isRecording && source.character != "all") {
              player.play().catch((e) => {
                // console.warn("Audio play failed", e)
              });
            }
          }
        } else {
          // Pause if playing
          if (!player.paused) {
            player.pause();
          }
        }
      }

    },
    getVideoData() {
      const video = this.$refs.video;
      if (!video) return;

      if (!this._updateScrollPositionBound) {
        this._updateScrollPositionBound = this.updateScrollPosition.bind(this);
      }

      if (!this._videoHandlersAttached) {
        this._handleVideoLoadedMetadata = (e) => {
          this.$nextTick(() => {
            this.videoLoading = false;
          });
          this.videoDuration = e.target.duration;
          this._lastForcedViewportSync = 0;
          this._lastSeekSyncAt = 0;
          this._lastTimeUpdateSyncAt = 0;
          this._lastAudioCheck = 0;
          this.syncRythmoViewport({ forceReactive: true, currentTime: 0 });
        };

        this._handleVideoPlay = () => {
          this.clearSelectedSubtitle();
          this._lastTimeUpdateSyncAt = 0;
          this._lastAudioCheck = 0;

          if (this.isRecording) {
            this._audioPlaybackSuspended = true;
            this.pauseSyncedAudioPlayers();
          } else if (this.$refs.baseaudio) {
            this.$refs.baseaudio.setVolume(0);
            setTimeout(() => {
              this.$refs.baseaudio.play();
            }, 0);
          }

          this.startScrollLoop();
        };

        this._handleVideoPause = () => {
          this.stopScrollLoop();
          this.syncRythmoViewport({ forceReactive: true });
          this._lastTimeUpdateSyncAt = 0;

          this.pauseSyncedAudioPlayers();
        };

        this._handleVideoSeeked = () => {
          const now = performance.now();
          this._lastSeekSyncAt = now;
          this._lastTimeUpdateSyncAt = now;
          this._lastAudioCheck = 0;
          this.scheduleForcedViewportSync(180);
        };

        this._handleVideoTimeUpdate = () => {
          if (video.paused || this.videoPaused) {
            const now = performance.now();
            if (now - this._lastTimeUpdateSyncAt > 180) {
              this._lastTimeUpdateSyncAt = now;
              this.scheduleForcedViewportSync(180);
            }
          }
        };

        video.addEventListener("loadedmetadata", this._handleVideoLoadedMetadata);
        video.addEventListener("play", this._handleVideoPlay);
        video.addEventListener("pause", this._handleVideoPause);
        video.addEventListener("seeked", this._handleVideoSeeked);
        video.addEventListener("timeupdate", this._handleVideoTimeUpdate);
        this._videoHandlersAttached = true;
      }

      this.$nextTick(() => {
        this.syncRythmoViewport({ forceReactive: true });
        if (!video.paused) {
          this.startScrollLoop();
        }
      });
    },
    // Misc
    idFromCharacterName(character) {
      let keys = Object.keys(this.subtitlesGroupedByCharacters);
      let characterIndex = keys.indexOf(character);
      return characterIndex;
    },
    choseColorBySeedString(character) {
      // Find character object key index in subtitlesGroupedByCharacters
      let keys = Object.keys(this.subtitlesGroupedByCharacters);
      let characterIndex = keys.indexOf(character);
      if (this.settings.backCharactersColors[character]) {
        return this.settings.backCharactersColors[character];
      }
      let colors = this.darkMode
        ? ["rgb(0 0 0)", "rgb(30 30 30)"]
        : ["rgb(255 255 255)", "rgb(225 225 225)"];
      // odd or even
      return colors[characterIndex % 2 == 0 ? 0 : 1];
    },
    calcMarginLeftAndWidth(startTime, endTime) {
      let marginLeft = (startTime / this.videoDuration) * 100;
      if (marginLeft < 0) {
        marginLeft = 0;
      }
      let width = ((endTime - startTime) / this.videoDuration) * 100;
      return `margin-left:${marginLeft}%;width:${width}%`;
    },
    calcMarginLeftAndWidthFun(startTime, endTime) {
      let marginLeft = (startTime / this.videoDuration) * 100;
      let width = ((endTime - startTime) / this.videoDuration) * 100;
      return {
        marginLeft: `${marginLeft}`,
        width: `${width}`,
      };
    },
    getCharacterTrackPosition(character) {
      const characters = Object.keys(this.sourcesGroupedByCharacters);
      const index = characters.indexOf(character);
      if (index === -1) return 0;
      return (this.settings.height / characters.length) * index;
    },
    calcTransformScaleX(startTime, endTime, text) {
      const mainContainerWidth =
        this.videoDuration * 25 * this.settings.fontSize; // px
      const dialogDivWidth = ((endTime - startTime) / this.videoDuration) * 100; // %
      const containerWidth = mainContainerWidth * (dialogDivWidth / 100);
      const textWidth = this.getTextWidth(text);
      const scaleX = containerWidth / textWidth;
      return `transform: translate(-50%) scaleX(${scaleX})`;
    },
    checkIfBrowserIsChrome() {
      var isChromium = window.chrome,
        winNav = window.navigator,
        vendorName = winNav.vendor,
        isOpera = winNav.userAgent.indexOf("OPR") > -1,
        isIEedge = winNav.userAgent.indexOf("Edge") > -1,
        isIOSChrome = winNav.userAgent.match("CriOS");
      if (isIOSChrome) {
        // is Google Chrome on IOS
        return true;
      } else if (
        isChromium !== null &&
        typeof isChromium !== "undefined" &&
        vendorName === "Google Inc." &&
        isOpera === false &&
        isIEedge === false
      ) {
        // is Google Chrome
        return true;
      } else {
        // not Google Chrome
        return false;
      }
    },
    getTextWidth(text) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.font = `${this.settings.fontSize}px ${this.settings.fontFamily}`;
      const metrics = ctx.measureText(text);
      return metrics.width;
    },
    calcWidth(startTime, endTime) {
      let width =
        ((endTime - startTime) / (this.videoDuration + this.offsetDuration)) *
        100;
      return `width:${width}%`;
    },
    async initClientContentful() {
      const client = await this.$contentful.createClient({
        space: "rlg2q6znunia",
        environment: "master", // defaults to 'master' if not set
        accessToken: "thSjjymf_lV7q9ZKmBrznLTRuzENiJBh12vc44YB6Uo",
      });
      return client;
    },
    makeIntro() {
      this.$nextTick(() => {
        if (localStorage.getItem("intro") == "true") return;
        localStorage.setItem("intro", "true");
        // introjs().start();
        // introjs(".intro1").start();
      });
    },
    initDraggableAudio() {
      var self = this;
      var duration = null;
      var selectedSource = null;
      interact(".draggable-audio")
        .draggable({
          // enable inertial throwing
          inertia: true,
          // keep the element within the area of it's parent
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: "parent",
              endOnly: true,
            }),
          ],
          // enable autoScroll
          autoScroll: true,
          listeners: {
            // call this function on every dragmove event
            move: dragMoveListener,
            // call this function on every dragend event
            end(event) {
              var textEl = event.target.querySelector("p");
              textEl &&
                (textEl.textContent =
                  "moved a distance of " +
                  Math.sqrt(
                    (Math.pow(event.pageX - event.x0, 2) +
                      Math.pow(event.pageY - event.y0, 2)) |
                      0
                  ).toFixed(2) +
                  "px");
            },
          },
        })
        .on("down", (event) => {
          // loop parents untel we get data-source
          let nameSource =
            event.target.getAttribute("data-source") ||
            event.target.parentNode.getAttribute("data-source") ||
            event.target.parentNode.parentNode.getAttribute("data-source") ||
            event.target.parentNode.parentNode.parentNode.getAttribute(
              "data-source"
            );
          selectedSource = self.sources.find(
            (source) => source.name == nameSource
          );
          duration = selectedSource.start - selectedSource.end;
        });
      function dragMoveListener(event) {
        var target = event.target;
        let totalWidth =
          self.videoDuration * self.base_rate * self.settings.fontSize;
        // keep the dragged position in the data-x is second on the video
        var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
        var id = target.getAttribute("data-id");
        // totalWidth en pixel
        self.sources.find((source) => source.id == id).start =
          Math.round(parseFloat((x / totalWidth) * self.videoDuration) * 100) /
          100;
        self.sources.find((source) => source.id == id).end =
          Math.round(
            (parseFloat(self.sources.find((source) => source.id == id).start) +
              parseFloat(duration)) *
              100
          ) / 100;
        // translate the element
        // target.style.webkitTransform =
        //   target.style.transform =
        //   'translate(' + x + 'px)'
        // update the posiion attributes
        target.setAttribute("data-x", x);
        // target.setAttribute('data-y', y)
      }
      // this function is used later in the resizing and gesture demos
      window.dragMoveListener = dragMoveListener;
    },
    initResizableWindow() {
      var self = this;
      interact(".resizable-layout").resizable({
        // resize from all edges and corners
        edges: { left: true, right: true },
        listeners: {
          move(event) {
            if (Math.floor(event.rect.width) % 10 === 0) {
              if (Math.floor(event.rect.width) < window.innerWidth / 2) {
                if (self.layoutoffset < -2) return;
                self.layoutoffset -= 1;
              } else {
                if (self.layoutoffset > 2) return;
                self.layoutoffset += 1;
              }
            }
          },
        },
        modifiers: [
          // keep the edges inside the parent
          interact.modifiers.restrictEdges({
            outer: "parent",
          }),
        ],
      });
    },
    initItemInteract() {
      var self = this;
      interact(".replace-item").draggable({
        // enable inertial throwing
        inertia: true,
        // keep the element within the area of it's parent
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: "parent",
            endOnly: true,
          }),
        ],
        // enable autoScroll
        autoScroll: true,
        listeners: {
          // call this function on every dragmove event
          move: function (event) {
            var target = event.target;
            let id = target.getAttribute("data-id");
            let type = target.getAttribute("data-type");
            // keep the dragged position in the data-x/data-y attributes
            var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
            var y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;
            self.ndd[type].find((item) => item.id == id).x = x;
            self.ndd[type].find((item) => item.id == id).y = y;
            // translate the element
            target.style.transform = "translate(" + x + "px, " + y + "px)";
            // update the posiion attributes
            target.setAttribute("data-x", x);
            target.setAttribute("data-y", y);
          },
        },
      });
    },
    initInteract() {
      var self = this;
      interact(".resize-drag")
        .resizable({
          // resize from all edges and corners
          edges: { left: true, right: true },
          listeners: {
            move(event) {
              var target = event.target;
              var x = parseFloat(target.getAttribute("data-x")) || 0;
              var y = parseFloat(target.getAttribute("data-y")) || 0;
              if (!self.selectedSubtitle.id) return;
              let { left, right } = event.edges;
              // update the element's style
              target.style.width = event.rect.width + "px";
              // largeur de la div en pixels
              let divWidth = event.rect.width;
              // durée totale de la timeline en secondes
              let timelineDuration = self.videoDuration;
              // temps de début du sous-titre en secondes
              let start = self.selectedSubtitle.start;
              // proportion de la timeline occupée par la div
              let proportion =
                divWidth /
                (timelineDuration * self.base_rate * self.settings.fontSize);
              // durée totale représentée par la div en secondes
              let duration = proportion * timelineDuration;
              // calcul de la valeur end en secondes
              let end = start + duration;
              if (right) {
                self.selectedSubtitle.end = parseFloat(
                  self.selectedSubtitle.end
                );
                self.selectedSubtitle.end = parseFloat(end);
              }
              // translate when resizing from top or left edges
              x += event.deltaRect.left;
              y += event.deltaRect.top;
              if (left) {
                self.selectedSubtitle.start = parseFloat(
                  self.selectedSubtitle.start
                );
                let start = parseFloat(
                  (event.deltaRect.left /
                    (timelineDuration *
                      self.base_rate *
                      self.settings.fontSize)) *
                    timelineDuration
                );
                self.selectedSubtitle.start += start;
              }
              // target.style.transform = 'translate(' + x + 'px,' + y + 'px)'
              target.setAttribute("data-x", x);
              target.setAttribute("data-y", y);
            },
          },
          modifiers: [
            // keep the edges inside the parent
            interact.modifiers.restrictEdges({
              outer: "parent",
            }),
            // minimum size
            interact.modifiers.restrictSize({
              min: { width: 10, height: 50 },
            }),
          ],
          // inertia: true
        })
        .draggable({
          listeners: {
            move(event) {
              var target = event.target;
              var x =
                (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
              var y =
                (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;
              // translate the element
              target.style.transform = "translateY(" + y + "px)";
              // update the posiion attributes
              target.setAttribute("data-x", x);
              target.setAttribute("data-y", y);
              if (!self.selectedSubtitle.id) return;
              self.selectedSubtitle.y = y;
              self.selectedSubtitle.start = parseFloat(
                self.selectedSubtitle.start
              );
              self.selectedSubtitle.end = parseFloat(self.selectedSubtitle.end);
              let start = parseFloat(
                (event.dx /
                  (self.videoDuration * 25 * self.settings.fontSize)) *
                  self.videoDuration
              );
              let end = parseFloat(
                (event.dx /
                  (self.videoDuration * 25 * self.settings.fontSize)) *
                  self.videoDuration
              );
              self.selectedSubtitle.start += start;
              self.selectedSubtitle.end += end;
            },
            modifiers: [
              interact.modifiers.restrictRect({
                restriction: "timeline-cell",
                endOnly: true,
              }),
            ],
          },
          inertia: false,
        })
        .on("down", (event) => {
          let { id } = event.target;
          if (!id) {
            id = event.target.parentNode.id;
            if (!id) {
              id = event.target.parentNode.parentNode.id;
              if (!id) {
                id = event.target.parentNode.parentNode.parentNode.id;
              }
            }
          }
          self.selectedSubtitle = self.subtitles.find((sub) => sub.id == id);
          self.isEditingSubtitle = true;
        })
        .on("resizeend", () => {
          self.isEditingSubtitle = false;
        })
        .on("up", () => {})
        .on("load", (event) => {
          console.log(event);
        });
    },
    initInteractLetter() {
      interact(".resize-drag-letter")
        .resizable({
          // resize from all edges and corners
          edges: { right: true },
          listeners: {
            move(event) {
              var target = event.target;
              var x = parseFloat(target.getAttribute("data-x")) || 0;
              var y = parseFloat(target.getAttribute("data-y")) || 0;
              // translate when resizing from top or left edges
              x += event.deltaRect.left;
              y += event.deltaRect.top;
              target.style.transform = "scaleX(" + event.rect.width / 100 + ")";
              target.setAttribute("data-x", x);
              target.setAttribute("data-y", y);
            },
          },
          modifiers: [
            // keep the edges inside the parent
            interact.modifiers.restrictEdges({
              outer: "parent",
            }),
            // minimum size
            interact.modifiers.restrictSize({
              min: { width: 20, height: 50 },
            }),
          ],
          inertia: true,
        })
        .on("down", (event) => {
          console.log(event);
        });
    },
    playVideo() {
      // Optimisation : juste gérer play/pause de la vidéo
      // La gestion des sources audio est déjà faite dans updateScrollPosition()
      const wasPlaying = !this.$refs.video.paused;

      // Fix: Capturer currentTime AVANT play() car le navigateur peut avancer currentTime
      // de plusieurs frames lors du démarrage, causant un "jump" visuel
      const currentTimeBeforePlay = this.$refs.video.currentTime;

      this.$refs.video.paused
        ? this.$refs.video.play()
        : this.$refs.video.pause();
      this.videoPaused = this.$refs.video.paused;

      // Si on vient de démarrer la lecture, forcer le scroll à la position d'AVANT le play
      // pour éviter le jump de 2-3 frames causé par l'avance de currentTime
      if (!wasPlaying && !this.videoPaused) {
        // Restaurer currentTime à sa valeur d'avant play (annule l'avance du navigateur)
        this.$refs.video.currentTime = currentTimeBeforePlay;

        // Forcer un update immédiat du scroll
        this.videoTime = currentTimeBeforePlay + this.offsetDuration;

        const scroll =
          (this.videoTime / this.videoDuration) *
          (this.videoDuration * 25 * this.settings.fontSize) *
          1000;
        const baseScroll = scroll / 1000;

        if (this.$refs.offsetDiv) {
          this.$refs.offsetDiv.scrollLeft = baseScroll;
        }
        if (this.$refs.offsetDivAudio) {
          this.$refs.offsetDivAudio.scrollLeft = baseScroll;
        }
      }

      // Sync audio state (pause/play)
      if (!this.isRecording) {
        this.syncAudio();
      } else {
        this.pauseSyncedAudioPlayers();
      }
    },
    // Gérer le redimensionnement de la fenêtre
    handleWindowResize() {
      this.innerWidth = window.innerWidth;
      this.innerHeight = window.innerHeight;
      this.$nextTick(() => {
        this.refreshRythmoMeasurements();
      });
    },
    getVideoSubtitleStyle(subtitle) {
      const style = {
        position: "absolute",
        bottom: "60px", // Position depuis le bas de la vidéo
        left: "50%",
        transform: "translateX(-50%)",
        width: "90%",
        textAlign: "center",
        color: this.settings.fontColor || "#ffffff",
        fontFamily: this.settings.fontFamily,
        fontSize: `${Math.max(this.settings.fontSize * 0.8, 16)}px`,
        padding: "8px 15px",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        borderRadius: "5px",
        zIndex: 1000,
        lineHeight: "1.4",
        wordWrap: "break-word",
      };

      // Couleur de bordure selon les propriétés du sous-titre
      if (subtitle.underline) {
        style.borderBottom = "3px solid #58e279";
      }
      if (subtitle.dashed) {
        style.borderBottom = "3px dashed #58e279";
      }

      return style;
    },
    toggleDrawingMode() {
      console.log(
        "toggleDrawingMode called, current drawingMode:",
        this.drawingMode
      );

      // Vérifier si l'utilisateur est Pro
      if (this.$auth?.user?.role !== "pro") {
        this.openPopupPlan = true;
        this.reasonPlan = "drawing_pro_only";
        this.snackbar = true;
        this.snackbarMessage = "Le mode dessin est réservé aux abonnés Pro";
        return;
      }

      this.drawingMode = !this.drawingMode;
      console.log("toggleDrawingMode, new drawingMode:", this.drawingMode);
    },
    onDrawingStart(event) {
      console.log("Drawing started:", event);
      // Optionnel: sauvegarder automatiquement quand un nouveau dessin commence
    },
    onDrawing(event) {
      // Console log trop verbose, on peut le supprimer
      // console.log('Drawing:', event);
    },
    onDrawingEnd(event) {
      console.log("Drawing ended:", event);
      // Sauvegarder l'historique de dessin
      if (this.$refs.drawingCanvas) {
        this.drawingHistory = this.$refs.drawingCanvas.getDrawingHistory();
        this.saveDrawingData();
      }
    },
    onCanvasCleared(event) {
      console.log("Canvas cleared:", event);
      this.drawingHistory = [];
      this.canvasData = null;
      this.saveDrawingData();
    },
    onCanvasExported(event) {
      console.log("Canvas exported:", event);
      this.canvasData = event.dataURL;
    },

    // Sauvegarder les données de dessin dans les settings ou le workspace
    saveDrawingData() {
      if (this.drawingHistory && this.drawingHistory.length > 0) {
        // Stocker dans les settings du projet
        this.settings.drawingData = {
          history: this.drawingHistory,
          canvasData: this.canvasData,
          lastModified: Date.now(),
        };

        console.log("Données de dessin sauvegardées dans les settings");
      } else {
        // Supprimer les données si pas de dessin
        delete this.settings.drawingData;
      }
    },

    // Charger les données de dessin depuis les settings
    loadDrawingData() {
      console.log("loadDrawingData appelée");
      console.log("settings:", this.settings);
      console.log("settings.drawingData:", this.settings.drawingData);

      if (this.settings.drawingData) {
        try {
          console.log("Chargement des données de dessin depuis les settings");
          this.drawingHistory = this.settings.drawingData.history || [];
          this.canvasData = this.settings.drawingData.canvasData || null;

          console.log(
            "Données de dessin chargées:",
            this.drawingHistory.length,
            "strokes"
          );
          console.log("Premier stroke:", this.drawingHistory[0]);

          // Appliquer au canvas si il existe et est prêt
          this.applyDrawingDataToCanvas();
        } catch (error) {
          console.error(
            "Erreur lors du chargement des données de dessin:",
            error
          );
          // Supprimer les données corrompues
          delete this.settings.drawingData;
        }
      } else {
        console.log("Aucunes données de dessin trouvées dans les settings");
      }
    },

    // Appliquer les données de dessin au canvas quand il est disponible
    applyDrawingDataToCanvas() {
      console.log("applyDrawingDataToCanvas appelée");
      console.log("drawingMode:", this.drawingMode);
      console.log("$refs.drawingCanvas:", !!this.$refs.drawingCanvas);
      console.log("drawingHistory length:", this.drawingHistory?.length || 0);

      if (
        this.$refs.drawingCanvas &&
        this.drawingHistory &&
        this.drawingHistory.length > 0
      ) {
        console.log(
          "Application des données au canvas:",
          this.drawingHistory.length,
          "strokes"
        );
        this.$refs.drawingCanvas.loadDrawingHistory(this.drawingHistory);
      } else if (
        !this.$refs.drawingCanvas &&
        this.drawingHistory &&
        this.drawingHistory.length > 0
      ) {
        console.log(
          "Canvas pas encore disponible, programmation d'une tentative ultérieure"
        );
        // Réessayer après un délai si le canvas n'est pas encore disponible
        setTimeout(() => {
          if (this.$refs.drawingCanvas) {
            console.log(
              "Tentative ultérieure réussie, application des données"
            );
            this.$refs.drawingCanvas.loadDrawingHistory(this.drawingHistory);
          } else {
            console.warn("Canvas toujours pas disponible après délai");
          }
        }, 200);
      } else {
        console.log(
          "Pas de données de dessin à appliquer ou canvas non disponible"
        );
      }
    },

    // Obtenir les données du canvas pour l'export
    async getCanvasDataForExport() {
      if (!this.settings.drawingData || !this.drawingHistory.length) {
        return null;
      }

      try {
        // Si on a un canvas actif, l'utiliser
        if (this.$refs.drawingCanvas) {
          const blob = await this.$refs.drawingCanvas.getCanvasBlob();
          return blob;
        }

        // Sinon, utiliser les données sauvegardées
        if (this.settings.drawingData.canvasData) {
          // Convertir dataURL en blob
          const response = await fetch(this.settings.drawingData.canvasData);
          return await response.blob();
        }

        return null;
      } catch (error) {
        console.error("Erreur lors de l'export du canvas:", error);
        return null;
      }
    },
    onCanvasReady() {
      console.log("Canvas prêt, application des données de dessin");
      // Appliquer les données de dessin quand le canvas devient prêt
      this.applyDrawingDataToCanvas();
    },

    // Méthode de test pour déboguer
    testDrawingDataLoad() {
      console.log("=== TEST DRAWING DATA LOAD ===");
      console.log("settings.drawingData exists:", !!this.settings.drawingData);
      console.log("drawingHistory length:", this.drawingHistory?.length || 0);
      console.log("drawingMode:", this.drawingMode);

      if (this.settings.drawingData && !this.drawingMode) {
        console.log("Activation temporaire du mode dessin pour test");
        this.drawingMode = true;
        this.$nextTick(() => {
          console.log(
            "Canvas ref après activation:",
            !!this.$refs.drawingCanvas
          );
          this.applyDrawingDataToCanvas();
        });
      } else if (this.drawingMode) {
        this.applyDrawingDataToCanvas();
      }
    },
    formatDuration(seconds) {
      if (!seconds) return "0:00";
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
    },
    shareVideo() {
      if (navigator.share && this.outputURL) {
        navigator
          .share({
            title: "Ma vidéo Voxdub",
            text: "Regardez ma vidéo créée avec Voxdub !",
            url: this.outputURL,
          })
          .catch(console.error);
      } else {
        // Fallback: copy URL to clipboard
        navigator.clipboard.writeText(this.outputURL).then(() => {
          this.snackbar = true;
          this.snackbarMessage = "Lien copié dans le presse-papier !";
        });
      }
    },
    updateTasksFromChild(updatedTasks) {
      // Mettre à jour le store avec les tâches modifiées côté client
      this.$store.dispatch("setTasks", updatedTasks);
    },
    openRecordingStudioForSubtitle(subtitle) {
      // Positionner la vidéo sur le sous-titre et lancer le DubbingRecorder
      this.selectedSubtitle = subtitle;
      this.selectedCharacter = subtitle.character;
      this.$refs.video.currentTime = subtitle.start;
      this.$nextTick(() => {
        if (this.$refs.dubbingRecorder) {
          this.$refs.dubbingRecorder.selectedCharacter = subtitle.character;
          this.$refs.dubbingRecorder.startRecording();
        }
      });
    },

    handleAudioStudioSave(audioData) {
      // Intégrer la nouvelle prise enregistrée dans le projet
      const source = {
        id: audioData.id,
        name: audioData.name,
        character: audioData.character,
        subtitle_id: audioData.subtitle_id,
        subtitle: audioData.subtitle_id,
        duration: audioData.duration,
        start: audioData.start,
        end: audioData.end,
        src: audioData.src,
        blob: audioData.blob,
        processed: audioData.processed,
        settings: audioData.settings,
      };

      // Si le personnage est "all", c'est une piste globale, sinon c'est une prise
      // Dans Voxdub, les Character-based sources sont ajoutées au tableau sources
      this.sources.unshift(source);

      this.snackbarMessage = "Prise enregistrée avec succès";
      this.snackbar = true;

      // Optionnel: sauvegarder automatiquement
      this.saveProject();
    },

    // --- DubbingRecorder handlers ---
    toggleAudioTracks() {
      this.showAudioTracks = !this.showAudioTracks;
      if (this.showAudioTracks) {
        this.$nextTick(() => {
          // Force wavesurfer redraw after v-show reveals container
          this.audioSources.forEach((source) => {
            const refs = this.$refs[`audioTrackWs_${source.id}`];
            if (refs && refs[0] && refs[0].wavesurfer) {
              refs[0].wavesurfer.drawBuffer();
            }
          });
        });
      }
    },
    onDubbingRecordingStart({ startTime }) {
      this.isRecording = true;
      this.startRecording = startTime;
      this.recordingTime = 0;
      this._audioPlaybackSuspended = true;
      this.pauseSyncedAudioPlayers();
    },
    async onDubbingRecordingDone(source) {
      this.isRecording = false;
      this._audioPlaybackSuspended = false;

      const newSource = {
        id: this.sources.length + 1,
        name: this.$moment().unix(),
        character: source.character,
        duration: source.duration,
        start: source.start,
        end: source.end,
        src: source.src,
      };

      this.sources = await this.decouperSourcesChevauchantes(
        newSource,
        this.sources,
        newSource.character
      );
      this.sources.push(newSource);
      this.sources = this.sources.map((s, i) => { s.id = i + 1; return s; });
      this.lastRecordedSource = newSource;
      this._audioPlayersCache = null; // Reset cache for syncAudio

      // Refresh audio tracks display
      this.$nextTick(() => {
        if (this.$refs.audioTracks) this.$refs.audioTracks.refresh();
      });

      this.snackbar = true;
      this.snackbarMessage = "Enregistrement terminé";
    },
    onDubbingRecordingError(msg) {
      this.isRecording = false;
      this._audioPlaybackSuspended = false;
      this.snackbar = true;
      this.snackbarMessage = msg || "Impossible d'accéder au microphone";
    },
    onSourceMoved({ trackId, startPosition }) {
      const source = this.sources.find((s) => s.character !== "all" && s.id === trackId);
      if (source) {
        const duration = source.end - source.start;
        source.start = startPosition;
        source.end = startPosition + duration;
      }
    },
    startAudioSegmentDrag(e, source) {
      e.preventDefault();
      const pxPerSec = 25 * this.settings.fontSize;
      const startX = e.clientX;
      const origStart = source.start;
      const duration = source.end - source.start;
      const el = e.currentTarget;
      el.style.cursor = "grabbing";
      el.style.opacity = "0.8";

      const onMove = (ev) => {
        const dx = ev.clientX - startX;
        const dt = dx / pxPerSec;
        const newStart = Math.max(0, origStart + dt);
        source.start = newStart;
        source.end = newStart + duration;
        el.style.left = (newStart * pxPerSec) + "px";
      };

      const onUp = () => {
        el.style.cursor = "grab";
        el.style.opacity = "1";
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onUp);
      };

      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", onUp);
    },

    // Ancien système d'enregistrement (legacy)
    async startRecordingWithPreRoll() {
      if (this.isRecording) return;

      // Legacy: plus d'onglet audio séparé

      // Initialiser l'audio context si nécessaire
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();
      }

      // Démarrer le countdown
      this.countdown = this.recordingSettings.preRoll;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.startActualRecording();
        }
      }, 1000);

      // Si autoPlay est activé, reculer la vidéo et la lancer
      if (this.recordingSettings.autoPlay && this.$refs.video) {
        let startTime;
        if (this.audioEditMode === "overwrite" && this.hasAudioSelection) {
          startTime = Math.max(
            0,
            this.audioSelectionStart - this.recordingSettings.preRoll
          );
        } else {
          startTime = Math.max(
            0,
            this.$refs.video.currentTime - this.recordingSettings.preRoll
          );
        }
        this.$refs.video.currentTime = startTime;
        this.$refs.video.play();
      }

      window.gtag("event", "record_audio_rythmo");
    },

    async quickRecord() {
      // Enregistrement rapide sans pre-roll
      this.countdown = 0;
      await this.startActualRecording();
      window.gtag("event", "quick_record_audio");
    },

    async startActualRecording() {
      try {
        // Obtenir le stream audio avec les paramètres avancés
        this.mediaStream = await navigator.mediaDevices.getUserMedia({
          audio: {
            echoCancellation: this.recordingSettings.echoCancellation,
            noiseSuppression: this.recordingSettings.noiseSuppression,
            autoGainControl: this.recordingSettings.autoGain,
          },
        });

        // Créer la chaîne audio avec les effets
        const source = this.audioContext.createMediaStreamSource(
          this.mediaStream
        );
        let processedSource = source;

        // Appliquer les effets audio
        processedSource = this.applyAudioProcessing(processedSource);

        // Le feedback visuel actuel repose déjà sur les états réactifs du REC.
        // Éviter un analyseur + une boucle RAF qui ne servent pas au rendu.
        this.audioAnalyser = null;

        this.isRecording = true;
        this._audioPlaybackSuspended = true;
        this.pauseSyncedAudioPlayers();
        this.recordingTime = 0;
        this.recordedSamples = [];
        this.currentBufferLength = 0;

        // Calculer le startTime basé sur la position actuelle
        this.startRecording = this.$refs.video.currentTime;

        // Configurer le ScriptProcessor pour l'enregistrement PCM (WAV)
        this.scriptProcessor = this.audioContext.createScriptProcessor(
          4096,
          1,
          1
        );
        this.scriptProcessor.onaudioprocess = (e) => {
          if (!this.isRecording) return;
          const inputData = e.inputBuffer.getChannelData(0);
          this.recordedSamples.push(new Float32Array(inputData));
          this.currentBufferLength += inputData.length;
        };

        this.recordingMonitorNode = this.audioContext.createGain();
        this.recordingMonitorNode.gain.value = 0;
        processedSource.connect(this.scriptProcessor);
        this.scriptProcessor.connect(this.recordingMonitorNode);
        this.recordingMonitorNode.connect(this.audioContext.destination);

        // Démarrer le timer
        this.recordingTimer = setInterval(() => {
          this.recordingTime += 0.1;

          // Punch-out automatique en mode Overwrite
          if (this.audioEditMode === "overwrite" && this.hasAudioSelection) {
            if (this.$refs.video.currentTime >= this.audioSelectionEnd) {
              this.stopRecording();
            }
          }

          // Auto-stop avec post-roll
          if (this.recordingSettings.postRoll > 0) {
            const currentTime = this.$refs.video.currentTime;

            // Si on suit les sous-titres et qu'on a un personnage sélectionné
            if (
              this.recordingSettings.followSubtitles &&
              this.selectedCharacter
            ) {
              // Trouver le prochain sous-titre du personnage
              const nextCharacterSubtitle = this.subtitles
                .filter(
                  (s) =>
                    s.character === this.selectedCharacter &&
                    s.start > this.startRecording
                )
                .sort((a, b) => a.start - b.start)[0];

              // Si on a dépassé le post-roll du dernier sous-titre du personnage enregistré
              const lastRecordedSubtitle = this.subtitles
                .filter(
                  (s) =>
                    s.character === this.selectedCharacter &&
                    s.start <= currentTime &&
                    s.end >= this.startRecording
                )
                .sort((a, b) => b.end - a.end)[0];

              if (
                lastRecordedSubtitle &&
                currentTime >=
                  lastRecordedSubtitle.end + this.recordingSettings.postRoll
              ) {
                // S'il n'y a pas de prochain sous-titre ou qu'il est trop loin
                if (
                  !nextCharacterSubtitle ||
                  nextCharacterSubtitle.start > currentTime + 1
                ) {
                  this.stopRecording();
                }
              }
            } else {
              // Comportement par défaut
              const activeSubtitle = this.getActiveRecordingSubtitle();
              if (
                activeSubtitle &&
                currentTime >=
                  activeSubtitle.end + this.recordingSettings.postRoll
              ) {
                this.stopRecording();
              }
            }
          }

        }, 100);

        // Si la vidéo est en pause, la relancer
        if (this.$refs.video && this.$refs.video.paused) {
          this.$refs.video.play();
        }
      } catch (error) {
        console.error("Erreur lors du démarrage de l'enregistrement:", error);
        this.snackbar = true;
        this.snackbarMessage = "Impossible d'accéder au microphone";
        this.error = true;
        this.errorMessage = error.message;
        this.cleanup();
      }
    },

    async stopRecording() {
      if (!this.isRecording) return;

      this.isRecording = false;
      this._audioPlaybackSuspended = false;

      if (this.scriptProcessor) {
        this.scriptProcessor.disconnect();
        this.scriptProcessor = null;
      }
      if (this.recordingMonitorNode) {
        this.recordingMonitorNode.disconnect();
        this.recordingMonitorNode = null;
      }

      await this.processRecordedAudio();

      if (this.recordingTimer) {
        clearInterval(this.recordingTimer);
        this.recordingTimer = null;
      }

      // Arrêter la vidéo si elle tourne
      if (this.$refs.video && !this.$refs.video.paused) {
        this.$refs.video.pause();
      }

      // Nettoyer le stream
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach((track) => track.stop());
        this.mediaStream = null;
      }

      this.audioAnalyser = null;
    },

    async processRecordedAudio() {
      if (this.recordedSamples.length === 0) return;

      // Combiner tous les échantillons en un seul Float32Array
      const result = new Float32Array(this.currentBufferLength);
      let offset = 0;
      for (let i = 0; i < this.recordedSamples.length; i++) {
        result.set(this.recordedSamples[i], offset);
        offset += this.recordedSamples[i].length;
      }

      // Créer un AudioBuffer avec les échantillons enregistrés
      const audioBuffer = this.audioContext.createBuffer(
        1,
        this.currentBufferLength,
        this.audioContext.sampleRate
      );
      audioBuffer.getChannelData(0).set(result);

      // Convertir en WAV
      const wavBytes = toWav(audioBuffer);
      const blob = new Blob([new DataView(wavBytes)], { type: "audio/wav" });
      const audioUrl = URL.createObjectURL(blob);

      // Déterminer le personnage
      let character =
        this.selectedCharacter || this.getArrayOfAvailableCharacter[0];

      // Si on suit les sous-titres ET qu'aucun personnage n'est explicitement sélectionné
      if (this.recordingSettings.followSubtitles && !this.selectedCharacter) {
        const recordedSubtitles = this.getSubtitlesInTimeRange(
          this.startRecording,
          this.startRecording + this.recordingTime
        );
        if (recordedSubtitles.length > 0) {
          // Prendre le personnage du sous-titre principal (celui avec le plus de durée couverte)
          const mainSubtitle = recordedSubtitles.reduce((prev, current) => {
            const prevDuration =
              Math.min(prev.end, this.startRecording + this.recordingTime) -
              Math.max(prev.start, this.startRecording);
            const currentDuration =
              Math.min(current.end, this.startRecording + this.recordingTime) -
              Math.max(current.start, this.startRecording);
            return currentDuration > prevDuration ? current : prev;
          });
          character = mainSubtitle.character || character;
        }
      }

      // Créer la nouvelle source
      const newSource = {
        id: this.sources.length + 1,
        name: this.$moment().unix(),
        character: character,
        duration: this.recordingTime,
        start: this.startRecording - 0.1 < 0 ? 0 : this.startRecording - 0.1,
        end: this.startRecording + this.recordingTime,
        src: audioUrl,
      };

      // Découper les sources chevauchantes
      this.sources = await this.decouperSourcesChevauchantes(
        newSource,
        this.sources,
        newSource.character
      );
      this.sources.push(newSource);

      // Réindexer
      this.sources = this.sources.map((source, index) => {
        source.id = index + 1;
        return source;
      });

      this.lastRecordedSource = newSource;
      this.recordedChunks = [];

      // Feedback de succès
      this.snackbar = true;
      this.snackbarMessage = "Enregistrement terminé avec succès";
    },

    getSubtitlesInTimeRange(start, end) {
      return this.subtitles.filter((subtitle) => {
        return subtitle.start < end && subtitle.end > start;
      });
    },

    async punchAndRoll() {
      if (!this.lastRecordedSource) return;

      // Reculer de 2 secondes avant la fin du dernier enregistrement
      const rollbackTime = 2;
      const startTime = Math.max(0, this.lastRecordedSource.end - rollbackTime);

      this.$refs.video.currentTime = startTime;
      await this.startRecordingWithPreRoll();
    },

    // Méthodes pour la sélection audio dans le tab Audio
    handleAudioMouseDown(e) {
      if (this.isRecording) return;

      const rect = e.currentTarget.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const pixelsPerSecond = this.base_rate * this.settings.fontSize;
      const time = x / pixelsPerSecond;

      this.isSelectingAudio = true;
      this.audioSelectionStart = time;
      this.audioSelectionEnd = time;
      this.hasAudioSelection = true;
    },

    handleAudioMouseMove(e) {
      if (!this.isSelectingAudio) return;

      const rect = e.currentTarget.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const pixelsPerSecond = this.base_rate * this.settings.fontSize;
      const time = Math.max(this.audioSelectionStart, x / pixelsPerSecond);

      this.audioSelectionEnd = time;
    },

    handleAudioMouseUp() {
      this.isSelectingAudio = false;
      if (this.audioSelectionEnd - this.audioSelectionStart < 0.05) {
        this.hasAudioSelection = false;
      }
    },

    async cutAudioSelection() {
      if (!this.hasAudioSelection || this.sources.length === 0) return;

      // Trouver la source qui est sous la sélection (simplifié: on prend la première qui matche)
      // TODO: Gérer le personnage sélectionné
      const sourceToCut = this.sources.find(
        (s) =>
          s.start < this.audioSelectionEnd &&
          s.end > this.audioSelectionStart &&
          (!this.selectedCharacter || s.character === this.selectedCharacter)
      );

      if (!sourceToCut) {
        this.snackbarMessage = "Aucun segment audio trouvé dans la sélection";
        this.snackbar = true;
        return;
      }

      try {
        if (!this.audioProcessor) {
          this.audioProcessor = new AudioProcessor(this.audioContext);
        }

        // Décoder l'audio si nécessaire
        const response = await fetch(sourceToCut.src);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await this.audioContext.decodeAudioData(
          arrayBuffer
        );

        // Calculer les temps relatifs à la source
        const startRel = Math.max(
          0,
          this.audioSelectionStart - sourceToCut.start
        );
        const endRel = Math.min(
          audioBuffer.duration,
          this.audioSelectionEnd - sourceToCut.start
        );

        const newBuffer = this.audioProcessor.cutAudio(
          audioBuffer,
          startRel,
          endRel
        );

        if (newBuffer) {
          const wavBytes = toWav(newBuffer);
          const blob = new Blob([new DataView(wavBytes)], {
            type: "audio/wav",
          });
          const url = URL.createObjectURL(blob);

          // Mettre à jour la source
          sourceToCut.src = url;
          sourceToCut.blob = blob;
          sourceToCut.end = sourceToCut.start + newBuffer.duration;

          this.snackbarMessage = "Segment coupé avec succès";
          this.snackbar = true;
          this.hasAudioSelection = false;

          // Sauvegarder
          this.saveProject();
        }
      } catch (error) {
        console.error("Erreur lors de la coupe audio:", error);
        this.snackbarMessage = "Erreur lors de la coupe audio";
        this.snackbar = true;
      }
    },

    getNextSubtitleAtTime(time) {
      // Trouver le prochain sous-titre qui commence après le temps donné
      return this.subtitles
        .filter((s) => s.start <= time && s.end >= time)
        .sort((a, b) => a.start - b.start)[0];
    },

    formatRecordingTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      const ms = Math.floor((seconds % 1) * 10);
      return `${mins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}.${ms}`;
    },

    cleanup() {
      this.countdown = 0;
      this.recordingTime = 0;
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      if (this.recordingTimer) {
        clearInterval(this.recordingTimer);
        this.recordingTimer = null;
      }
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach((track) => track.stop());
        this.mediaStream = null;
      }
      if (this.scriptProcessor) {
        this.scriptProcessor.disconnect();
        this.scriptProcessor = null;
      }
      if (this.recordingMonitorNode) {
        this.recordingMonitorNode.disconnect();
        this.recordingMonitorNode = null;
      }
    },

    startRealtimeVisualization() {
      if (!this.audioAnalyser) return;

      const bufferLength = this.audioAnalyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);

      const animate = () => {
        if (!this.isRecording || !this.audioAnalyser) return;

        this.audioAnalyser.getByteFrequencyData(dataArray);

        // Calculer le niveau moyen pour l'animation
        let sum = 0;
        for (let i = 0; i < bufferLength; i++) {
          sum += dataArray[i];
        }
        const average = sum / bufferLength;

        // Stocker les données pour la visualisation
        this.recordingWaveData.push({
          time: this.recordingTime,
          level: average / 255,
        });

        // Limiter la taille du buffer
        if (this.recordingWaveData.length > 1000) {
          this.recordingWaveData.shift();
        }

        requestAnimationFrame(animate);
      };

      animate();
    },

    updateRecordingVisualization() {
      // recordingTime est déjà réactif et suffit à rafraîchir l'UI du REC
    },

    resetAudioSettings() {
      this.recordingSettings.audioGain = 0;
      this.recordingSettings.noiseGate = -50;
      this.recordingSettings.echoCancellation = true;
      this.recordingSettings.noiseSuppression = true;
      this.recordingSettings.autoGain = false;
    },

    applyAudioProcessing(source) {
      if (!this.audioProcessor) {
        this.audioProcessor = new AudioProcessor(this.audioContext);
      }

      // Créer la chaîne de traitement pro
      const nodes = this.audioProcessor.createProcessingChain();

      // Appliquer les paramètres utilisateur
      // Gain d'entrée
      nodes.inputGain.gain.value = Math.pow(
        10,
        this.recordingSettings.audioGain / 20
      );

      // Noise Gate (si activé dans AudioProcessor, sinon on peut simplifier)
      // On peut ajuster le seuil du gate ici si besoin

      // Compressor & Limiter sont dans la chaîne par défaut

      // Connecter la source à l'entrée de la chaîne
      source.connect(nodes.inputGain);

      // Retourner la sortie de la chaîne
      return nodes.outputGain;
    },

    getCharacterTrackPosition(character) {
      const characters = this.getArrayOfAvailableCharacter;
      const index = characters.indexOf(character);
      const trackHeight = this.settings.height / characters.length;
      return index * trackHeight;
    },

    handleAudioScroll(e) {
      this._lastAudioScrollLeft = e.target.scrollLeft;
    },

    async refreshWaveforms() {
      this.snackbar = true;
      this.snackbarMessage = "Actualisation des formes d'onde...";

      // Invalider le cache des éléments audio
      this._audioPlayersCache = null;

      // Forcer la ré-assignation pour déclencher la réactivité
      const currentSources = [...this.sources];
      this.sources = [];
      await this.$nextTick();
      this.sources = currentSources;

      this.snackbarMessage = "Formes d'onde actualisées";
    },

    toggleMuteCharacter(character) {
      // Toggle mute pour toutes les sources d'un personnage
      const sources = this.sourcesGroupedByCharacters[character] || [];
      const shouldMute = !this.isCharacterMuted(character);

      sources.forEach((source) => {
        source.muted = shouldMute;
        // Mettre à jour la waveform si elle existe
        const waveformRef = this.$refs[`audio${source.character}${source.id}`];
        if (waveformRef && waveformRef[0]) {
          waveformRef[0].setMute(shouldMute);
        }
      });

      this.$forceUpdate();
    },

    isCharacterMuted(character) {
      const sources = this.sourcesGroupedByCharacters[character] || [];
      return sources.length > 0 && sources.every((source) => source.muted);
    },

    hexToRgba(hex, alpha) {
      // Convertir hex en rgba avec transparence
      if (!hex) return `rgba(128, 128, 128, ${alpha})`;

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      if (result) {
        const r = parseInt(result[1], 16);
        const g = parseInt(result[2], 16);
        const b = parseInt(result[3], 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      }
      return `rgba(128, 128, 128, ${alpha})`;
    },

    isRecordingForSubtitle(subtitle) {
      if (!this.isRecording || !this.startRecording) return false;

      // Si on a un personnage sélectionné et qu'on suit les sous-titres
      if (this.selectedCharacter && this.recordingSettings.followSubtitles) {
        // Ne montrer l'indicateur que pour les sous-titres de ce personnage
        if (subtitle.character !== this.selectedCharacter) {
          return false;
        }
      }

      const currentTime = this.videoTime;
      const recordStart = this.startRecording;
      const recordEnd = recordStart + this.recordingTime;

      // Vérifier si l'enregistrement chevauche avec ce sous-titre
      return recordStart <= subtitle.end && recordEnd >= subtitle.start;
    },

    getRecordingIndicatorStyle(subtitle) {
      const left = subtitle.start * this.base_rate * this.settings.fontSize;
      const width =
        (subtitle.end - subtitle.start) *
        this.base_rate *
        this.settings.fontSize;
      const y =
        subtitle.y || this.heightBySeed(subtitle.character || "character");

      return {
        position: "absolute",
        left: `${left}px`,
        width: `${width}px`,
        top: `${y - 20}px`,
        height: "20px",
        zIndex: 2000,
        pointerEvents: "none",
      };
    },

    getSessionCharacterIndicatorStyle(subtitle) {
      const left = subtitle.start * this.base_rate * this.settings.fontSize;
      const y =
        subtitle.y || this.heightBySeed(subtitle.character || "character");

      return {
        position: "absolute",
        left: `${left - 25}px`,
        top: `${y + 5}px`,
        width: "20px",
        height: "20px",
        zIndex: 1500,
        pointerEvents: "none",
      };
    },

    getActiveRecordingSubtitle() {
      if (!this.isRecording) return null;

      const currentTime = this.videoTime;

      // Si le suivi des sous-titres est désactivé, retourner null
      if (!this.recordingSettings.followSubtitles) {
        return null;
      }

      // Si on a un personnage sélectionné pour la session
      if (this.selectedCharacter) {
        // Chercher uniquement parmi les sous-titres de ce personnage
        const characterSubtitles = this.subtitles.filter(
          (s) =>
            s.character === this.selectedCharacter &&
            currentTime >= s.start &&
            currentTime <= s.end
        );

        if (characterSubtitles.length > 0) {
          const activeSubtitle = characterSubtitles[0];
          // Sélectionner automatiquement ce sous-titre
          if (this.recordingSettings.autoPlay) {
            this.selectedSubtitle = activeSubtitle;
          }
          return activeSubtitle;
        }

        // Si aucun sous-titre du personnage n'est actif, retourner null
        return null;
      }

      // Si aucun personnage n'est sélectionné, comportement par défaut
      // Si on a un sous-titre sélectionné, l'utiliser en priorité
      if (
        this.selectedSubtitle &&
        currentTime >= this.selectedSubtitle.start &&
        currentTime <= this.selectedSubtitle.end
      ) {
        return this.selectedSubtitle;
      }

      // Sinon, trouver le sous-titre actif au temps actuel
      const activeSubtitle = this.subtitles.find(
        (subtitle) =>
          currentTime >= subtitle.start && currentTime <= subtitle.end
      );

      // Si on trouve un sous-titre actif, le sélectionner automatiquement
      if (activeSubtitle && this.recordingSettings.autoPlay) {
        this.selectedSubtitle = activeSubtitle;
        this.selectedCharacter = activeSubtitle.character;
      }

      return activeSubtitle;
    },

    getRecordingBarStyle() {
      const width =
        (this.videoTime - this.startRecording) *
        this.base_rate *
        this.settings.fontSize;
      const left =
        this.startRecording * this.base_rate * this.settings.fontSize;

      // Barre fine qui suit toute la hauteur disponible
      return {
        position: "absolute",
        left: `${left}px`,
        width: `${width}px`,
        top: "0px",
        height: `${this.settings.height}px`,
        opacity: 0.5,
      };
    },
  },
  mounted() {
    // Vérifier et rafraîchir le profil utilisateur si nécessaire
    this.checkAndRefreshUserProfile();

    // Initialiser les tailles depuis les settings si elles existent
    if (this.settings.videoSectionWidth) {
      this.videoSectionWidth = this.settings.videoSectionWidth;
    }
    if (this.settings.subtitleSectionWidth) {
      this.subtitleSectionWidth = this.settings.subtitleSectionWidth;
    }
    if (this.settings.rythmoSectionHeight) {
      this.rythmoSectionHeight = this.settings.rythmoSectionHeight;
    }

    // Initialiser les thèmes sélectionnés depuis choiceTheme
    this.selectedThemes = Object.entries(this.choiceTheme)
      .filter(([key, value]) => value)
      .map(([key, value]) => value);

    // Listener pour les changements de taille de fenêtre
    window.addEventListener("resize", this.handleWindowResize);

    // Setup initial
    this.handleWindowResize();
    this.$nextTick(() => {
      this.refreshRythmoMeasurements();
      this.setupRythmoResizeObserver();
    });

    // Charger les préférences BWF depuis localStorage
    const savedBwfMapping = localStorage.getItem("bwfMicrophoneMapping");
    if (savedBwfMapping) {
      try {
        this.bwfMicrophoneMapping = JSON.parse(savedBwfMapping);
      } catch (e) {
        console.error("Erreur lors du chargement des préférences BWF:", e);
      }
    }

    const savedBwfIncludeSessionInfo = localStorage.getItem(
      "bwfIncludeSessionInfo"
    );
    if (savedBwfIncludeSessionInfo !== null) {
      this.bwfIncludeSessionInfo = savedBwfIncludeSessionInfo === "true";
    }

    // Synchronisation bidirectionnelle du scrolling - desactivee pendant la lecture
    this.$nextTick(() => {
      let isScrollingRythmo = false;
      let isScrollingAudio = false;
      let scrollSyncTimeout = null;

      if (this.$refs.offsetDiv) {
        this.$refs.offsetDiv.addEventListener("scroll", (e) => {
          // Ignorer pendant la lecture video - updateScrollPosition gere le scroll
          if (this.$refs.video && !this.$refs.video.paused) return;
          if (isScrollingAudio || !this.$refs.offsetDivAudio) return;
          
          isScrollingRythmo = true;
          this.$refs.offsetDivAudio.scrollLeft = e.target.scrollLeft;
          clearTimeout(scrollSyncTimeout);
          scrollSyncTimeout = setTimeout(() => { isScrollingRythmo = false; }, 50);
        }, { passive: true });
      }

      if (this.$refs.offsetDivAudio) {
        this.$refs.offsetDivAudio.addEventListener("scroll", (e) => {
          if (this.$refs.video && !this.$refs.video.paused) return;
          if (isScrollingRythmo || !this.$refs.offsetDiv) return;
          
          isScrollingAudio = true;
          this.$refs.offsetDiv.scrollLeft = e.target.scrollLeft;
          clearTimeout(scrollSyncTimeout);
          scrollSyncTimeout = setTimeout(() => { isScrollingAudio = false; }, 50);
        }, { passive: true });
      }
    });

    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.tasksInterval = setInterval(() => {
      if (!this.taskPopup) return;
      this.getTasks();
    }, 5000);
    this.tipInterval = setInterval(() => {
      if (this.saveInProgress) {
        this.tips.map((tip) => (tip.show = false));
        this.tips[Math.floor(Math.random() * this.tips.length)].show = true;
      }
    }, 10000);
    if (this.$vuetify.breakpoint.mobile) {
      this.cinemaMode = true;
      this.$nextTick(() => {
        this.selectedSubtitle = { id: null };
      });
    }
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
      this.innerHeight = window.innerHeight;
    });
    window.html2canvas = html2canvas;
    // prevent window leave
    window.onbeforeunload = function () {
      return "Are you sure you want to leave?";
    };
    this.$nextTick(() => {
      this.initInteract();
      this.initInteractLetter();
      this.initResizableWindow();
      this.initDraggableAudio();
      this.initItemInteract();
    });
    // add event listener mouse scroll
    document.addEventListener("wheel", (e) => {
      // prevent when text input is focused
      if (document.activeElement.tagName == "INPUT") return;
      // if press ctrl or cmd + mouse scroll
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
        // if scroll up, increase video time
        if (e.deltaY < 0 || e.deltaX < 0) {
          this.$refs.video.currentTime += 1 / 25;
        }
        // if scroll down, decrease video time
        if (e.deltaY > 0 || e.deltaX > 0) {
          this.$refs.video.currentTime -= 1 / 25;
        }
      }
    });
    // if press space bar, play/pause video
    document.addEventListener("keydown", (e) => {
      // prevent when text input is focused
      if (!this.$refs.video) return;
      if (this.renderDone) return;
      if (
        document.activeElement.tagName == "INPUT" ||
        document.activeElement.tagName == "DIV" ||
        document.activeElement.tagName == "TEXTAREA"
      )
        return;
      if (e.keyCode == 32) {
        e.preventDefault();
        // unfocus video
        if (document.activeElement.tagName == "VIDEO") {
          if (this.$refs.video) {
            this.$refs.video.blur();
          }
        }
        if (!this.$refs.video) return;
        // Optimisation : éviter les appels multiples rapides
        if (!this._playDebounce) {
          this._playDebounce = true;
          this.playVideo();
          setTimeout(() => {
            this._playDebounce = false;
          }, 100);
        }
      }
      // undo operation
      if ((e.keyCode == 90 && e.ctrlKey) || (e.keyCode == 90 && e.metaKey)) {
        e.preventDefault();
        this.undo();
      }
      // if press right arrow and shift key, increase video time
      if (e.keyCode == 39 && e.shiftKey) {
        e.preventDefault();
        this.$refs.video.currentTime += 1;
      }
      // if press left arrow and shift key, decrease video time
      if (e.keyCode == 37 && e.shiftKey) {
        e.preventDefault();
        this.$refs.video.currentTime -= 1;
      }
      // if press right arrow, increase video time
      if (e.keyCode == 39) {
        e.preventDefault();
        this.$refs.video.currentTime += 1 / 25;
        // play video audio source on the range of currentTime
        // play one frame and stop
        if (!this.$refs.video.paused) return;
        try {
          this.$refs.video.play();
        } catch (err) {
          console.log(err);
        }
        setTimeout(() => {
          try {
            this.$refs.video.pause();
          } catch (err) {
            console.log(err);
          }
        }, 100);
      }
      // if press left arrow, decrease video time
      if (e.keyCode == 37) {
        e.preventDefault();
        this.$refs.video.currentTime -= 1 / 25;
        // play video audio source on the range of currentTime
        // play one frame and stop
        if (!this.$refs.video.paused) return;
        try {
          // this.$refs.video.play();
        } catch (err) {
          console.log(err);
        }
        setTimeout(() => {
          try {
            // this.$refs.video.pause();
          } catch (err) {
            console.log(err);
          }
        }, 100);
      }
      // CTRL or CMD +
      if (e.keyCode == 187 && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        this.createSubtitle("Text here");
        this.selectedSubtitle = this.subtitles[this.subtitles.length - 1];
        this.scrollTo(this.subtitles.length - 1);
      }
      // CMD + S or CTRL + S
      if ((e.keyCode == 83 && e.metaKey) || (e.keyCode == 83 && e.ctrlKey)) {
        e.preventDefault();
        this.saveProject();
      }
      // CMD OR CTRL + K
      if ((e.keyCode == 75 && e.metaKey) || (e.keyCode == 75 && e.ctrlKey)) {
        e.preventDefault();
        if (!this.isRecording) {
          this.startRecordingWithPreRoll();
        } else {
          this.stopRecording();
        }
      }
    });
    document.addEventListener("click", (e) => {
      if (!this.$refs.offsetDiv) return;
      let scroll =
        (e.x / this.$refs.offsetDiv.scrollWidth) * this.videoDuration * 25;
      let time = scroll + this.videoTime;
      this.cursorTime = parseFloat(time);
    });

    // Charger les préférences utilisateur
    this.loadUserPreferences();

    // Écouter les mises à jour des préférences depuis SettingsView
    this.$bus.$on("preferences-updated", (data) => {
      console.log("[Preferences] Preferences updated event received:", data);
      if (data.type === "ui" && data.preferences) {
        // Recharger toutes les préférences pour être sûr
        this.loadUserPreferences();
      }
    });

    // Démarrer l'auto-save
    this.loadAutoSavePreferences();
    this.startAutoSave();

    this.makeIntro();
    this.workspace = this.$route.query.workspace || 40;
    this.loadWorkspace();
    this.getTasks();
    this.$nextTick(() => {
      this.$refs.video.addEventListener("pause", () => {
        if (this.isRecording) {
          this.stopRecording();
        }
      });
    });
  },
  beforeDestroy() {
    // Arrêter l'auto-save
    this.stopAutoSave();

    // Sauvegarder les préférences actuelles
    this.saveUserPreferences();

    // Supprimer le listener des préférences
    this.$bus.$off("preferences-updated");

    clearInterval(this.tasksInterval);
    clearInterval(this.tipInterval);
    this.stopScrollLoop();
    this.cleanupRythmoResizeObserver();

    const video = this.$refs.video;
    if (video && this._videoHandlersAttached) {
      video.removeEventListener(
        "loadedmetadata",
        this._handleVideoLoadedMetadata
      );
      video.removeEventListener("play", this._handleVideoPlay);
      video.removeEventListener("pause", this._handleVideoPause);
      video.removeEventListener("seeked", this._handleVideoSeeked);
      video.removeEventListener("timeupdate", this._handleVideoTimeUpdate);
    }

    window.removeEventListener("resize", this.handleWindowResize);
  },
  beforeRouteLeave(to, from, next) {
    if (!this.confirmLeave) {
      this.confirmLeavePopup = true;
      this.nextRoute = to;
    } else {
      next();
    }
  },
  watch: {
    cinemaMode() {
      this.$store.dispatch("setCinemaMode", this.cinemaMode);
      this.$nextTick(() => {
        this.refreshRythmoMeasurements();
      });
    },
    videoSpeedRate() {
      this.$refs.video.playbackRate = this.videoSpeedRate;
    },
    selectedSubtitle: {
      deep: true,
      handler() {
        if (!this.selectedSubtitle || this.selectedSubtitle.id == null) {
          if (this.selectedCharacter !== null) {
            this.selectedCharacter = null;
          }
          return;
        }

        const nextCharacter = this.selectedSubtitle.character ?? null;
        if (this.selectedCharacter !== nextCharacter) {
          this.selectedCharacter = nextCharacter;
        }
      },
    },
    selectedCharacter: {
      deep: true,
      handler() {
        if (!this.selectedSubtitle || this.selectedSubtitle.id == null) return;
        if (this.selectedSubtitle.character === this.selectedCharacter) return;

        this.selectedSubtitle.character = this.selectedCharacter;
      },
    },
    subtitles: {
      deep: true,
      handler() {
        this.subtitles.forEach((subtitle, index) => {
          subtitle.id = index + 1;
        });
      },
    },
    "settings.height": {
      deep: true,
      handler() {
        console.log("change height");
        this.subtitles.forEach((subtitle) => {
          if (subtitle.y > this.settings.height - 50) {
            subtitle.y = this.settings.height - 50;
          }
        });
        this.$nextTick(() => {
          this.refreshRythmoMeasurements();
        });
        this.$forceUpdate();
      },
    },
    drawingMode: {
      handler(newVal) {
        if (newVal) {
          console.log("Mode dessin activé");
        } else {
          console.log("Mode dessin désactivé");
          // Sauvegarder les données quand on désactive le mode
          this.saveDrawingData();
        }
      },
    },
  },
};
</script>
<style lang="scss">
/* ===== DIRECTION ARTISTIQUE MODERNE DARK - VERSION CORRIGÉE ===== */

/* Container principal spécifique */
.v-container.d-flex.flex-column.pa-0.ma-0[style*="height:100vh"] {
  background: #121212 !important;
}

/* Supprimer le padding bottom de Vuetify qui crée la marge en bas */
.v-main__wrap {
  padding-bottom: 0 !important;
}

/* Header de l'application spécifique */
.v-layout.menu.pa-0.ma-0 {
  background: transparent !important;
  height: auto !important;
  display: flex !important;
  align-items: center !important;
}

/* Forcer l'alignement vertical de tous les éléments enfants dans la barre de menu */
.v-layout.menu > * {
  display: flex !important;
  align-items: center !important;
}

/* Styles pour les tabs dans le menu */
.v-layout.menu .v-tabs {
  background: transparent !important;
  height: 36px !important;
  flex: 0 0 auto !important;
}

.v-layout.menu .v-tabs .v-tab {
  min-width: 80px !important;
  height: 36px !important;
  font-size: 13px !important;
}

/* S'assurer que le MenuBar ne prend pas toute la largeur */
.v-layout.menu .modern-menubar {
  flex: 0 0 auto !important;
}

/* Container du menu */
.menu-container {
  position: relative;
  z-index: 2;
  flex: 0 0 auto !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Barre secondaire pour les tabs et infos */
.secondary-bar {
  background: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 36px;
  height: 36px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.secondary-bar .v-tabs {
  background: transparent !important;
  flex: 0 0 auto !important;
}

.secondary-bar .v-tab {
  color: rgba(255, 255, 255, 0.8) !important;
  text-transform: uppercase;
  font-size: 12px !important;
  font-weight: 500;
  letter-spacing: 0.02em;
  min-width: 60px !important;
  padding: 0 12px !important;
}

.secondary-bar .v-tab--active {
  color: #fff !important;
}

/* Zone du titre du projet */
.project-title-zone {
  text-align: center;
  padding: 3px 20px;
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
  height: 28px;
  overflow: hidden;
}

.project-title-zone:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.15);
}

.project-title-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* Animation subtile au survol */
.project-title-zone:hover .project-title-text {
  color: rgba(255, 255, 255, 1);
  transition: color 0.3s ease;
}

.project-title-zone .v-icon {
  transition: opacity 0.3s ease;
  font-size: 14px !important;
  opacity: 0.7;
}

.project-title-zone:hover .v-icon {
  opacity: 1;
}

/* Zone de statut de sauvegarde */
.save-status-zone {
  min-width: 120px;
  max-width: 180px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  padding-right: 8px;
}

.save-time-text {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  text-align: right;
  line-height: 1;
}

/* Bouton de sauvegarde */
.save-status-zone .v-btn {
  margin-left: 4px !important;
}

/* Responsive - sur mobile, ajuster le titre */
@media (max-width: 1200px) {
  .project-title-zone {
    min-width: 200px;
    padding: 3px 16px;
  }

  .save-status-zone {
    min-width: 100px;
    max-width: 150px;
  }
}

@media (max-width: 960px) {
  .project-title-zone {
    min-width: 150px;
    padding: 2px 12px;
    height: 26px;
  }

  .project-title-text {
    font-size: 12px;
  }

  .save-time-text {
    max-width: 80px;
    font-size: 10px;
  }

  .save-status-zone {
    min-width: 80px;
    max-width: 120px;
  }
}

@media (max-width: 768px) {
  .project-title-zone {
    min-width: 150px;
    padding: 2px 12px;
    height: 24px;
  }

  .project-title-text {
    font-size: 12px;
  }

  .project-title-zone .v-icon {
    font-size: 12px !important;
  }
}

@media (max-width: 600px) {
  .project-title-zone {
    display: none;
  }
}

/* Cards spécifiques - seulement pour les nouvelles interfaces */
.workspace-card,
.settings-card,
.upload-card {
  background: rgba(30, 30, 30, 0.98) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
}

/* Toolbar moderne spécifique */
.fixed-bar.modern-subtitle-toolbar {
  background: linear-gradient(135deg, #1e1e1e 0%, #2d2d2d 100%) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}

/* Text fields modernes spécifiques */
.modern-text-field .v-input__control {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.modern-select .v-input__control {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* Boutons modernes spécifiques */
.modern-icon-btn {
  background: linear-gradient(135deg, #2196f3 0%, #21cbf3 100%) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.modern-icon-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4) !important;
}

/* Section vidéo moderne */
.videocontainer {
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.95) 0%,
    rgba(0, 0, 0, 0.85) 100%
  ) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex: 1 1 0%;
  width: 100%;
  padding: 15px;
}

/* Video avec style moderne */
video {
  max-height: 100%;
  margin: auto;
  aspect-ratio: 16/9;
  width: 100%;
  height: auto;
  position: relative;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(232, 73, 124, 0.3) !important;
}

/* Overlays de sous-titres modernes */
.video-subtitle-text {
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.98) 0%,
    rgba(0, 0, 0, 0.9) 100%
  ) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5) !important;
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 800px;
  padding: 8px 15px;
  color: #fff;
  text-align: center;
  z-index: 1000;
  line-height: 1.4;
  word-wrap: break-word;
}

.subtitle-character {
  background-color: rgba(30, 30, 30, 0.95);
  border-radius: 4px;
  font-size: 0.7em;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  color: white;
  padding: 4px 8px;
  font-weight: 600;
  display: inline-block;
  margin-right: 8px;
  font-size: 0.7em;
}

/* Section rythmo moderne */
.rowbottom {
  background: rgba(30, 30, 30, 0.98) !important;
  border-radius: 16px 16px 0 0 !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  min-height: 15vh;
  max-height: 50vh;
  overflow: hidden !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* Modals modernes spécifiques */
.v-dialog > .v-card {
  background: rgba(30, 30, 30, 0.98) !important;
  border-radius: 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5) !important;
}

.v-dialog .v-card-title {
  background: linear-gradient(135deg, #2d2d2d 0%, #3d3d3d 100%) !important;
  border-radius: 20px 20px 0 0 !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 20px 24px !important;
}

/* Render dialog moderne */
.render-dialog {
  background: linear-gradient(135deg, #1e1e2e 0%, #2d2d4a 100%) !important;
  border-radius: 20px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  overflow: hidden;
}

.render-header {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%) !important;
  border-radius: 20px 20px 0 0 !important;
}

.render-content {
  background: transparent;
  max-height: calc(70vh - 56px);
  overflow-y: auto;
}

.video-preview-container {
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.preview-video {
  width: 100%;
  max-height: 300px;
  border-radius: 8px;
  object-fit: contain;
}

.video-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  text-align: center;
}

.render-info-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.success-message {
  background: linear-gradient(
    135deg,
    rgba(76, 175, 80, 0.1) 0%,
    rgba(102, 187, 106, 0.1) 100%
  );
  border-radius: 8px;
  padding: 15px;
}

.video-stats {
  background: rgba(30, 30, 30, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px !important;
}

.stats-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stat-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
}

.stat-item .v-icon {
  color: rgba(255, 255, 255, 0.7);
}

.download-btn {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%) !important;
  color: white !important;
  text-transform: none !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4) !important;
  transition: all 0.3s ease !important;
  border-radius: 12px !important;
}

.download-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.6) !important;
}

.actions-container {
  width: 100%;
  margin-top: auto;
}

/* Ancien CSS maintenu pour compatibilité */
.subtitle-dialog {
  box-shadow: none;
  transition: box-shadow 0.3s ease;
}
.subtitle-dialog:hover {
  transition: box-shadow 0.3s ease;
  box-shadow: inset 20px 0px 0px 0px #58e2794d,
    inset -20px 0px 0px 0px #6449d178;
}
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&family=Sacramento&family=Oooh+Baby&family=The+Girl+Next+Door&display=swap");
@font-face {
  src: url("@/font/LeagueMono-VF.ttf") format("truetype");
  font-family: League;
  font-style: normal;
  font-weight: 400;
  font-stretch: 50% 200%;
}
#output section {
  font-size: 1.2em;
  font-family: League, sans-serif;
}
.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 0px;
}
.introjs-tooltiptext {
  font-family: "Open Sans";
}
a.introjs-button,
.introjs-button:focus,
.introjs-button:active {
  // primary var color
  background-color: #6449d1 !important;
  color: white;
  border: none;
  text-shadow: none;
  font-family: "Open Sans";
  background-image: none;
}
.introjs-button:focus,
.introjs-button:active {
  background-image: none !important;
}
.introjs-disabled {
  background-color: #373737;
}
// .ws and child elements
wave,
.ws * {
  touch-action: none !important;
}
#divOffset::-webkit-scrollbar {
  display: none;
}
#divOffset,
header {
  -ms-overflow-style: none !important;
  /* IE and Edge */
  scrollbar-width: none !important;
  /* Firefox */
}
.dialogue {
  touch-action: none !important;
  // cursor: pointer;
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
.col::-webkit-scrollbar,
div::-webkit-scrollbar,
header::-webkit-scrollbar {
  display: none;
}
.col,
div {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}
.menu {
  position: relative;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
}
.workspace {
  flex: 2 1 35%;
  z-index: 1;
  display: flex;
  overflow: hidden;
  position: relative;
  -webkit-box-pack: justify;
  justify-content: space-between;
}
.rythmospace {
  position: relative;
  z-index: 0;
  resize: vertical;
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 150px;
}
// Flex
.fullscreen {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  min-height: 0;
}
.top {
  position: relative;
  z-index: 2;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid rgb(0, 0, 0);
  background-color: rgb(28, 31, 47);
}
.center {
  flex: 1 1 0%;
  z-index: 1;
  display: flex;
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid rgb(0, 0, 0);
  -webkit-box-pack: justify;
  justify-content: space-between;
}
.bottom {
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  // height: 150px;
  overflow: hidden;
}
.left {
  height: 100%;
  display: flex;
  position: relative;
  -webkit-box-align: center;
  align-items: center;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  border-right: 1px solid rgb(0, 0, 0);
}
.right {
  height: 100%;
  min-width: 60vw;
  display: flex;
}
.subtitle {
  box-sizing: border-box;
  direction: ltr;
  position: relative;
  will-change: transform;
  overflow: hidden auto;
}
.videocanvas {
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.art-video-player {
  z-index: 20;
  width: 100%;
  height: 100%;
  zoom: 1;
  color: #eee;
  text-align: left;
  direction: ltr;
  user-select: none;
  -webkit-tap-highlight-color: #0000;
  touch-action: manipulation;
  -ms-high-contrast-adjust: none;
  background-color: #000;
  outline: 0;
  margin: 0 auto;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 1.3;
  display: flex;
  position: relative;
}
.rythmoTabActive {
  display: initial !important;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0 !important;
  margin: 0 !important;
}

/* Réinitialisation des marges pour les tabs */
.v-tab-item {
  padding: 0 !important;
  margin: 0 !important;
}

.v-tabs-items {
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
}

.rythmo-tabs-items {
  background-color: transparent !important;
  position: relative;
  flex: 1 1 auto;
  overflow: hidden;
  min-height: 0;
}

.rythmo-tab-item {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  padding: 0 !important;
  margin: 0 !important;
  height: 100%;
}

/* Par défaut, comportement normal de Vuetify */
.rythmo-tabs-items .v-window-item {
  position: relative !important;
}

/* Mode audio : superposer l'onglet audio sur le rythmo */
.rythmo-tabs-items.audio-mode {
  position: relative !important;
}

/* Reset par défaut pour éviter les effets de bord */
.rythmo-tabs-items.audio-mode .v-window-item {
  position: static !important;
}

/* 1) Rythmo (1er item) visible en arrière-plan uniquement en mode audio */
.rythmo-tabs-items.audio-mode .v-window-item:nth-child(1) {
  display: block !important; /* forcer l'affichage même si inactif */
  position: absolute !important; /* superposé sous l'audio */
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 1 !important;
  opacity: 0.35 !important; /* voir la rythmo en fond */
  pointer-events: none !important; /* ne pas capter les clics */
}

/* 2) Audio (2e item) au-dessus, interactif */
.rythmo-tabs-items.audio-mode .v-window-item:nth-child(2) {
  position: relative !important;
  z-index: 2 !important;
  pointer-events: auto !important;
}

/* Tab export opaque */
.rythmo-tabs-items .v-window-item:nth-child(3) {
  background: #1e1e1e !important;
  z-index: 3 !important;
}

.v-window-item {
  padding: 0 !important;
  margin: 0 !important;
}

.v-window__container {
  padding: 0 !important;
  margin: 0 !important;
}

.audio-tab-content {
  padding: 0 !important;
  margin: 0 !important;
  position: relative !important;
  min-height: 600px !important;
}

.rythmo-tabs-items:not(.audio-mode) .audio-tab-content {
  display: none !important;
}

.rythmo-tabs-items.audio-mode .audio-tab-content {
  display: block !important;
}

/* Quand empty state, fond opaque */
.audio-tab-content.is-empty {
  background-color: #1a1a1a !important;
}

/* Quand il y a des sources, fond transparent pour voir le rythmo */
.audio-tab-content.has-sources {
  background-color: transparent !important;
}

/* Conteneur audio transparent pour voir le rythmo en dessous */
#offsetDivAudio {
  background-color: transparent !important;
  pointer-events: auto !important;
  position: relative !important;
  z-index: 10 !important;
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
}

/* Rendre les éléments dans la piste audio légèrement transparents */
.audio-tab-content .waveform-container,
.audio-tab-content wave-surfer {
  opacity: 0.8 !important;
}
// fade transition
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.waveform {
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}
.waveform:hover {
  opacity: 0.5;
  transition: opacity 0.3s ease-in-out;
}
.resize-drag {
  touch-action: none !important;
}
.containerapp {
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
  min-height: 0;
}
.column1 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20%;
  max-width: 80%;
}
.column2 {
  overflow: auto;
  min-width: 20%;
  max-width: 80%;
}

.column3 {
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  margin: 0 !important;
  height: 100% !important;
}

.column3 > .v-col {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 1 auto !important;
  overflow: hidden !important;
  padding: 0 !important;
  margin: 0 !important;
  min-height: 0 !important;
}

.rythmo-band-content {
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 0;
  position: relative;
}

.audio-track-segment:hover .audio-segment-delete {
  opacity: 1 !important;
}

.audio-segment-delete {
  background: rgba(0, 0, 0, 0.6) !important;
  border-radius: 50%;
}

/* Indicateur visuel pendant le redimensionnement */
.resizing .containerapp,
.resizing .rowbottom {
  user-select: none;
  pointer-events: none;
}

.resizing .column1,
.resizing .column2,
.resizing .column3 {
  transition: none !important;
}
.v-menu__content.theme--dark.menuable__content__active {
  z-index: 10000 !important;
}
.v-dialog {
  z-index: 1000 !important;
}
.theme--dark.v-expansion-panels .v-expansion-panel {
  background-color: transparent;
}
.v-expansion-panel::before {
  box-shadow: none;
}
.fixed-bar {
  position: fixed;
  width: auto;
  position: -webkit-sticky;
  /* for Safari */
  // top: 0em;
  z-index: 2;
}
.rythmo-ruban {
  background-image: url("@/assets/background-ticker.png");
  background-repeat: repeat-x;
}

.base-audio-wave {
  width: 100%;
  position: absolute;
  z-index: 100000;
}

.video-subtitles-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
}

.subtitle-content {
  display: inline;
}

.subtitle-underline {
  text-decoration: underline;
  text-decoration-color: #58e279;
  text-decoration-thickness: 2px;
}

.subtitle-dashed {
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-color: #58e279;
  text-decoration-thickness: 2px;
}

/* ===== PANNEAU MODERNE TITRE ET LANGUES ===== */

/* Container principal du panneau */
.project-header-panel {
  background: linear-gradient(
    135deg,
    rgba(30, 30, 30, 0.98) 0%,
    rgba(45, 45, 45, 0.98) 100%
  ) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
  padding: 16px 20px !important;
  margin-bottom: 16px !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
}

/* Section principale (titre + langue) */
.header-main-section {
  display: flex !important;
  align-items: center !important;
  gap: 20px !important;
  margin-bottom: 16px !important;
  flex-wrap: wrap !important;
}

/* Section titre */
.title-section {
  display: flex !important;
  align-items: center !important;
  flex: 1 1 300px !important;
  min-width: 250px !important;
}

.title-icon {
  background: rgba(33, 150, 243, 0.1) !important;
  border-radius: 8px !important;
  padding: 8px !important;
  /* transition: all 0.3s ease !important; */
}

.title-icon:hover {
  background: rgba(33, 150, 243, 0.2) !important;
  transform: scale(1.1) !important;
}

.project-title-field {
  flex: 1 !important;
}

.project-title-field .v-input__control {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  /* transition: all 0.3s ease !important; */
}

.project-title-field .v-input__control:hover {
  border-color: #2196f3 !important;
  background: rgba(255, 255, 255, 0.08) !important;
}

.project-title-field .v-input__slot {
  color: white !important;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
}

/* Section langue */
.language-section {
  display: flex !important;
  align-items: center !important;
  flex: 0 1 280px !important;
  min-width: 250px !important;
}

.language-icon {
  background: rgba(33, 150, 243, 0.1) !important;
  border-radius: 8px !important;
  padding: 8px !important;
  /* transition: all 0.3s ease !important; */
}

.language-icon:hover {
  background: rgba(33, 150, 243, 0.2) !important;
  transform: scale(1.1) !important;
}

.language-select {
  flex: 1 !important;
}

.language-select .v-input__control {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  /* transition: all 0.3s ease !important; */
}

.language-select .v-input__control:hover {
  border-color: #2196f3 !important;
  background: rgba(255, 255, 255, 0.08) !important;
}

.add-language-btn {
  background: rgba(33, 150, 243, 0.1) !important;
  border-radius: 8px !important;
  /* transition: all 0.3s ease !important; */
}

.add-language-btn:hover {
  background: rgba(33, 150, 243, 0.2) !important;
  transform: scale(1.1) !important;
}

/* Menus des langues */
.language-menu {
  background: rgba(30, 30, 30, 0.98) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4) !important;
}

.language-item {
  border-radius: 8px !important;
  margin: 4px 8px !important;
  transition: all 0.2s ease !important;
}

.language-item:hover {
  background: rgba(33, 150, 243, 0.1) !important;
  transform: translateX(4px) !important;
}

.language-name {
  font-weight: 600 !important;
  color: white !important;
}

/* Section des actions */
.header-actions-section {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 16px !important;
  flex-wrap: wrap !important;
}

.action-group {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
}

.action-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
  min-width: 100px !important;
}

.primary-btn {
  background: rgba(33, 150, 243, 0.1) !important;
  border: 1px solid #2196f3 !important;
}

.primary-btn:hover {
  background: rgba(33, 150, 243, 0.2) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3) !important;
}

.secondary-btn {
  background: rgba(255, 152, 0, 0.1) !important;
  border: 1px solid #ff9800 !important;
}

.secondary-btn:hover {
  background: rgba(255, 152, 0, 0.2) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3) !important;
}

.btn-text {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
}

/* Menu des sous-titres */
.subtitle-menu {
  background: rgba(30, 30, 30, 0.98) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4) !important;
}

.subtitle-line-item {
  border-radius: 8px !important;
  margin: 4px 8px !important;
  transition: all 0.2s ease !important;
}

.subtitle-line-item:hover {
  background: rgba(33, 150, 243, 0.1) !important;
  transform: translateX(4px) !important;
}

/* Indicateurs de statut */
.status-indicators {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.status-chip {
  background: rgba(76, 175, 80, 0.1) !important;
  border: 1px solid #4caf50 !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

.status-chip:hover {
  background: rgba(76, 175, 80, 0.2) !important;
  transform: scale(1.05) !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .project-header-panel {
    padding: 12px 16px !important;
    border-radius: 12px !important;
  }

  .header-main-section {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px !important;
  }

  .title-section,
  .language-section {
    flex: 1 1 100% !important;
    min-width: auto !important;
  }

  .header-actions-section {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px !important;
  }

  .action-group {
    justify-content: center !important;
    flex-wrap: wrap !important;
  }

  .action-btn {
    min-width: 80px !important;
    font-size: 0.8rem !important;
  }

  .btn-text {
    display: none !important;
  }
}

/* Animations d'entrée */
@keyframes slideInFromTop {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.project-header-panel {
  animation: slideInFromTop 0.3s ease forwards !important;
}

/* ===== NOUVEAU SYSTÈME D'ENREGISTREMENT INTÉGRÉ ===== */

/* Toolbar d'enregistrement */
.rythmo-toolbar {
  background: linear-gradient(135deg, #1e1e1e 0%, #2d2d2d 100%) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex !important;
  align-items: center !important;
  flex: 0 0 auto !important;
  margin: 0 !important;
  padding: 4px 8px !important;
  min-height: 48px !important;
  max-height: 48px !important;
}

/* Forcer l'alignement vertical des boutons dans la toolbar rythmo */
.rythmo-toolbar .v-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.rythmo-toolbar .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.recording-section {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

/* Status chips */
.recording-status {
  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%) !important;
  color: white !important;
  font-weight: 600;
  animation: pulse-recording 1.5s ease-in-out infinite;
}

.countdown-chip {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%) !important;
  color: white !important;
  font-weight: 700;
  font-size: 1.1em !important;
  animation: countdown-pulse 1s ease-in-out infinite;
}

/* Bouton d'enregistrement principal */
.record-main-btn {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;
}

.record-main-btn:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4) !important;
}

/* Menu d'enregistrement */
.recording-menu {
  background: #1e1e1e !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4) !important;
}

.recording-menu .v-card-title {
  background: linear-gradient(135deg, #2d2d2d 0%, #3d3d3d 100%) !important;
  font-weight: 600;
}

/* Indicateur d'enregistrement dans la bande rythmo */
.recording-indicator-rythmo {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    rgba(244, 67, 54, 0.9) 0%,
    rgba(211, 47, 47, 0.9) 100%
  );
  border-radius: 4px;
  border: 1px solid #ff5252;
  box-shadow: 0 2px 10px rgba(244, 67, 54, 0.4);
}

/* Barre d'enregistrement audio fine qui suit le curseur */
.audio-recording-bar {
  background: linear-gradient(
    to bottom,
    rgba(255, 82, 82, 0.1) 0%,
    rgba(255, 82, 82, 0.2) 50%,
    rgba(255, 82, 82, 0.1) 100%
  );
  box-shadow: 0 0 8px rgba(255, 82, 82, 0.3);
  overflow: hidden;
  z-index: 1000;
  transition: width 0.1s linear;
  border-left: 2px solid rgba(255, 82, 82, 0.8);
  border-right: 1px solid rgba(255, 82, 82, 0.4);
}

.recording-wave-effect {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.3) 50%,
    transparent 100%
  );
  animation: recording-wave 1.5s linear infinite;
}

@keyframes recording-wave {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.recording-pulse {
  position: absolute;
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-radius: 50%;
  left: 8px;
  animation: recording-pulse-dot 1s ease-in-out infinite;
}

.recording-label {
  font-size: 10px;
  font-weight: 700;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-left: 16px;
}

/* Animations */
@keyframes pulse-recording {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.9;
    transform: scale(1.02);
  }
}

@keyframes countdown-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes recording-pulse-dot {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.3);
  }
}

/* Barre de progression d'enregistrement */
.recording-progress-bar {
  position: absolute;
  height: 3px;
  background: linear-gradient(90deg, #ff5252 0%, #ff867f 100%);
  bottom: 0;
  left: 0;
  transition: width 0.1s linear;
  box-shadow: 0 0 10px rgba(255, 82, 82, 0.5);
}

/* Feedback visuel pendant l'enregistrement */
.dialogue-recording {
  position: relative;
  overflow: visible;
}

.dialogue-recording::before {
  content: "";
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  background: linear-gradient(
    135deg,
    rgba(255, 82, 82, 0.3) 0%,
    rgba(255, 134, 127, 0.3) 100%
  );
  border-radius: 8px;
  animation: recording-glow 2s ease-in-out infinite;
  pointer-events: none;
}

/* Style pour les sous-titres actifs pendant l'enregistrement */
.subtitle-recording-active {
  filter: brightness(1.2);
  transform: scale(1.02);
  transition: all 0.3s ease;
}

@keyframes recording-glow {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.02);
  }
}

/* Améliorations visuelles pour l'onglet Audio */
.waveform-container-recording {
  position: relative;
  background: rgba(255, 82, 82, 0.1);
  border: 2px solid #ff5252;
  border-radius: 8px;
  padding: 4px;
  animation: recording-border 1.5s ease-in-out infinite;
}

@keyframes recording-border {
  0%,
  100% {
    border-color: #ff5252;
  }
  50% {
    border-color: #ff867f;
  }
}

/* Quick controls */
.v-btn--text {
  opacity: 0.8;
  transition: all 0.2s ease;
}

.v-btn--text:hover:not(:disabled) {
  opacity: 1;
  background: rgba(255, 255, 255, 0.1) !important;
}

.v-btn--text:disabled {
  opacity: 0.3 !important;
}

/* Responsive */
@media (max-width: 768px) {
  .recording-section {
    padding: 2px 4px;
    gap: 4px;
  }

  .recording-menu {
    width: 100% !important;
    max-width: 300px !important;
  }
}

/* ===== LAYOUT AUDIO AMÉLIORÉ ===== */

/* Conteneur principal de l'onglet Audio */
.audio-tab-content {
  position: relative;
  background: transparent;
}

/* Label des personnages dans l'onglet audio */
.character-label {
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Redesign Onglet Audio */
.audio-editor-container {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.audio-tracks-sidebar {
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.4);
  background-color: #1a1a1a !important;
}

.track-header {
  transition: background-color 0.2s ease;
}

.track-header:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.audio-timeline-scrollable::-webkit-scrollbar {
  height: 10px;
}

.audio-timeline-scrollable {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  background: #121212;
  will-change: scroll-position;
  contain: layout paint; /* Plus sûr que 'strict' sans dimensions fixes forcées */
}

.audio-timeline-scrollable::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 5px;
  border: 2px solid #121212;
}

.audio-timeline-scrollable::-webkit-scrollbar-thumb:hover {
  background: #444;
}

.audio-empty-state {
  height: 100%;
  background: radial-gradient(
    circle at center,
    rgba(255, 255, 255, 0.02) 0%,
    transparent 70%
  );
}

.audio-segment {
  transition: transform 0.1s ease;
  z-index: 30;
  will-change: transform;
}

.waveform {
  will-change: transform;
}

.segment-controls {
  position: absolute;
  top: -20px;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 40;
}

.audio-segment:hover .segment-controls {
  opacity: 1;
}

.delete-segment-btn {
  background: rgba(255, 61, 0, 0.8) !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.audio-recording-bar {
  background: rgba(255, 0, 0, 0.2);
  border-left: 2px solid #ff0000;
}

.recording-wave-effect {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #ff0000;
  box-shadow: 0 0 15px #ff0000;
}

.audio-grid-canvas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.05) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 100% 40px, 100px 100%;
  pointer-events: none;
}

/* Waveform améliorée */
.waveform {
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

/* Session info dans le menu */
.session-info {
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Character selector chip */
.character-selector-chip {
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.character-selector-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Menu paramètres amélioré */
.recording-menu {
  max-height: 80vh;
  overflow-y: auto;
}

.recording-menu .v-slider {
  margin-top: 8px !important;
}

.recording-menu .text-subtitle-2 {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  display: flex;
  align-items: center;
}

/* Amélioration de la lisibilité */
.audio-tab-content .waveform {
  opacity: 0.85;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

/* Séparation visuelle entre les pistes */
#timeline {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

/* Effet de transparence pour voir les sous-titres */
.audio-tab-content {
  pointer-events: auto !important;
}

/* Fix pour s'assurer que le contenu audio est visible */
.audio-tab-content > div {
  opacity: 1 !important;
  visibility: visible !important;
  display: block !important;
}

#offsetDivAudio {
  opacity: 1 !important;
  visibility: visible !important;
  display: block !important;
  position: relative !important;
  z-index: 10 !important;
}

/* Indicateur de personnage en session */
.session-character-indicator {
  background: linear-gradient(
    135deg,
    rgba(33, 150, 243, 0.8) 0%,
    rgba(25, 118, 210, 0.8) 100%
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(33, 150, 243, 0.4);
  animation: session-pulse 2s ease-in-out infinite;
}

@keyframes session-pulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 2px 6px rgba(33, 150, 243, 0.4);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(33, 150, 243, 0.6);
  }
}

/* ===== STYLES POUR LE DIALOGUE DE REMPLACEMENT VIDÉO ===== */

/* Styles pour le dialogue de remplacement vidéo */
.v-stepper__header {
  box-shadow: none !important;
  padding: 20px;
  background: rgba(255, 255, 255, 0.05) !important;
}

.v-stepper__step--active .v-stepper__step__step {
  background-color: var(--v-primary-base) !important;
  color: white !important;
  font-weight: bold !important;
  box-shadow: 0 3px 10px rgba(33, 150, 243, 0.4) !important;
}

.v-stepper__step--complete .v-stepper__step__step {
  background-color: var(--v-success-base) !important;
}

.v-stepper__content {
  padding: 0 !important;
}

.v-alert {
  transition: all 0.3s ease;
}

.v-alert:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

/* Animation du progress circular */
.v-progress-circular {
  animation: rotate-progress 2s linear infinite;
}

@keyframes rotate-progress {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(1.05);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}

/* Chip avec animation */
.v-chip {
  animation: fade-in 0.5s ease;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Transitions fluides entre les étapes */
.v-stepper__wrapper {
  transition: height 0.3s ease !important;
}

/* Boutons avec effet de hover amélioré */
.v-stepper__content .v-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Card title avec gradient */
.v-dialog .v-card-title.primary {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%) !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
}

/* Effet de brillance sur le bouton danger */
.v-btn.error {
  position: relative;
  overflow: hidden;
}

.v-btn.error::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.2) 50%,
    transparent 100%
  );
  transition: left 0.5s ease;
}

.v-btn.error:hover::before {
  left: 100%;
}

/* Animation de succès */
@keyframes success-bounce {
  0%,
  100% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(0.95);
  }
  75% {
    transform: scale(1.05);
  }
}

.v-icon.mdi-check-circle {
  animation: success-bounce 0.6s ease;
}

/* Style pour la checkbox de confirmation */
.v-input--checkbox {
  margin-top: 0 !important;
}

.v-input--checkbox .v-label {
  color: rgba(255, 255, 255, 0.9) !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
}

/* Responsive pour le dialogue */
@media (max-width: 600px) {
  .v-dialog {
    margin: 16px !important;
  }

  .v-stepper__header {
    padding: 12px !important;
  }

  .v-card-text {
    padding: 16px !important;
  }
}

/* ===== NOUVEAU SYSTÈME DE SETTINGS AMÉLIORÉ ===== */

/* Dialog des settings */
.settings-dialog {
  background: #1e1e1e !important;
  border-radius: 20px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6) !important;
  overflow: hidden;
}

.settings-header {
  background: linear-gradient(135deg, #2d2d2d 0%, #3d3d3d 100%) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.home-settings-content {
  background: transparent !important;
  max-height: calc(80vh - 64px - 60px);
  overflow-y: auto;
}

/* Groupes de paramètres */
.setting-group {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.setting-group:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.setting-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.9);
}

/* Preview card */
.preview-card {
  background: linear-gradient(
    135deg,
    rgba(33, 150, 243, 0.1) 0%,
    rgba(21, 101, 192, 0.1) 100%
  );
  border: 1px solid rgba(33, 150, 243, 0.2);
}

.preview-container {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-text {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
}

/* Grille de couleurs */
.color-picker-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.color-option {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.color-option:hover {
  transform: scale(1.1);
  border-color: rgba(255, 255, 255, 0.3);
}

.color-option.active {
  border-color: #2196f3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.3);
}

/* Options de background */
.background-option {
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.02);
  border: 2px solid transparent;
}

.background-option:hover {
  transform: translateY(-4px);
  border-color: rgba(33, 150, 243, 0.3);
}

.background-option.selected {
  border-color: #2196f3;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.2);
}

.background-preview {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(76, 175, 80, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px 8px 0 0;
}

.preview-text-example {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  padding: 4px 12px;
  border-radius: 20px;
  white-space: nowrap;
}

/* Liste des personnages */
.character-list {
  background: transparent !important;
}

.character-item {
  background: rgba(255, 255, 255, 0.02);
  border-radius: 12px;
  margin-bottom: 8px;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.character-item:hover {
  background: rgba(255, 255, 255, 0.05);
  transform: translateX(4px);
}

.character-item.active {
  background: rgba(33, 150, 243, 0.1);
  border-color: rgba(33, 150, 243, 0.3);
}

/* Chips de thèmes */
.v-chip-group .v-chip {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  transition: all 0.2s ease;
}

.v-chip-group .v-chip:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-2px);
}

.v-chip-group .v-chip.v-chip--active {
  background: rgba(33, 150, 243, 0.2) !important;
  border-color: #2196f3 !important;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
}

/* Tooltips */
.v-tooltip__content {
  background: rgba(0, 0, 0, 0.98) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  font-size: 12px;
  padding: 8px 12px;
}

/* Scrollbar personnalisée pour les settings */
.settings-content::-webkit-scrollbar {
  width: 8px;
}

.settings-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.settings-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.settings-content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Correction du scroll pour les tab-items */
.home-settings-content .v-tab-item,
.home-settings-content .scrollable-tab-item {
  max-height: calc(
    80vh - 64px - 60px - 48px
  ); /* Soustrait header, footer et tabs */
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

/* Assurer que le contenu des tabs soit scrollable */
.home-settings-content .v-window__container {
  height: 100%;
}

.home-settings-content .v-window-item {
  height: 100%;
}

.home-settings-content .v-tab-item::-webkit-scrollbar {
  width: 8px;
}

.home-settings-content .v-tab-item::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.home-settings-content .v-tab-item::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.home-settings-content .v-tab-item::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Tab Exporter principal */
.export-tab-item {
  height: calc(
    var(--rythmo-height, 30vh) - 50px
  ); /* hauteur fixe au lieu de max-height */
  min-height: 200px; /* hauteur minimale */
  max-height: 400px; /* hauteur maximale pour éviter trop grand */
  overflow-y: scroll !important; /* force le scroll */
  overflow-x: hidden !important;
  position: relative;
}

.export-tab-item .v-card {
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: visible !important;
}

.export-tab-item .v-card-text {
  flex: 1;
  overflow-y: auto;
  max-height: calc(100% - 100px); /* augmente l'espace réservé aux actions */
  padding-bottom: 10px;
}

.export-tab-item .v-card-actions {
  flex-shrink: 0; /* empêche les actions de se réduire */
  background-color: rgba(
    30,
    30,
    30,
    0.95
  ); /* fond semi-transparent pour mieux voir */
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  position: sticky;
  bottom: 0;
  z-index: 10;
  padding: 16px !important;
}

.export-tab-item::-webkit-scrollbar {
  width: 8px;
}

.export-tab-item::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.export-tab-item::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.export-tab-item::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Animations */
@keyframes setting-slide-in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.setting-group {
  animation: setting-slide-in 0.3s ease-out;
}

/* Responsive */
@media (max-width: 600px) {
  .settings-dialog {
    margin: 0 !important;
    max-width: 100% !important;
    max-height: 100% !important;
    border-radius: 0 !important;
  }

  .setting-group {
    padding: 12px;
    margin-bottom: 12px;
  }

  .color-option {
    width: 36px;
    height: 36px;
  }
}

/* ===== CORRECTIONS D'ALIGNEMENT VERTICAL GLOBAL ===== */

/* Styles globaux pour améliorer l'alignement vertical des boutons */
.v-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
}

.v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
  height: 100% !important;
  line-height: 1 !important;
}

.v-btn .v-icon {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  vertical-align: middle !important;
}

.v-btn span {
  display: inline-flex !important;
  align-items: center !important;
  line-height: 1 !important;
  vertical-align: middle !important;
}

/* S'assurer que les éléments de menu sont bien alignés */
.v-menu__activator {
  display: flex !important;
  align-items: center !important;
}

/* Alignement pour les sections de toolbar personnalisées */
.header-actions-section,
.action-group,
.status-indicators {
  display: flex !important;
  align-items: center !important;
  height: 100%;
}

/* Correction spécifique pour les chips de statut */
.status-chip {
  display: inline-flex !important;
  align-items: center !important;
}

/* Correction pour les boutons avec badges */
.v-btn .v-badge {
  display: inline-flex !important;
  align-items: center !important;
}

/* Alignement vertical pour les v-select dans les toolbars */
.v-toolbar .v-select {
  display: flex !important;
  align-items: center !important;
}

.v-toolbar .v-select .v-input__control {
  display: flex !important;
  align-items: center !important;
}

/* Correction pour les menus déroulants */
.v-menu > .v-menu__activator {
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
}

/* Alignement des éléments dans les barres d'outils */
.v-toolbar__content {
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
}

/* Correction spécifique pour la toolbar de la MenuBar */
.modern-menubar .menubar-toolbar {
  height: 48px !important;
}

.modern-menubar .v-toolbar__content {
  height: 100% !important;
  padding: 0 !important;
}

/* Forcer la taille cohérente des icônes dans les boutons */
.v-btn .v-icon.v-icon--left,
.v-btn .v-icon.v-icon--right {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* Reset des marges par défaut de Vuetify */
.v-btn:not(.v-btn--icon):not(.v-btn--fab) .v-icon--left {
  margin-right: 8px !important;
  margin-left: 0 !important;
}

.v-btn:not(.v-btn--icon):not(.v-btn--fab) .v-icon--right {
  margin-left: 8px !important;
  margin-right: 0 !important;
}

/* Alignement spécifique pour les boutons small */
.v-btn.v-size--small {
  height: 36px !important;
  min-height: 36px !important;
}

.v-btn.v-size--small .v-btn__content {
  padding: 0 12px !important;
}

/* Fix pour les icônes small */
.v-icon.v-size--small {
  font-size: 18px !important;
  height: 18px !important;
  width: 18px !important;
}

/* Reset des styles de texte dans les boutons */
.v-btn__content > span,
.v-btn__content > .v-icon + span {
  line-height: 1 !important;
  font-size: 0.875rem !important;
}

/* ===== STYLES POUR LE MODE DOUBLE BANDE RYTHMO ===== */

/* Container pour le mode double bande */
.double-band-container {
  position: relative;
  width: 100%;
  height: 100%;
}

/* Headers des bandes rythmo */
.rythmo-band-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 28px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  color: white;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  z-index: 1000;
}

.rythmo-band-header.source {
  background: linear-gradient(
    90deg,
    rgba(33, 150, 243, 0.4) 0%,
    rgba(33, 150, 243, 0.2) 50%,
    transparent 100%
  );
  border-bottom: 1px solid rgba(33, 150, 243, 0.3);
}

.rythmo-band-header.target {
  background: linear-gradient(
    90deg,
    rgba(76, 175, 80, 0.4) 0%,
    rgba(76, 175, 80, 0.2) 50%,
    transparent 100%
  );
  border-bottom: 1px solid rgba(76, 175, 80, 0.3);
}

/* Séparateur entre les deux bandes */
.double-band-divider {
  position: absolute;
  width: 100%;
  height: 2px;
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  z-index: 101;
}

/* Animation pour le switch entre modes */
.timeline-cell {
  transition: height 0.3s ease;
}

/* Styles pour les bandes en mode double */
.source-band {
  opacity: 1;
  position: absolute !important;
  overflow: visible;
  box-sizing: border-box;
}

.source-band::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(33, 150, 243, 0.1) 0%,
    rgba(33, 150, 243, 0.05) 100%
  );
  pointer-events: none;
  z-index: -1;
}

.target-band {
  opacity: 1;
  position: absolute !important;
  overflow: visible;
  box-sizing: border-box;
}

.target-band::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(76, 175, 80, 0.1) 0%,
    rgba(76, 175, 80, 0.05) 100%
  );
  pointer-events: none;
  z-index: -1;
}

/* Hover effect sur les bandes */
.source-band:hover,
.target-band:hover {
  opacity: 1;
}

/* Chip de sélection de langues */
.language-selector-chip {
  cursor: pointer;
  transition: all 0.2s ease;
}

.language-selector-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Menu de sélection de langues */
.language-selector-menu .v-card {
  background: rgba(30, 30, 30, 0.98) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Indicateur de mode double bande actif */
.v-btn[color="primary"] .v-icon.mdi-view-split-horizontal {
  animation: pulse-icon 2s ease-in-out infinite;
}

@keyframes pulse-icon {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Responsive pour le mode double bande */
@media (max-width: 600px) {
  .rythmo-band-label {
    font-size: 10px;
  }

  .language-selector-chip {
    font-size: 0.75rem;
  }
}

/* Audio Empty State - Refactorisé */
.audio-empty-state-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 600px;
  background: linear-gradient(
    135deg,
    rgba(20, 20, 30, 0.98) 0%,
    rgba(30, 30, 40, 0.98) 100%
  );
  position: relative;
  z-index: 10;
}

.audio-empty-card {
  max-width: 600px;
  background: linear-gradient(
    135deg,
    rgba(50, 50, 60, 0.98) 0%,
    rgba(70, 70, 80, 0.98) 100%
  ) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.7) !important;
  border: 2px solid rgba(100, 73, 209, 0.4) !important;
}
</style>
